
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5078"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5078"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $b34efa7e825b941c$exports = {};
$parcel$extendImportMap({
    "lRBOd": "Pressuru.684952ea.ttf",
    "hOimC": "Oswald-Regular.89ec7d89.ttf",
    "c5nso": "Oswald-Bold.0f6a7ca6.ttf",
    "917SN": "Roboto-Regular.ca197847.ttf",
    "kCRYk": "Roboto-Bold.fdb9b54a.ttf",
    "7mTjM": "RobotoCondensed-Regular.d585f5c7.ttf",
    "bNJU7": "RobotoCondensed-Bold.e1f96d4b.ttf",
    "2zTNP": "CourierPrime-Regular.3a25a501.ttf",
    "6U5us": "CourierPrime-Bold.3d6bf689.ttf",
    "jadM2": "OpenSans-Regular.edf9e01b.ttf",
    "4rZHV": "OpenSans-Bold.8fceb72b.ttf"
});

function $736431a7b9521865$var$assertNonEmptyString(str) {
    if (typeof str !== 'string' || !str) throw new Error('expected a non-empty string, got: ' + str);
}
function $736431a7b9521865$var$assertNumber(number) {
    if (typeof number !== 'number') throw new Error('expected a number, got: ' + number);
}
const $736431a7b9521865$var$DB_VERSION_CURRENT = 1;
const $736431a7b9521865$var$DB_VERSION_INITIAL = 1;
const $736431a7b9521865$var$STORE_EMOJI = 'emoji';
const $736431a7b9521865$var$STORE_KEYVALUE = 'keyvalue';
const $736431a7b9521865$var$STORE_FAVORITES = 'favorites';
const $736431a7b9521865$var$FIELD_TOKENS = 'tokens';
const $736431a7b9521865$var$INDEX_TOKENS = 'tokens';
const $736431a7b9521865$var$FIELD_UNICODE = 'unicode';
const $736431a7b9521865$var$INDEX_COUNT = 'count';
const $736431a7b9521865$var$FIELD_GROUP = 'group';
const $736431a7b9521865$var$FIELD_ORDER = 'order';
const $736431a7b9521865$var$INDEX_GROUP_AND_ORDER = 'group-order';
const $736431a7b9521865$var$KEY_ETAG = 'eTag';
const $736431a7b9521865$var$KEY_URL = 'url';
const $736431a7b9521865$var$KEY_PREFERRED_SKINTONE = 'skinTone';
const $736431a7b9521865$var$MODE_READONLY = 'readonly';
const $736431a7b9521865$var$MODE_READWRITE = 'readwrite';
const $736431a7b9521865$var$INDEX_SKIN_UNICODE = 'skinUnicodes';
const $736431a7b9521865$var$FIELD_SKIN_UNICODE = 'skinUnicodes';
const $736431a7b9521865$var$DEFAULT_DATA_SOURCE = 'https://cdn.jsdelivr.net/npm/emoji-picker-element-data@^1/en/emojibase/data.json';
const $736431a7b9521865$var$DEFAULT_LOCALE = 'en';
// like lodash's uniqBy but much smaller
function $736431a7b9521865$var$uniqBy(arr, func) {
    const set = new Set();
    const res = [];
    for (const item of arr){
        const key = func(item);
        if (!set.has(key)) {
            set.add(key);
            res.push(item);
        }
    }
    return res;
}
function $736431a7b9521865$var$uniqEmoji(emojis) {
    return $736431a7b9521865$var$uniqBy(emojis, (_)=>_.unicode);
}
function $736431a7b9521865$var$initialMigration(db) {
    function createObjectStore(name, keyPath, indexes) {
        const store = keyPath ? db.createObjectStore(name, {
            keyPath: keyPath
        }) : db.createObjectStore(name);
        if (indexes) for (const [indexName, [keyPath, multiEntry]] of Object.entries(indexes))store.createIndex(indexName, keyPath, {
            multiEntry: multiEntry
        });
        return store;
    }
    createObjectStore($736431a7b9521865$var$STORE_KEYVALUE);
    createObjectStore($736431a7b9521865$var$STORE_EMOJI, /* keyPath */ $736431a7b9521865$var$FIELD_UNICODE, {
        [$736431a7b9521865$var$INDEX_TOKENS]: [
            $736431a7b9521865$var$FIELD_TOKENS,
            /* multiEntry */ true
        ],
        [$736431a7b9521865$var$INDEX_GROUP_AND_ORDER]: [
            [
                $736431a7b9521865$var$FIELD_GROUP,
                $736431a7b9521865$var$FIELD_ORDER
            ]
        ],
        [$736431a7b9521865$var$INDEX_SKIN_UNICODE]: [
            $736431a7b9521865$var$FIELD_SKIN_UNICODE,
            /* multiEntry */ true
        ]
    });
    createObjectStore($736431a7b9521865$var$STORE_FAVORITES, undefined, {
        [$736431a7b9521865$var$INDEX_COUNT]: [
            ''
        ]
    });
}
const $736431a7b9521865$var$openIndexedDBRequests = {};
const $736431a7b9521865$var$databaseCache = {};
const $736431a7b9521865$var$onCloseListeners = {};
function $736431a7b9521865$var$handleOpenOrDeleteReq(resolve, reject, req) {
    // These things are almost impossible to test with fakeIndexedDB sadly
    /* istanbul ignore next */ req.onerror = ()=>reject(req.error);
    /* istanbul ignore next */ req.onblocked = ()=>reject(new Error('IDB blocked'));
    req.onsuccess = ()=>resolve(req.result);
}
async function $736431a7b9521865$var$createDatabase(dbName) {
    const db = await new Promise((resolve, reject)=>{
        const req = indexedDB.open(dbName, $736431a7b9521865$var$DB_VERSION_CURRENT);
        $736431a7b9521865$var$openIndexedDBRequests[dbName] = req;
        req.onupgradeneeded = (e)=>{
            // Technically there is only one version, so we don't need this `if` check
            // But if an old version of the JS is in another browser tab
            // and it gets upgraded in the future and we have a new DB version, well...
            // better safe than sorry.
            /* istanbul ignore else */ if (e.oldVersion < $736431a7b9521865$var$DB_VERSION_INITIAL) $736431a7b9521865$var$initialMigration(req.result);
        };
        $736431a7b9521865$var$handleOpenOrDeleteReq(resolve, reject, req);
    });
    // Handle abnormal closes, e.g. "delete database" in chrome dev tools.
    // No need for removeEventListener, because once the DB can no longer
    // fire "close" events, it will auto-GC.
    // Unfortunately cannot test in fakeIndexedDB: https://github.com/dumbmatter/fakeIndexedDB/issues/50
    /* istanbul ignore next */ db.onclose = ()=>$736431a7b9521865$var$closeDatabase(dbName);
    return db;
}
function $736431a7b9521865$var$openDatabase(dbName) {
    if (!$736431a7b9521865$var$databaseCache[dbName]) $736431a7b9521865$var$databaseCache[dbName] = $736431a7b9521865$var$createDatabase(dbName);
    return $736431a7b9521865$var$databaseCache[dbName];
}
function $736431a7b9521865$var$dbPromise(db, storeName, readOnlyOrReadWrite, cb) {
    return new Promise((resolve, reject)=>{
        // Use relaxed durability because neither the emoji data nor the favorites/preferred skin tone
        // are really irreplaceable data. IndexedDB is just a cache in this case.
        const txn = db.transaction(storeName, readOnlyOrReadWrite, {
            durability: 'relaxed'
        });
        const store = typeof storeName === 'string' ? txn.objectStore(storeName) : storeName.map((name)=>txn.objectStore(name));
        let res;
        cb(store, txn, (result)=>{
            res = result;
        });
        txn.oncomplete = ()=>resolve(res);
        /* istanbul ignore next */ txn.onerror = ()=>reject(txn.error);
    });
}
function $736431a7b9521865$var$closeDatabase(dbName) {
    // close any open requests
    const req = $736431a7b9521865$var$openIndexedDBRequests[dbName];
    const db = req && req.result;
    if (db) {
        db.close();
        const listeners = $736431a7b9521865$var$onCloseListeners[dbName];
        /* istanbul ignore else */ if (listeners) for (const listener of listeners)listener();
    }
    delete $736431a7b9521865$var$openIndexedDBRequests[dbName];
    delete $736431a7b9521865$var$databaseCache[dbName];
    delete $736431a7b9521865$var$onCloseListeners[dbName];
}
function $736431a7b9521865$var$deleteDatabase(dbName) {
    return new Promise((resolve, reject)=>{
        // close any open requests
        $736431a7b9521865$var$closeDatabase(dbName);
        const req = indexedDB.deleteDatabase(dbName);
        $736431a7b9521865$var$handleOpenOrDeleteReq(resolve, reject, req);
    });
}
// The "close" event occurs during an abnormal shutdown, e.g. a user clearing their browser data.
// However, it doesn't occur with the normal "close" event, so we handle that separately.
// https://www.w3.org/TR/IndexedDB/#close-a-database-connection
function $736431a7b9521865$var$addOnCloseListener(dbName, listener) {
    let listeners = $736431a7b9521865$var$onCloseListeners[dbName];
    if (!listeners) listeners = $736431a7b9521865$var$onCloseListeners[dbName] = [];
    listeners.push(listener);
}
// list of emoticons that don't match a simple \W+ regex
// extracted using:
// require('emoji-picker-element-data/en/emojibase/data.json').map(_ => _.emoticon).filter(Boolean).filter(_ => !/^\W+$/.test(_))
const $736431a7b9521865$var$irregularEmoticons = new Set([
    ':D',
    'XD',
    ":'D",
    'O:)',
    ':X',
    ':P',
    ';P',
    'XP',
    ':L',
    ':Z',
    ':j',
    '8D',
    'XO',
    '8)',
    ':B',
    ':O',
    ':S',
    ":'o",
    'Dx',
    'X(',
    'D:',
    ':C',
    '>0)',
    ':3',
    '</3',
    '<3',
    '\\M/',
    ':E',
    '8#'
]);
function $736431a7b9521865$var$extractTokens(str) {
    return str.split(/[\s_]+/).map((word)=>{
        if (!word.match(/\w/) || $736431a7b9521865$var$irregularEmoticons.has(word)) // for pure emoticons like :) or :-), just leave them as-is
        return word.toLowerCase();
        return word.replace(/[)(:,]/g, '').replace(/’/g, "'").toLowerCase();
    }).filter(Boolean);
}
const $736431a7b9521865$var$MIN_SEARCH_TEXT_LENGTH = 2;
// This is an extra step in addition to extractTokens(). The difference here is that we expect
// the input to have already been run through extractTokens(). This is useful for cases like
// emoticons, where we don't want to do any tokenization (because it makes no sense to split up
// ">:)" by the colon) but we do want to lowercase it to have consistent search results, so that
// the user can type ':P' or ':p' and still get the same result.
function $736431a7b9521865$var$normalizeTokens(str) {
    return str.filter(Boolean).map((_)=>_.toLowerCase()).filter((_)=>_.length >= $736431a7b9521865$var$MIN_SEARCH_TEXT_LENGTH);
}
// Transform emoji data for storage in IDB
function $736431a7b9521865$var$transformEmojiData(emojiData) {
    const res = emojiData.map(({ annotation: annotation, emoticon: emoticon, group: group, order: order, shortcodes: shortcodes, skins: skins, tags: tags, emoji: emoji, version: version })=>{
        const tokens = [
            ...new Set($736431a7b9521865$var$normalizeTokens([
                ...(shortcodes || []).map($736431a7b9521865$var$extractTokens).flat(),
                ...(tags || []).map($736431a7b9521865$var$extractTokens).flat(),
                ...$736431a7b9521865$var$extractTokens(annotation),
                emoticon
            ]))
        ].sort();
        const res = {
            annotation: annotation,
            group: group,
            order: order,
            tags: tags,
            tokens: tokens,
            unicode: emoji,
            version: version
        };
        if (emoticon) res.emoticon = emoticon;
        if (shortcodes) res.shortcodes = shortcodes;
        if (skins) {
            res.skinTones = [];
            res.skinUnicodes = [];
            res.skinVersions = [];
            for (const { tone: tone, emoji: emoji, version: version } of skins){
                res.skinTones.push(tone);
                res.skinUnicodes.push(emoji);
                res.skinVersions.push(version);
            }
        }
        return res;
    });
    return res;
}
// helper functions that help compress the code better
function $736431a7b9521865$var$callStore(store, method, key, cb) {
    store[method](key).onsuccess = (e)=>cb && cb(e.target.result);
}
function $736431a7b9521865$var$getIDB(store, key, cb) {
    $736431a7b9521865$var$callStore(store, 'get', key, cb);
}
function $736431a7b9521865$var$getAllIDB(store, key, cb) {
    $736431a7b9521865$var$callStore(store, 'getAll', key, cb);
}
function $736431a7b9521865$var$commit(txn) {
    /* istanbul ignore else */ if (txn.commit) txn.commit();
}
// like lodash's minBy
function $736431a7b9521865$var$minBy(array, func) {
    let minItem = array[0];
    for(let i = 1; i < array.length; i++){
        const item = array[i];
        if (func(minItem) > func(item)) minItem = item;
    }
    return minItem;
}
// return an array of results representing all items that are found in each one of the arrays
//
function $736431a7b9521865$var$findCommonMembers(arrays, uniqByFunc) {
    const shortestArray = $736431a7b9521865$var$minBy(arrays, (_)=>_.length);
    const results = [];
    for (const item of shortestArray)// if this item is included in every array in the intermediate results, add it to the final results
    if (!arrays.some((array)=>array.findIndex((_)=>uniqByFunc(_) === uniqByFunc(item)) === -1)) results.push(item);
    return results;
}
async function $736431a7b9521865$var$isEmpty(db) {
    return !await $736431a7b9521865$var$get(db, $736431a7b9521865$var$STORE_KEYVALUE, $736431a7b9521865$var$KEY_URL);
}
async function $736431a7b9521865$var$hasData(db, url, eTag) {
    const [oldETag, oldUrl] = await Promise.all([
        $736431a7b9521865$var$KEY_ETAG,
        $736431a7b9521865$var$KEY_URL
    ].map((key)=>$736431a7b9521865$var$get(db, $736431a7b9521865$var$STORE_KEYVALUE, key)));
    return oldETag === eTag && oldUrl === url;
}
async function $736431a7b9521865$var$doFullDatabaseScanForSingleResult(db, predicate) {
    // This batching algorithm is just a perf improvement over a basic
    // cursor. The BATCH_SIZE is an estimate of what would give the best
    // perf for doing a full DB scan (worst case).
    //
    // Mini-benchmark for determining the best batch size:
    //
    // PERF=1 pnpm build:rollup && pnpm test:adhoc
    //
    // (async () => {
    //   performance.mark('start')
    //   await $('emoji-picker').database.getEmojiByShortcode('doesnotexist')
    //   performance.measure('total', 'start')
    //   console.log(performance.getEntriesByName('total').slice(-1)[0].duration)
    // })()
    const BATCH_SIZE = 50; // Typically around 150ms for 6x slowdown in Chrome for above benchmark
    return $736431a7b9521865$var$dbPromise(db, $736431a7b9521865$var$STORE_EMOJI, $736431a7b9521865$var$MODE_READONLY, (emojiStore, txn, cb)=>{
        let lastKey;
        const processNextBatch = ()=>{
            emojiStore.getAll(lastKey && IDBKeyRange.lowerBound(lastKey, true), BATCH_SIZE).onsuccess = (e)=>{
                const results = e.target.result;
                for (const result of results){
                    lastKey = result.unicode;
                    if (predicate(result)) return cb(result);
                }
                if (results.length < BATCH_SIZE) return cb();
                processNextBatch();
            };
        };
        processNextBatch();
    });
}
async function $736431a7b9521865$var$loadData(db, emojiData, url, eTag) {
    {
        const transformedData = $736431a7b9521865$var$transformEmojiData(emojiData);
        await $736431a7b9521865$var$dbPromise(db, [
            $736431a7b9521865$var$STORE_EMOJI,
            $736431a7b9521865$var$STORE_KEYVALUE
        ], $736431a7b9521865$var$MODE_READWRITE, ([emojiStore, metaStore], txn)=>{
            let oldETag;
            let oldUrl;
            let todo = 0;
            function checkFetched() {
                if (++todo === 2) onFetched();
            }
            function onFetched() {
                if (oldETag === eTag && oldUrl === url) // check again within the transaction to guard against concurrency, e.g. multiple browser tabs
                return;
                // delete old data
                emojiStore.clear();
                // insert new data
                for (const data of transformedData)emojiStore.put(data);
                metaStore.put(eTag, $736431a7b9521865$var$KEY_ETAG);
                metaStore.put(url, $736431a7b9521865$var$KEY_URL);
                $736431a7b9521865$var$commit(txn);
            }
            $736431a7b9521865$var$getIDB(metaStore, $736431a7b9521865$var$KEY_ETAG, (result)=>{
                oldETag = result;
                checkFetched();
            });
            $736431a7b9521865$var$getIDB(metaStore, $736431a7b9521865$var$KEY_URL, (result)=>{
                oldUrl = result;
                checkFetched();
            });
        });
    }
}
async function $736431a7b9521865$var$getEmojiByGroup(db, group) {
    return $736431a7b9521865$var$dbPromise(db, $736431a7b9521865$var$STORE_EMOJI, $736431a7b9521865$var$MODE_READONLY, (emojiStore, txn, cb)=>{
        const range = IDBKeyRange.bound([
            group,
            0
        ], [
            group + 1,
            0
        ], false, true);
        $736431a7b9521865$var$getAllIDB(emojiStore.index($736431a7b9521865$var$INDEX_GROUP_AND_ORDER), range, cb);
    });
}
async function $736431a7b9521865$var$getEmojiBySearchQuery(db, query) {
    const tokens = $736431a7b9521865$var$normalizeTokens($736431a7b9521865$var$extractTokens(query));
    if (!tokens.length) return [];
    return $736431a7b9521865$var$dbPromise(db, $736431a7b9521865$var$STORE_EMOJI, $736431a7b9521865$var$MODE_READONLY, (emojiStore, txn, cb)=>{
        // get all results that contain all tokens (i.e. an AND query)
        const intermediateResults = [];
        const checkDone = ()=>{
            if (intermediateResults.length === tokens.length) onDone();
        };
        const onDone = ()=>{
            const results = $736431a7b9521865$var$findCommonMembers(intermediateResults, (_)=>_.unicode);
            cb(results.sort((a, b)=>a.order < b.order ? -1 : 1));
        };
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            const range = i === tokens.length - 1 ? IDBKeyRange.bound(token, token + '\uffff', false, true) // treat last token as a prefix search
             : IDBKeyRange.only(token); // treat all other tokens as an exact match
            $736431a7b9521865$var$getAllIDB(emojiStore.index($736431a7b9521865$var$INDEX_TOKENS), range, (result)=>{
                intermediateResults.push(result);
                checkDone();
            });
        }
    });
}
// This could have been implemented as an IDB index on shortcodes, but it seemed wasteful to do that
// when we can already query by tokens and this will give us what we're looking for 99.9% of the time
async function $736431a7b9521865$var$getEmojiByShortcode(db, shortcode) {
    const emojis = await $736431a7b9521865$var$getEmojiBySearchQuery(db, shortcode);
    // In very rare cases (e.g. the shortcode "v" as in "v for victory"), we cannot search because
    // there are no usable tokens (too short in this case). In that case, we have to do an inefficient
    // full-database scan, which I believe is an acceptable tradeoff for not having to have an extra
    // index on shortcodes.
    if (!emojis.length) {
        const predicate = (_)=>(_.shortcodes || []).includes(shortcode.toLowerCase());
        return await $736431a7b9521865$var$doFullDatabaseScanForSingleResult(db, predicate) || null;
    }
    return emojis.filter((_)=>{
        const lowerShortcodes = (_.shortcodes || []).map((_)=>_.toLowerCase());
        return lowerShortcodes.includes(shortcode.toLowerCase());
    })[0] || null;
}
async function $736431a7b9521865$var$getEmojiByUnicode(db, unicode) {
    return $736431a7b9521865$var$dbPromise(db, $736431a7b9521865$var$STORE_EMOJI, $736431a7b9521865$var$MODE_READONLY, (emojiStore, txn, cb)=>$736431a7b9521865$var$getIDB(emojiStore, unicode, (result)=>{
            if (result) return cb(result);
            $736431a7b9521865$var$getIDB(emojiStore.index($736431a7b9521865$var$INDEX_SKIN_UNICODE), unicode, (result)=>cb(result || null));
        }));
}
function $736431a7b9521865$var$get(db, storeName, key) {
    return $736431a7b9521865$var$dbPromise(db, storeName, $736431a7b9521865$var$MODE_READONLY, (store, txn, cb)=>$736431a7b9521865$var$getIDB(store, key, cb));
}
function $736431a7b9521865$var$set(db, storeName, key, value) {
    return $736431a7b9521865$var$dbPromise(db, storeName, $736431a7b9521865$var$MODE_READWRITE, (store, txn)=>{
        store.put(value, key);
        $736431a7b9521865$var$commit(txn);
    });
}
function $736431a7b9521865$var$incrementFavoriteEmojiCount(db, unicode) {
    return $736431a7b9521865$var$dbPromise(db, $736431a7b9521865$var$STORE_FAVORITES, $736431a7b9521865$var$MODE_READWRITE, (store, txn)=>$736431a7b9521865$var$getIDB(store, unicode, (result)=>{
            store.put((result || 0) + 1, unicode);
            $736431a7b9521865$var$commit(txn);
        }));
}
function $736431a7b9521865$var$getTopFavoriteEmoji(db, customEmojiIndex, limit) {
    if (limit === 0) return [];
    return $736431a7b9521865$var$dbPromise(db, [
        $736431a7b9521865$var$STORE_FAVORITES,
        $736431a7b9521865$var$STORE_EMOJI
    ], $736431a7b9521865$var$MODE_READONLY, ([favoritesStore, emojiStore], txn, cb)=>{
        const results = [];
        favoritesStore.index($736431a7b9521865$var$INDEX_COUNT).openCursor(undefined, 'prev').onsuccess = (e)=>{
            const cursor = e.target.result;
            if (!cursor) return cb(results);
            function addResult(result) {
                results.push(result);
                if (results.length === limit) return cb(results) // done, reached the limit
                ;
                cursor.continue();
            }
            const unicodeOrName = cursor.primaryKey;
            const custom = customEmojiIndex.byName(unicodeOrName);
            if (custom) return addResult(custom);
            // This could be done in parallel (i.e. make the cursor and the get()s parallelized),
            // but my testing suggests it's not actually faster.
            $736431a7b9521865$var$getIDB(emojiStore, unicodeOrName, (emoji)=>{
                if (emoji) return addResult(emoji);
                // emoji not found somehow, ignore (may happen if custom emoji change)
                cursor.continue();
            });
        };
    });
}
// trie data structure for prefix searches
// loosely based on https://github.com/nolanlawson/substring-trie
const $736431a7b9521865$var$CODA_MARKER = ''; // marks the end of the string
function $736431a7b9521865$var$trie(arr, itemToTokens) {
    const map = new Map();
    for (const item of arr){
        const tokens = itemToTokens(item);
        for (const token of tokens){
            let currentMap = map;
            for(let i = 0; i < token.length; i++){
                const char = token.charAt(i);
                let nextMap = currentMap.get(char);
                if (!nextMap) {
                    nextMap = new Map();
                    currentMap.set(char, nextMap);
                }
                currentMap = nextMap;
            }
            let valuesAtCoda = currentMap.get($736431a7b9521865$var$CODA_MARKER);
            if (!valuesAtCoda) {
                valuesAtCoda = [];
                currentMap.set($736431a7b9521865$var$CODA_MARKER, valuesAtCoda);
            }
            valuesAtCoda.push(item);
        }
    }
    const search = (query, exact)=>{
        let currentMap = map;
        for(let i = 0; i < query.length; i++){
            const char = query.charAt(i);
            const nextMap = currentMap.get(char);
            if (nextMap) currentMap = nextMap;
            else return [];
        }
        if (exact) {
            const results = currentMap.get($736431a7b9521865$var$CODA_MARKER);
            return results || [];
        }
        const results = [];
        // traverse
        const queue = [
            currentMap
        ];
        while(queue.length){
            const currentMap = queue.shift();
            const entriesSortedByKey = [
                ...currentMap.entries()
            ].sort((a, b)=>a[0] < b[0] ? -1 : 1);
            for (const [key, value] of entriesSortedByKey)if (key === $736431a7b9521865$var$CODA_MARKER) results.push(...value);
            else queue.push(value);
        }
        return results;
    };
    return search;
}
const $736431a7b9521865$var$requiredKeys$1 = [
    'name',
    'url'
];
function $736431a7b9521865$var$assertCustomEmojis(customEmojis) {
    const isArray = customEmojis && Array.isArray(customEmojis);
    const firstItemIsFaulty = isArray && customEmojis.length && (!customEmojis[0] || $736431a7b9521865$var$requiredKeys$1.some((key)=>!(key in customEmojis[0])));
    if (!isArray || firstItemIsFaulty) throw new Error('Custom emojis are in the wrong format');
}
function $736431a7b9521865$var$customEmojiIndex(customEmojis) {
    $736431a7b9521865$var$assertCustomEmojis(customEmojis);
    const sortByName = (a, b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
    //
    // all()
    //
    const all = customEmojis.sort(sortByName);
    //
    // search()
    //
    const emojiToTokens = (emoji)=>{
        const set = new Set();
        if (emoji.shortcodes) {
            for (const shortcode of emoji.shortcodes)for (const token of $736431a7b9521865$var$extractTokens(shortcode))set.add(token);
        }
        return set;
    };
    const searchTrie = $736431a7b9521865$var$trie(customEmojis, emojiToTokens);
    const searchByExactMatch = (_)=>searchTrie(_, true);
    const searchByPrefix = (_)=>searchTrie(_, false);
    // Search by query for custom emoji. Similar to how we do this in IDB, the last token
    // is treated as a prefix search, but every other one is treated as an exact match.
    // Then we AND the results together
    const search = (query)=>{
        const tokens = $736431a7b9521865$var$extractTokens(query);
        const intermediateResults = tokens.map((token, i)=>(i < tokens.length - 1 ? searchByExactMatch : searchByPrefix)(token));
        return $736431a7b9521865$var$findCommonMembers(intermediateResults, (_)=>_.name).sort(sortByName);
    };
    //
    // byShortcode, byName
    //
    const shortcodeToEmoji = new Map();
    const nameToEmoji = new Map();
    for (const customEmoji of customEmojis){
        nameToEmoji.set(customEmoji.name.toLowerCase(), customEmoji);
        for (const shortcode of customEmoji.shortcodes || [])shortcodeToEmoji.set(shortcode.toLowerCase(), customEmoji);
    }
    const byShortcode = (shortcode)=>shortcodeToEmoji.get(shortcode.toLowerCase());
    const byName = (name)=>nameToEmoji.get(name.toLowerCase());
    return {
        all: all,
        search: search,
        byShortcode: byShortcode,
        byName: byName
    };
}
const $736431a7b9521865$var$isFirefoxContentScript = typeof wrappedJSObject !== 'undefined';
// remove some internal implementation details, i.e. the "tokens" array on the emoji object
// essentially, convert the emoji from the version stored in IDB to the version used in-memory
function $736431a7b9521865$var$cleanEmoji(emoji) {
    if (!emoji) return emoji;
    // if inside a Firefox content script, need to clone the emoji object to prevent Firefox from complaining about
    // cross-origin object. See: https://github.com/nolanlawson/emoji-picker-element/issues/356
    /* istanbul ignore if */ if ($736431a7b9521865$var$isFirefoxContentScript) emoji = structuredClone(emoji);
    delete emoji.tokens;
    if (emoji.skinTones) {
        const len = emoji.skinTones.length;
        emoji.skins = Array(len);
        for(let i = 0; i < len; i++)emoji.skins[i] = {
            tone: emoji.skinTones[i],
            unicode: emoji.skinUnicodes[i],
            version: emoji.skinVersions[i]
        };
        delete emoji.skinTones;
        delete emoji.skinUnicodes;
        delete emoji.skinVersions;
    }
    return emoji;
}
function $736431a7b9521865$var$warnETag(eTag) {
    if (!eTag) console.warn('emoji-picker-element is more efficient if the dataSource server exposes an ETag header.');
}
const $736431a7b9521865$var$requiredKeys = [
    'annotation',
    'emoji',
    'group',
    'order',
    'version'
];
function $736431a7b9521865$var$assertEmojiData(emojiData) {
    if (!emojiData || !Array.isArray(emojiData) || !emojiData[0] || typeof emojiData[0] !== 'object' || $736431a7b9521865$var$requiredKeys.some((key)=>!(key in emojiData[0]))) throw new Error('Emoji data is in the wrong format');
}
function $736431a7b9521865$var$assertStatus(response, dataSource) {
    if (Math.floor(response.status / 100) !== 2) throw new Error('Failed to fetch: ' + dataSource + ':  ' + response.status);
}
async function $736431a7b9521865$var$getETag(dataSource) {
    const response = await fetch(dataSource, {
        method: 'HEAD'
    });
    $736431a7b9521865$var$assertStatus(response, dataSource);
    const eTag = response.headers.get('etag');
    $736431a7b9521865$var$warnETag(eTag);
    return eTag;
}
async function $736431a7b9521865$var$getETagAndData(dataSource) {
    const response = await fetch(dataSource);
    $736431a7b9521865$var$assertStatus(response, dataSource);
    const eTag = response.headers.get('etag');
    $736431a7b9521865$var$warnETag(eTag);
    const emojiData = await response.json();
    $736431a7b9521865$var$assertEmojiData(emojiData);
    return [
        eTag,
        emojiData
    ];
}
// TODO: including these in blob-util.ts causes typedoc to generate docs for them,
// even with --excludePrivate ¯\_(ツ)_/¯
/** @private */ /**
 * Convert an `ArrayBuffer` to a binary string.
 *
 * Example:
 *
 * ```js
 * var myString = blobUtil.arrayBufferToBinaryString(arrayBuff)
 * ```
 *
 * @param buffer - array buffer
 * @returns binary string
 */ function $736431a7b9521865$var$arrayBufferToBinaryString(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var length = bytes.byteLength;
    var i = -1;
    while(++i < length)binary += String.fromCharCode(bytes[i]);
    return binary;
}
/**
 * Convert a binary string to an `ArrayBuffer`.
 *
 * ```js
 * var myBuffer = blobUtil.binaryStringToArrayBuffer(binaryString)
 * ```
 *
 * @param binary - binary string
 * @returns array buffer
 */ function $736431a7b9521865$var$binaryStringToArrayBuffer(binary) {
    var length = binary.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    var i = -1;
    while(++i < length)arr[i] = binary.charCodeAt(i);
    return buf;
}
// generate a checksum based on the stringified JSON
async function $736431a7b9521865$var$jsonChecksum(object) {
    const inString = JSON.stringify(object);
    let inBuffer = $736431a7b9521865$var$binaryStringToArrayBuffer(inString);
    // this does not need to be cryptographically secure, SHA-1 is fine
    const outBuffer = await crypto.subtle.digest('SHA-1', inBuffer);
    const outBinString = $736431a7b9521865$var$arrayBufferToBinaryString(outBuffer);
    const res = btoa(outBinString);
    return res;
}
async function $736431a7b9521865$var$doCheckForUpdates(db, dataSource) {
    // just do a simple HEAD request first to see if the eTags match
    let emojiData;
    let eTag = await $736431a7b9521865$var$getETag(dataSource);
    if (!eTag) {
        const eTagAndData = await $736431a7b9521865$var$getETagAndData(dataSource);
        eTag = eTagAndData[0];
        emojiData = eTagAndData[1];
        if (!eTag) eTag = await $736431a7b9521865$var$jsonChecksum(emojiData);
    }
    if (await $736431a7b9521865$var$hasData(db, dataSource, eTag)) ;
    else {
        if (!emojiData) {
            const eTagAndData = await $736431a7b9521865$var$getETagAndData(dataSource);
            emojiData = eTagAndData[1];
        }
        await $736431a7b9521865$var$loadData(db, emojiData, dataSource, eTag);
    }
}
async function $736431a7b9521865$var$loadDataForFirstTime(db, dataSource) {
    let [eTag, emojiData] = await $736431a7b9521865$var$getETagAndData(dataSource);
    if (!eTag) // Handle lack of support for ETag or Access-Control-Expose-Headers
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Access-Control-Expose-Headers#Browser_compatibility
    eTag = await $736431a7b9521865$var$jsonChecksum(emojiData);
    await $736431a7b9521865$var$loadData(db, emojiData, dataSource, eTag);
}
async function $736431a7b9521865$var$checkForUpdates(db, dataSource) {
    try {
        await $736431a7b9521865$var$doCheckForUpdates(db, dataSource);
    } catch (err) {
        // Checking for updates is not a critical operation, and it can fail if e.g. the picker is quickly removed and
        // re-added to the DOM. In those cases, we may get an IndexedDB InvalidStateError because we are attempting to close
        // the database connection, possibly while another request is inflight. So there's effectively no way to prevent
        // InvalidStateErrors unless we were to carefully sequence our IndexedDB operations. Much more simply, we can just
        // ignore IndexedDB InvalidStateErrors here and give users one less useless error message in their console.
        if (err.name !== 'InvalidStateError') throw err;
    }
}
class $736431a7b9521865$export$2e2bcd8739ae039 {
    constructor({ dataSource: dataSource = $736431a7b9521865$var$DEFAULT_DATA_SOURCE, locale: locale = $736431a7b9521865$var$DEFAULT_LOCALE, customEmoji: customEmoji = [] } = {}){
        this.dataSource = dataSource;
        this.locale = locale;
        this._dbName = `emoji-picker-element-${this.locale}`;
        this._db = undefined;
        this._lazyUpdate = undefined;
        this._custom = $736431a7b9521865$var$customEmojiIndex(customEmoji);
        this._clear = this._clear.bind(this);
        this._ready = this._init();
    }
    async _init() {
        const db = this._db = await $736431a7b9521865$var$openDatabase(this._dbName);
        $736431a7b9521865$var$addOnCloseListener(this._dbName, this._clear);
        const dataSource = this.dataSource;
        const empty = await $736431a7b9521865$var$isEmpty(db);
        if (empty) await $736431a7b9521865$var$loadDataForFirstTime(db, dataSource);
        else this._lazyUpdate = $736431a7b9521865$var$checkForUpdates(db, dataSource);
    }
    async ready() {
        const checkReady = async ()=>{
            if (!this._ready) this._ready = this._init();
            return this._ready;
        };
        await checkReady();
        // There's a possibility of a race condition where the element gets added, removed, and then added again
        // with a particular timing, which would set the _db to undefined.
        // We *could* do a while loop here, but that seems excessive and could lead to an infinite loop.
        if (!this._db) await checkReady();
    }
    async getEmojiByGroup(group) {
        $736431a7b9521865$var$assertNumber(group);
        await this.ready();
        return $736431a7b9521865$var$uniqEmoji(await $736431a7b9521865$var$getEmojiByGroup(this._db, group)).map($736431a7b9521865$var$cleanEmoji);
    }
    async getEmojiBySearchQuery(query) {
        $736431a7b9521865$var$assertNonEmptyString(query);
        await this.ready();
        const customs = this._custom.search(query);
        const natives = $736431a7b9521865$var$uniqEmoji(await $736431a7b9521865$var$getEmojiBySearchQuery(this._db, query)).map($736431a7b9521865$var$cleanEmoji);
        return [
            ...customs,
            ...natives
        ];
    }
    async getEmojiByShortcode(shortcode) {
        $736431a7b9521865$var$assertNonEmptyString(shortcode);
        await this.ready();
        const custom = this._custom.byShortcode(shortcode);
        if (custom) return custom;
        return $736431a7b9521865$var$cleanEmoji(await $736431a7b9521865$var$getEmojiByShortcode(this._db, shortcode));
    }
    async getEmojiByUnicodeOrName(unicodeOrName) {
        $736431a7b9521865$var$assertNonEmptyString(unicodeOrName);
        await this.ready();
        const custom = this._custom.byName(unicodeOrName);
        if (custom) return custom;
        return $736431a7b9521865$var$cleanEmoji(await $736431a7b9521865$var$getEmojiByUnicode(this._db, unicodeOrName));
    }
    async getPreferredSkinTone() {
        await this.ready();
        return await $736431a7b9521865$var$get(this._db, $736431a7b9521865$var$STORE_KEYVALUE, $736431a7b9521865$var$KEY_PREFERRED_SKINTONE) || 0;
    }
    async setPreferredSkinTone(skinTone) {
        $736431a7b9521865$var$assertNumber(skinTone);
        await this.ready();
        return $736431a7b9521865$var$set(this._db, $736431a7b9521865$var$STORE_KEYVALUE, $736431a7b9521865$var$KEY_PREFERRED_SKINTONE, skinTone);
    }
    async incrementFavoriteEmojiCount(unicodeOrName) {
        $736431a7b9521865$var$assertNonEmptyString(unicodeOrName);
        await this.ready();
        return $736431a7b9521865$var$incrementFavoriteEmojiCount(this._db, unicodeOrName);
    }
    async getTopFavoriteEmoji(limit) {
        $736431a7b9521865$var$assertNumber(limit);
        await this.ready();
        return (await $736431a7b9521865$var$getTopFavoriteEmoji(this._db, this._custom, limit)).map($736431a7b9521865$var$cleanEmoji);
    }
    set customEmoji(customEmojis) {
        this._custom = $736431a7b9521865$var$customEmojiIndex(customEmojis);
    }
    get customEmoji() {
        return this._custom.all;
    }
    async _shutdown() {
        await this.ready(); // reopen if we've already been closed/deleted
        try {
            await this._lazyUpdate; // allow any lazy updates to process before closing/deleting
        } catch (err) {}
    }
    // clear references to IDB, e.g. during a close event
    _clear() {
        // We don't need to call removeEventListener or remove the manual "close" listeners.
        // The memory leak tests prove this is unnecessary. It's because:
        // 1) IDBDatabases that can no longer fire "close" automatically have listeners GCed
        // 2) we clear the manual close listeners in databaseLifecycle.js.
        this._db = this._ready = this._lazyUpdate = undefined;
    }
    async close() {
        await this._shutdown();
        await $736431a7b9521865$var$closeDatabase(this._dbName);
    }
    async delete() {
        await this._shutdown();
        await $736431a7b9521865$var$deleteDatabase(this._dbName);
    }
}


// via https://unpkg.com/browse/emojibase-data@6.0.0/meta/groups.json
const $9e9d3488b14d9168$var$allGroups = [
    [
        -1,
        "\u2728",
        'custom'
    ],
    [
        0,
        "\uD83D\uDE00",
        'smileys-emotion'
    ],
    [
        1,
        "\uD83D\uDC4B",
        'people-body'
    ],
    [
        3,
        "\uD83D\uDC31",
        'animals-nature'
    ],
    [
        4,
        "\uD83C\uDF4E",
        'food-drink'
    ],
    [
        5,
        "\uD83C\uDFE0\uFE0F",
        'travel-places'
    ],
    [
        6,
        "\u26BD",
        'activities'
    ],
    [
        7,
        "\uD83D\uDCDD",
        'objects'
    ],
    [
        8,
        "\u26D4\uFE0F",
        'symbols'
    ],
    [
        9,
        "\uD83C\uDFC1",
        'flags'
    ]
].map(([id, emoji, name])=>({
        id: id,
        emoji: emoji,
        name: name
    }));
const $9e9d3488b14d9168$var$groups = $9e9d3488b14d9168$var$allGroups.slice(1);
const $9e9d3488b14d9168$var$MIN_SEARCH_TEXT_LENGTH = 2;
const $9e9d3488b14d9168$var$NUM_SKIN_TONES = 6;
/* istanbul ignore next */ const $9e9d3488b14d9168$var$rIC = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;
// check for ZWJ (zero width joiner) character
function $9e9d3488b14d9168$var$hasZwj(emoji) {
    return emoji.unicode.includes('\u200d');
}
// Find one good representative emoji from each version to test by checking its color.
// Ideally it should have color in the center. For some inspiration, see:
// https://about.gitlab.com/blog/2018/05/30/journey-in-native-unicode-emoji/
//
// Note that for certain versions (12.1, 13.1), there is no point in testing them explicitly, because
// all the emoji from this version are compound-emoji from previous versions. So they would pass a color
// test, even in browsers that display them as double emoji. (E.g. "face in clouds" might render as
// "face without mouth" plus "fog".) These emoji can only be filtered using the width test,
// which happens in checkZwjSupport.js.
const $9e9d3488b14d9168$var$versionsAndTestEmoji = {
    "\uD83E\uDEE9": 16,
    "\uD83E\uDEE8": 15.1,
    "\uD83E\uDEE0": 14,
    "\uD83E\uDD72": 13.1,
    "\uD83E\uDD7B": 12.1,
    "\uD83E\uDD70": 11,
    "\uD83E\uDD29": 5,
    "\uD83D\uDC71\u200D\u2640\uFE0F": 4,
    "\uD83E\uDD23": 3,
    "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F": 2,
    "\uD83D\uDE00": 1,
    "\uD83D\uDE10\uFE0F": 0.7,
    "\uD83D\uDE03": 0.6
};
const $9e9d3488b14d9168$var$TIMEOUT_BEFORE_LOADING_MESSAGE = 1000; // 1 second
const $9e9d3488b14d9168$var$DEFAULT_SKIN_TONE_EMOJI = "\uD83D\uDD90\uFE0F";
const $9e9d3488b14d9168$var$DEFAULT_NUM_COLUMNS = 8;
// Based on https://fivethirtyeight.com/features/the-100-most-used-emojis/ and
// https://blog.emojipedia.org/facebook-reveals-most-and-least-used-emojis/ with
// a bit of my own curation. (E.g. avoid the "OK" gesture because of connotations:
// https://emojipedia.org/ok-hand/)
const $9e9d3488b14d9168$var$MOST_COMMONLY_USED_EMOJI = [
    "\uD83D\uDE0A",
    "\uD83D\uDE12",
    "\u2764\uFE0F",
    "\uD83D\uDC4D\uFE0F",
    "\uD83D\uDE0D",
    "\uD83D\uDE02",
    "\uD83D\uDE2D",
    "\u263A\uFE0F",
    "\uD83D\uDE14",
    "\uD83D\uDE29",
    "\uD83D\uDE0F",
    "\uD83D\uDC95",
    "\uD83D\uDE4C",
    "\uD83D\uDE18"
];
// It's important to list Twemoji Mozilla before everything else, because Mozilla bundles their
// own font on some platforms (notably Windows and Linux as of this writing). Typically, Mozilla
// updates faster than the underlying OS, and we don't want to render older emoji in one font and
// newer emoji in another font:
// https://github.com/nolanlawson/emoji-picker-element/pull/268#issuecomment-1073347283
const $9e9d3488b14d9168$var$FONT_FAMILY = '"Twemoji Mozilla","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji","EmojiOne Color","Android Emoji",sans-serif';
/* istanbul ignore next */ const $9e9d3488b14d9168$var$DEFAULT_CATEGORY_SORTING = (a, b)=>a < b ? -1 : a > b ? 1 : 0;
// Test if an emoji is supported by rendering it to canvas and checking that the color is not black
// See https://about.gitlab.com/blog/2018/05/30/journey-in-native-unicode-emoji/
// and https://www.npmjs.com/package/if-emoji for inspiration
// This implementation is largely borrowed from if-emoji, adding the font-family
const $9e9d3488b14d9168$var$getTextFeature = (text, color)=>{
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = 1;
    const ctx = canvas.getContext('2d', {
        // Improves the performance of `getImageData()`
        // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/getContextAttributes#willreadfrequently
        willReadFrequently: true
    });
    ctx.textBaseline = 'top';
    ctx.font = `100px ${$9e9d3488b14d9168$var$FONT_FAMILY}`;
    ctx.fillStyle = color;
    ctx.scale(0.01, 0.01);
    ctx.fillText(text, 0, 0);
    return ctx.getImageData(0, 0, 1, 1).data;
};
const $9e9d3488b14d9168$var$compareFeatures = (feature1, feature2)=>{
    const feature1Str = [
        ...feature1
    ].join(',');
    const feature2Str = [
        ...feature2
    ].join(',');
    // This is RGBA, so for 0,0,0, we are checking that the first RGB is not all zeroes.
    // Most of the time when unsupported this is 0,0,0,0, but on Chrome on Mac it is
    // 0,0,0,61 - there is a transparency here.
    return feature1Str === feature2Str && !feature1Str.startsWith('0,0,0,');
};
function $9e9d3488b14d9168$var$testColorEmojiSupported(text) {
    // Render white and black and then compare them to each other and ensure they're the same
    // color, and neither one is black. This shows that the emoji was rendered in color.
    const feature1 = $9e9d3488b14d9168$var$getTextFeature(text, '#000');
    const feature2 = $9e9d3488b14d9168$var$getTextFeature(text, '#fff');
    return feature1 && feature2 && $9e9d3488b14d9168$var$compareFeatures(feature1, feature2);
}
// rather than check every emoji ever, which would be expensive, just check some representatives from the
// different emoji releases to determine what the font supports
function $9e9d3488b14d9168$var$determineEmojiSupportLevel() {
    const entries = Object.entries($9e9d3488b14d9168$var$versionsAndTestEmoji);
    try {
        // start with latest emoji and work backwards
        for (const [emoji, version] of entries){
            if ($9e9d3488b14d9168$var$testColorEmojiSupported(emoji)) return version;
        }
    } catch (e) {} finally{}
    // In case of an error, be generous and just assume all emoji are supported (e.g. for canvas errors
    // due to anti-fingerprinting add-ons). Better to show some gray boxes than nothing at all.
    return entries[0][1] // first one in the list is the most recent version
    ;
}
// Check which emojis we know for sure aren't supported, based on Unicode version level
let $9e9d3488b14d9168$var$promise;
const $9e9d3488b14d9168$var$detectEmojiSupportLevel = ()=>{
    if (!$9e9d3488b14d9168$var$promise) // Delay so it can run while the IDB database is being created by the browser (on another thread).
    // This helps especially with first load – we want to start pre-populating the database on the main thread,
    // and then wait for IDB to commit everything, and while waiting we run this check.
    $9e9d3488b14d9168$var$promise = new Promise((resolve)=>$9e9d3488b14d9168$var$rIC(()=>resolve($9e9d3488b14d9168$var$determineEmojiSupportLevel()) // delay so ideally this can run while IDB is first populating
        ));
    return $9e9d3488b14d9168$var$promise;
};
// determine which emojis containing ZWJ (zero width joiner) characters
// are supported (rendered as one glyph) rather than unsupported (rendered as two or more glyphs)
const $9e9d3488b14d9168$var$supportedZwjEmojis = new Map();
const $9e9d3488b14d9168$var$VARIATION_SELECTOR = '\ufe0f';
const $9e9d3488b14d9168$var$SKINTONE_MODIFIER = '\ud83c';
const $9e9d3488b14d9168$var$ZWJ = '\u200d';
const $9e9d3488b14d9168$var$LIGHT_SKIN_TONE = 0x1F3FB;
const $9e9d3488b14d9168$var$LIGHT_SKIN_TONE_MODIFIER = 0xdffb;
// TODO: this is a naive implementation, we can improve it later
// It's only used for the skintone picker, so as long as people don't customize with
// really exotic emoji then it should work fine
function $9e9d3488b14d9168$var$applySkinTone(str, skinTone) {
    if (skinTone === 0) return str;
    const zwjIndex = str.indexOf($9e9d3488b14d9168$var$ZWJ);
    if (zwjIndex !== -1) return str.substring(0, zwjIndex) + String.fromCodePoint($9e9d3488b14d9168$var$LIGHT_SKIN_TONE + skinTone - 1) + str.substring(zwjIndex);
    if (str.endsWith($9e9d3488b14d9168$var$VARIATION_SELECTOR)) str = str.substring(0, str.length - 1);
    return str + $9e9d3488b14d9168$var$SKINTONE_MODIFIER + String.fromCodePoint($9e9d3488b14d9168$var$LIGHT_SKIN_TONE_MODIFIER + skinTone - 1);
}
function $9e9d3488b14d9168$var$halt(event) {
    event.preventDefault();
    event.stopPropagation();
}
// Implementation left/right or up/down navigation, circling back when you
// reach the start/end of the list
function $9e9d3488b14d9168$var$incrementOrDecrement(decrement, val, arr) {
    val += decrement ? -1 : 1;
    if (val < 0) val = arr.length - 1;
    else if (val >= arr.length) val = 0;
    return val;
}
// like lodash's uniqBy but much smaller
function $9e9d3488b14d9168$var$uniqBy(arr, func) {
    const set = new Set();
    const res = [];
    for (const item of arr){
        const key = func(item);
        if (!set.has(key)) {
            set.add(key);
            res.push(item);
        }
    }
    return res;
}
// We don't need all the data on every emoji, and there are specific things we need
// for the UI, so build a "view model" from the emoji object we got from the database
function $9e9d3488b14d9168$var$summarizeEmojisForUI(emojis, emojiSupportLevel) {
    const toSimpleSkinsMap = (skins)=>{
        const res = {};
        for (const skin of skins)// ignore arrays like [1, 2] with multiple skin tones
        // also ignore variants that are in an unsupported emoji version
        // (these do exist - variants from a different version than their base emoji)
        if (typeof skin.tone === 'number' && skin.version <= emojiSupportLevel) res[skin.tone] = skin.unicode;
        return res;
    };
    return emojis.map(({ unicode: unicode, skins: skins, shortcodes: shortcodes, url: url, name: name, category: category, annotation: annotation })=>({
            unicode: unicode,
            name: name,
            shortcodes: shortcodes,
            url: url,
            category: category,
            annotation: annotation,
            id: unicode || name,
            skins: skins && toSimpleSkinsMap(skins)
        }));
}
// import rAF from one place so that the bundle size is a bit smaller
const $9e9d3488b14d9168$var$rAF = requestAnimationFrame;
// "Svelte action"-like utility to detect layout changes via ResizeObserver.
// If ResizeObserver is unsupported, we just use rAF once and don't bother to update.
let $9e9d3488b14d9168$var$resizeObserverSupported = typeof ResizeObserver === 'function';
function $9e9d3488b14d9168$var$resizeObserverAction(node, abortSignal, onUpdate) {
    let resizeObserver;
    if ($9e9d3488b14d9168$var$resizeObserverSupported) {
        resizeObserver = new ResizeObserver(onUpdate);
        resizeObserver.observe(node);
    } else $9e9d3488b14d9168$var$rAF(onUpdate);
    // cleanup function (called on destroy)
    abortSignal.addEventListener('abort', ()=>{
        if (resizeObserver) resizeObserver.disconnect();
    });
}
// get the width of the text inside of a DOM node, via https://stackoverflow.com/a/59525891/680742
function $9e9d3488b14d9168$var$calculateTextWidth(node) {
    // skip running this in jest/vitest because we don't need to check for emoji support in that environment
    /* istanbul ignore else */ {
        const range = document.createRange();
        range.selectNode(node.firstChild);
        return range.getBoundingClientRect().width;
    }
}
let $9e9d3488b14d9168$var$baselineEmojiWidth;
/**
 * Check if the given emojis containing ZWJ characters are supported by the current browser (don't render
 * as double characters) and return true if all are supported.
 * @param zwjEmojisToCheck
 * @param baselineEmoji
 * @param emojiToDomNode
 */ function $9e9d3488b14d9168$var$checkZwjSupport(zwjEmojisToCheck, baselineEmoji, emojiToDomNode) {
    let allSupported = true;
    for (const emoji of zwjEmojisToCheck){
        const domNode = emojiToDomNode(emoji);
        // sanity check to make sure the node is defined properly
        /* istanbul ignore if */ if (!domNode) continue;
        const emojiWidth = $9e9d3488b14d9168$var$calculateTextWidth(domNode);
        if (typeof $9e9d3488b14d9168$var$baselineEmojiWidth === 'undefined') $9e9d3488b14d9168$var$baselineEmojiWidth = $9e9d3488b14d9168$var$calculateTextWidth(baselineEmoji);
        // On Windows, some supported emoji are ~50% bigger than the baseline emoji, but what we really want to guard
        // against are the ones that are 2x the size, because those are truly broken (person with red hair = person with
        // floating red wig, black cat = cat with black square, polar bear = bear with snowflake, etc.)
        // So here we set the threshold at 1.8 times the size of the baseline emoji.
        const supported = emojiWidth / 1.8 < $9e9d3488b14d9168$var$baselineEmojiWidth;
        $9e9d3488b14d9168$var$supportedZwjEmojis.set(emoji.unicode, supported);
        if (!supported) allSupported = false;
    }
    return allSupported;
}
// like lodash's uniq
function $9e9d3488b14d9168$var$uniq(arr) {
    return $9e9d3488b14d9168$var$uniqBy(arr, (_)=>_);
}
// Note we put this in its own function outside Picker.js to avoid Svelte doing an invalidation on the "setter" here.
// At best the invalidation is useless, at worst it can cause infinite loops:
// https://github.com/nolanlawson/emoji-picker-element/pull/180
// https://github.com/sveltejs/svelte/issues/6521
// Also note tabpanelElement can be null if the element is disconnected immediately after connected
function $9e9d3488b14d9168$var$resetScrollTopIfPossible(element) {
    /* istanbul ignore else */ if (element) element.scrollTop = 0;
}
function $9e9d3488b14d9168$var$getFromMap(cache, key, func) {
    let cached = cache.get(key);
    if (!cached) {
        cached = func();
        cache.set(key, cached);
    }
    return cached;
}
function $9e9d3488b14d9168$var$toString(value) {
    return '' + value;
}
function $9e9d3488b14d9168$var$parseTemplate(htmlString) {
    const template = document.createElement('template');
    template.innerHTML = htmlString;
    return template;
}
const $9e9d3488b14d9168$var$parseCache = new WeakMap();
const $9e9d3488b14d9168$var$domInstancesCache = new WeakMap();
// This needs to be a symbol because it needs to be different from any possible output of a key function
const $9e9d3488b14d9168$var$unkeyedSymbol = Symbol('un-keyed');
// Not supported in Safari <=13
const $9e9d3488b14d9168$var$hasReplaceChildren = 'replaceChildren' in Element.prototype;
function $9e9d3488b14d9168$var$replaceChildren(parentNode, newChildren) {
    /* istanbul ignore else */ if ($9e9d3488b14d9168$var$hasReplaceChildren) parentNode.replaceChildren(...newChildren);
    else {
        parentNode.innerHTML = '';
        parentNode.append(...newChildren);
    }
}
function $9e9d3488b14d9168$var$doChildrenNeedRerender(parentNode, newChildren) {
    let oldChild = parentNode.firstChild;
    let oldChildrenCount = 0;
    // iterate using firstChild/nextSibling because browsers use a linked list under the hood
    while(oldChild){
        const newChild = newChildren[oldChildrenCount];
        // check if the old child and new child are the same
        if (newChild !== oldChild) return true;
        oldChild = oldChild.nextSibling;
        oldChildrenCount++;
    }
    // if new children length is different from old, we must re-render
    return oldChildrenCount !== newChildren.length;
}
function $9e9d3488b14d9168$var$patchChildren(newChildren, instanceBinding) {
    const { targetNode: targetNode } = instanceBinding;
    let { targetParentNode: targetParentNode } = instanceBinding;
    let needsRerender = false;
    if (targetParentNode) needsRerender = $9e9d3488b14d9168$var$doChildrenNeedRerender(targetParentNode, newChildren);
    else {
        needsRerender = true;
        instanceBinding.targetNode = undefined; // placeholder node not needed anymore, free memory
        instanceBinding.targetParentNode = targetParentNode = targetNode.parentNode;
    }
    // avoid re-rendering list if the dom nodes are exactly the same before and after
    if (needsRerender) $9e9d3488b14d9168$var$replaceChildren(targetParentNode, newChildren);
}
function $9e9d3488b14d9168$var$patch(expressions, instanceBindings) {
    for (const instanceBinding of instanceBindings){
        const { targetNode: targetNode, currentExpression: currentExpression, binding: { expressionIndex: expressionIndex, attributeName: attributeName, attributeValuePre: attributeValuePre, attributeValuePost: attributeValuePost } } = instanceBinding;
        const expression = expressions[expressionIndex];
        if (currentExpression === expression) continue;
        instanceBinding.currentExpression = expression;
        if (attributeName) {
            if (expression === null) // null is treated as a special case by the framework - we don't render an attribute at all in this case
            targetNode.removeAttribute(attributeName);
            else {
                // attribute value is not null; set a new attribute
                const newValue = attributeValuePre + $9e9d3488b14d9168$var$toString(expression) + attributeValuePost;
                targetNode.setAttribute(attributeName, newValue);
            }
        } else {
            let newNode;
            if (Array.isArray(expression)) $9e9d3488b14d9168$var$patchChildren(expression, instanceBinding);
            else if (expression instanceof Element) {
                newNode = expression;
                targetNode.replaceWith(newNode);
            } else // nodeValue is faster than textContent supposedly https://www.youtube.com/watch?v=LY6y3HbDVmg
            // note we may be replacing the value in a placeholder text node
            targetNode.nodeValue = $9e9d3488b14d9168$var$toString(expression);
            if (newNode) instanceBinding.targetNode = newNode;
        }
    }
}
function $9e9d3488b14d9168$var$parse(tokens) {
    let htmlString = '';
    let withinTag = false;
    let withinAttribute = false;
    let elementIndexCounter = -1; // depth-first traversal order
    const elementsToBindings = new Map();
    const elementIndexes = [];
    let skipTokenChars = 0;
    for(let i = 0, len = tokens.length; i < len; i++){
        const token = tokens[i];
        htmlString += token.slice(skipTokenChars);
        if (i === len - 1) break; // no need to process characters - no more expressions to be found
        for(let j = 0; j < token.length; j++){
            const char = token.charAt(j);
            switch(char){
                case '<':
                    {
                        const nextChar = token.charAt(j + 1);
                        if (nextChar === '/') // leaving an element
                        elementIndexes.pop();
                        else {
                            withinTag = true;
                            elementIndexes.push(++elementIndexCounter);
                        }
                        break;
                    }
                case '>':
                    withinTag = false;
                    withinAttribute = false;
                    break;
                case '=':
                    withinAttribute = true;
                    break;
            }
        }
        const elementIndex = elementIndexes[elementIndexes.length - 1];
        const bindings = $9e9d3488b14d9168$var$getFromMap(elementsToBindings, elementIndex, ()=>[]);
        let attributeName;
        let attributeValuePre;
        let attributeValuePost;
        if (withinAttribute) {
            // I never use single-quotes for attribute values in HTML, so just support double-quotes or no-quotes
            const attributePreMatch = /(\S+)="?([^"=]*)$/.exec(token);
            attributeName = attributePreMatch[1];
            attributeValuePre = attributePreMatch[2];
            const attributePostMatch = /^([^">]*)("?)/.exec(tokens[i + 1]);
            attributeValuePost = attributePostMatch[1];
            // Optimization: remove the attribute itself, so we don't create a default attribute which is either empty or just
            // the "pre" text, e.g. `<div foo>` or `<div foo="prefix">`. It will be replaced by the expression anyway.
            htmlString = htmlString.slice(0, -1 * attributePreMatch[0].length);
            skipTokenChars = attributePostMatch[0].length;
        } else skipTokenChars = 0;
        const binding = {
            attributeName: attributeName,
            attributeValuePre: attributeValuePre,
            attributeValuePost: attributeValuePost,
            expressionIndex: i
        };
        bindings.push(binding);
        if (!withinTag && !withinAttribute) // Add a placeholder text node, so we can find it later. Note we only support one dynamic child text node
        htmlString += ' ';
    }
    const template = $9e9d3488b14d9168$var$parseTemplate(htmlString);
    return {
        template: template,
        elementsToBindings: elementsToBindings
    };
}
function $9e9d3488b14d9168$var$applyBindings(bindings, element, instanceBindings) {
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        const targetNode = binding.attributeName ? element // attribute binding, just use the element itself
         : element.firstChild; // not an attribute binding, so has a placeholder text node
        const instanceBinding = {
            binding: binding,
            targetNode: targetNode,
            targetParentNode: undefined,
            currentExpression: undefined
        };
        instanceBindings.push(instanceBinding);
    }
}
function $9e9d3488b14d9168$var$traverseAndSetupBindings(rootElement, elementsToBindings) {
    const instanceBindings = [];
    let topLevelBindings;
    if (elementsToBindings.size === 1 && (topLevelBindings = elementsToBindings.get(0))) // Optimization for the common case where there's only one element and one binding
    // Skip creating a TreeWalker entirely and just handle the root DOM element
    $9e9d3488b14d9168$var$applyBindings(topLevelBindings, rootElement, instanceBindings);
    else {
        // traverse dom
        const treeWalker = document.createTreeWalker(rootElement, NodeFilter.SHOW_ELEMENT);
        let element = rootElement;
        let elementIndex = -1;
        do {
            const bindings = elementsToBindings.get(++elementIndex);
            if (bindings) $9e9d3488b14d9168$var$applyBindings(bindings, element, instanceBindings);
        }while (element = treeWalker.nextNode());
    }
    return instanceBindings;
}
function $9e9d3488b14d9168$var$parseHtml(tokens) {
    // All templates and bound expressions are unique per tokens array
    const { template: template, elementsToBindings: elementsToBindings } = $9e9d3488b14d9168$var$getFromMap($9e9d3488b14d9168$var$parseCache, tokens, ()=>$9e9d3488b14d9168$var$parse(tokens));
    // When we parseHtml, we always return a fresh DOM instance ready to be updated
    const dom = template.cloneNode(true).content.firstElementChild;
    const instanceBindings = $9e9d3488b14d9168$var$traverseAndSetupBindings(dom, elementsToBindings);
    return function updateDomInstance(expressions) {
        $9e9d3488b14d9168$var$patch(expressions, instanceBindings);
        return dom;
    };
}
function $9e9d3488b14d9168$var$createFramework(state) {
    const domInstances = $9e9d3488b14d9168$var$getFromMap($9e9d3488b14d9168$var$domInstancesCache, state, ()=>new Map());
    let domInstanceCacheKey = $9e9d3488b14d9168$var$unkeyedSymbol;
    function html(tokens, ...expressions) {
        // Each unique lexical usage of map() is considered unique due to the html`` tagged template call it makes,
        // which has lexically unique tokens. The unkeyed symbol is just used for html`` usage outside of a map().
        const domInstancesForTokens = $9e9d3488b14d9168$var$getFromMap(domInstances, tokens, ()=>new Map());
        const updateDomInstance = $9e9d3488b14d9168$var$getFromMap(domInstancesForTokens, domInstanceCacheKey, ()=>$9e9d3488b14d9168$var$parseHtml(tokens));
        return updateDomInstance(expressions) // update with expressions
        ;
    }
    function map(array, callback, keyFunction) {
        return array.map((item, index)=>{
            const originalCacheKey = domInstanceCacheKey;
            domInstanceCacheKey = keyFunction(item);
            try {
                return callback(item, index);
            } finally{
                domInstanceCacheKey = originalCacheKey;
            }
        });
    }
    return {
        map: map,
        html: html
    };
}
function $9e9d3488b14d9168$var$render(container, state, helpers, events, actions, refs, abortSignal, actionContext, firstRender) {
    const { labelWithSkin: labelWithSkin, titleForEmoji: titleForEmoji, unicodeWithSkin: unicodeWithSkin } = helpers;
    const { html: html, map: map } = $9e9d3488b14d9168$var$createFramework(state);
    function emojiList(emojis, searchMode, prefix) {
        return map(emojis, (emoji, i)=>{
            return html`<button role="${searchMode ? 'option' : 'menuitem'}" aria-selected="${searchMode ? i === state.activeSearchItem : null}" aria-label="${labelWithSkin(emoji, state.currentSkinTone)}" title="${titleForEmoji(emoji)}" class="${'emoji' + (searchMode && i === state.activeSearchItem ? ' active' : '') + (emoji.unicode ? '' : ' custom-emoji')}" id="${`${prefix}-${emoji.id}`}" style="${emoji.unicode ? null : `--custom-emoji-background: url(${JSON.stringify(emoji.url)})`}">${emoji.unicode ? unicodeWithSkin(emoji, state.currentSkinTone) : ''}</button>`;
        // It's important for the cache key to be unique based on the prefix, because the framework caches based on the
        // unique tokens + cache key, and the same emoji may be used in the tab as well as in the fav bar
        }, (emoji)=>`${prefix}-${emoji.id}`);
    }
    const section = ()=>{
        return html`<section data-ref="rootElement" class="picker" aria-label="${state.i18n.regionLabel}" style="${state.pickerStyle || ''}"><div class="pad-top"></div><div class="search-row"><div class="search-wrapper"><input id="search" class="search" type="search" role="combobox" enterkeyhint="search" placeholder="${state.i18n.searchLabel}" autocapitalize="none" autocomplete="off" spellcheck="true" aria-expanded="${!!(state.searchMode && state.currentEmojis.length)}" aria-controls="search-results" aria-describedby="search-description" aria-autocomplete="list" aria-activedescendant="${state.activeSearchItemId ? `emo-${state.activeSearchItemId}` : null}" data-ref="searchElement" data-on-input="onSearchInput" data-on-keydown="onSearchKeydown"><label class="sr-only" for="search">${state.i18n.searchLabel}</label> <span id="search-description" class="sr-only">${state.i18n.searchDescription}</span></div><div class="skintone-button-wrapper ${state.skinTonePickerExpandedAfterAnimation ? 'expanded' : ''}"><button id="skintone-button" class="emoji ${state.skinTonePickerExpanded ? 'hide-focus' : ''}" aria-label="${state.skinToneButtonLabel}" title="${state.skinToneButtonLabel}" aria-describedby="skintone-description" aria-haspopup="listbox" aria-expanded="${state.skinTonePickerExpanded}" aria-controls="skintone-list" data-on-click="onClickSkinToneButton">${state.skinToneButtonText || ''}</button></div><span id="skintone-description" class="sr-only">${state.i18n.skinToneDescription}</span><div data-ref="skinToneDropdown" id="skintone-list" class="skintone-list hide-focus ${state.skinTonePickerExpanded ? '' : 'hidden no-animate'}" style="transform:translateY(${state.skinTonePickerExpanded ? 0 : 'calc(-1 * var(--num-skintones) * var(--total-emoji-size))'})" role="listbox" aria-label="${state.i18n.skinTonesLabel}" aria-activedescendant="skintone-${state.activeSkinTone}" aria-hidden="${!state.skinTonePickerExpanded}" tabIndex="-1" data-on-focusout="onSkinToneOptionsFocusOut" data-on-click="onSkinToneOptionsClick" data-on-keydown="onSkinToneOptionsKeydown" data-on-keyup="onSkinToneOptionsKeyup">${map(state.skinTones, (skinTone, i)=>{
            return html`<div id="skintone-${i}" class="emoji ${i === state.activeSkinTone ? 'active' : ''}" aria-selected="${i === state.activeSkinTone}" role="option" title="${state.i18n.skinTones[i]}" aria-label="${state.i18n.skinTones[i]}">${skinTone}</div>`;
        }, (skinTone)=>skinTone)}</div></div><div class="nav" role="tablist" style="grid-template-columns:repeat(${state.groups.length},1fr)" aria-label="${state.i18n.categoriesLabel}" data-on-keydown="onNavKeydown" data-on-click="onNavClick">${map(state.groups, (group)=>{
            return html`<button role="tab" class="nav-button" aria-controls="tab-${group.id}" aria-label="${state.i18n.categories[group.name]}" aria-selected="${!state.searchMode && state.currentGroup.id === group.id}" title="${state.i18n.categories[group.name]}" data-group-id="${group.id}"><div class="nav-emoji emoji">${group.emoji}</div></button>`;
        }, (group)=>group.id)}</div><div class="indicator-wrapper"><div class="indicator" style="transform:translateX(${/* istanbul ignore next */ (state.isRtl ? -1 : 1) * state.currentGroupIndex * 100}%)"></div></div><div class="message ${state.message ? '' : 'gone'}" role="alert" aria-live="polite">${state.message || ''}</div><div data-ref="tabpanelElement" class="tabpanel ${!state.databaseLoaded || state.message ? 'gone' : ''}" role="${state.searchMode ? 'region' : 'tabpanel'}" aria-label="${state.searchMode ? state.i18n.searchResultsLabel : state.i18n.categories[state.currentGroup.name]}" id="${state.searchMode ? null : `tab-${state.currentGroup.id}`}" tabIndex="0" data-on-click="onEmojiClick"><div data-action="calculateEmojiGridStyle">${map(state.currentEmojisWithCategories, (emojiWithCategory, i)=>{
            return html`<div><div id="menu-label-${i}" class="category ${state.currentEmojisWithCategories.length === 1 && state.currentEmojisWithCategories[0].category === '' ? 'gone' : ''}" aria-hidden="true">${state.searchMode ? state.i18n.searchResultsLabel : emojiWithCategory.category ? emojiWithCategory.category : state.currentEmojisWithCategories.length > 1 ? state.i18n.categories.custom : state.i18n.categories[state.currentGroup.name]}</div><div class="emoji-menu ${i !== 0 && !state.searchMode && state.currentGroup.id === -1 ? 'visibility-auto' : ''}" style="${`--num-rows: ${Math.ceil(emojiWithCategory.emojis.length / state.numColumns)}`}" data-action="updateOnIntersection" role="${state.searchMode ? 'listbox' : 'menu'}" aria-labelledby="menu-label-${i}" id="${state.searchMode ? 'search-results' : null}">${emojiList(emojiWithCategory.emojis, state.searchMode, /* prefix */ 'emo')}</div></div>`;
        }, (emojiWithCategory)=>emojiWithCategory.category)}</div></div><div class="favorites onscreen emoji-menu ${state.message ? 'gone' : ''}" role="menu" aria-label="${state.i18n.favoritesLabel}" data-on-click="onEmojiClick">${emojiList(state.currentFavorites, /* searchMode */ false, /* prefix */ 'fav')}</div><button data-ref="baselineEmoji" aria-hidden="true" tabindex="-1" class="abs-pos hidden emoji baseline-emoji">😀</button></section>`;
    };
    const rootDom = section();
    // helper for traversing the dom, finding elements by an attribute, and getting the attribute value
    const forElementWithAttribute = (attributeName, callback)=>{
        for (const element of container.querySelectorAll(`[${attributeName}]`))callback(element, element.getAttribute(attributeName));
    };
    if (firstRender) {
        container.appendChild(rootDom);
        // we only bind events/refs once - there is no need to find them again given this component structure
        // bind events
        for (const eventName of [
            'click',
            'focusout',
            'input',
            'keydown',
            'keyup'
        ])forElementWithAttribute(`data-on-${eventName}`, (element, listenerName)=>{
            element.addEventListener(eventName, events[listenerName]);
        });
        // find refs
        forElementWithAttribute('data-ref', (element, ref)=>{
            refs[ref] = element;
        });
        // destroy/abort logic
        abortSignal.addEventListener('abort', ()=>{
            container.removeChild(rootDom);
        });
    }
    // set up actions - these are re-bound on every render
    forElementWithAttribute('data-action', (element, action)=>{
        let boundActions = actionContext.get(action);
        if (!boundActions) actionContext.set(action, boundActions = new WeakSet());
        // avoid applying the same action to the same element multiple times
        if (!boundActions.has(element)) {
            boundActions.add(element);
            actions[action](element);
        }
    });
}
/* istanbul ignore next */ const $9e9d3488b14d9168$var$qM = typeof queueMicrotask === 'function' ? queueMicrotask : (callback)=>Promise.resolve().then(callback);
function $9e9d3488b14d9168$var$createState(abortSignal) {
    let destroyed = false;
    let currentObserver;
    const propsToObservers = new Map();
    const dirtyObservers = new Set();
    let queued;
    const flush = ()=>{
        if (destroyed) return;
        const observersToRun = [
            ...dirtyObservers
        ];
        dirtyObservers.clear(); // clear before running to force any new updates to run in another tick of the loop
        try {
            for (const observer of observersToRun)observer();
        } finally{
            queued = false;
            if (dirtyObservers.size) {
                queued = true;
                $9e9d3488b14d9168$var$qM(flush);
            }
        }
    };
    const state = new Proxy({}, {
        get (target, prop) {
            if (currentObserver) {
                let observers = propsToObservers.get(prop);
                if (!observers) {
                    observers = new Set();
                    propsToObservers.set(prop, observers);
                }
                observers.add(currentObserver);
            }
            return target[prop];
        },
        set (target, prop, newValue) {
            if (target[prop] !== newValue) {
                target[prop] = newValue;
                const observers = propsToObservers.get(prop);
                if (observers) {
                    for (const observer of observers)dirtyObservers.add(observer);
                    if (!queued) {
                        queued = true;
                        $9e9d3488b14d9168$var$qM(flush);
                    }
                }
            }
            return true;
        }
    });
    const createEffect = (callback)=>{
        const runnable = ()=>{
            const oldObserver = currentObserver;
            currentObserver = runnable;
            try {
                return callback();
            } finally{
                currentObserver = oldObserver;
            }
        };
        return runnable();
    };
    // destroy logic
    abortSignal.addEventListener('abort', ()=>{
        destroyed = true;
    });
    return {
        state: state,
        createEffect: createEffect
    };
}
// Compare two arrays, with a function called on each item in the two arrays that returns true if the items are equal
function $9e9d3488b14d9168$var$arraysAreEqualByFunction(left, right, areEqualFunc) {
    if (left.length !== right.length) return false;
    for(let i = 0; i < left.length; i++){
        if (!areEqualFunc(left[i], right[i])) return false;
    }
    return true;
}
const $9e9d3488b14d9168$var$intersectionObserverCache = new WeakMap();
function $9e9d3488b14d9168$var$intersectionObserverAction(node, abortSignal, listener) {
    /* istanbul ignore else */ {
        // The scroll root is always `.tabpanel`
        const root = node.closest('.tabpanel');
        let observer = $9e9d3488b14d9168$var$intersectionObserverCache.get(root);
        if (!observer) {
            // TODO: replace this with the contentvisibilityautostatechange event when all supported browsers support it.
            // For now we use IntersectionObserver because it has better cross-browser support, and it would be bad for
            // old Safari versions if they eagerly downloaded all custom emoji all at once.
            observer = new IntersectionObserver(listener, {
                root: root,
                // trigger if we are 1/2 scroll container height away so that the images load a bit quicker while scrolling
                rootMargin: '50% 0px 50% 0px',
                // trigger if any part of the emoji grid is intersecting
                threshold: 0
            });
            // avoid creating a new IntersectionObserver for every category; just use one for the whole root
            $9e9d3488b14d9168$var$intersectionObserverCache.set(root, observer);
            // assume that the abortSignal is always the same for this root node; just add one event listener
            abortSignal.addEventListener('abort', ()=>{
                observer.disconnect();
            });
        }
        observer.observe(node);
    }
}
/* eslint-disable prefer-const,no-labels,no-inner-declarations */ // constants
const $9e9d3488b14d9168$var$EMPTY_ARRAY = [];
const { assign: $9e9d3488b14d9168$var$assign } = Object;
function $9e9d3488b14d9168$var$createRoot(shadowRoot, props) {
    const refs = {};
    const abortController = new AbortController();
    const abortSignal = abortController.signal;
    const { state: state, createEffect: createEffect } = $9e9d3488b14d9168$var$createState(abortSignal);
    const actionContext = new Map();
    // initial state
    $9e9d3488b14d9168$var$assign(state, {
        skinToneEmoji: undefined,
        i18n: undefined,
        database: undefined,
        customEmoji: undefined,
        customCategorySorting: undefined,
        emojiVersion: undefined
    });
    // public props
    $9e9d3488b14d9168$var$assign(state, props);
    // private props
    $9e9d3488b14d9168$var$assign(state, {
        initialLoad: true,
        currentEmojis: [],
        currentEmojisWithCategories: [],
        rawSearchText: '',
        searchText: '',
        searchMode: false,
        activeSearchItem: -1,
        message: undefined,
        skinTonePickerExpanded: false,
        skinTonePickerExpandedAfterAnimation: false,
        currentSkinTone: 0,
        activeSkinTone: 0,
        skinToneButtonText: undefined,
        pickerStyle: undefined,
        skinToneButtonLabel: '',
        skinTones: [],
        currentFavorites: [],
        defaultFavoriteEmojis: undefined,
        numColumns: $9e9d3488b14d9168$var$DEFAULT_NUM_COLUMNS,
        isRtl: false,
        currentGroupIndex: 0,
        groups: $9e9d3488b14d9168$var$groups,
        databaseLoaded: false,
        activeSearchItemId: undefined
    });
    //
    // Update the current group based on the currentGroupIndex
    //
    createEffect(()=>{
        if (state.currentGroup !== state.groups[state.currentGroupIndex]) state.currentGroup = state.groups[state.currentGroupIndex];
    });
    //
    // Utils/helpers
    //
    const focus = (id)=>{
        shadowRoot.getElementById(id).focus();
    };
    const emojiToDomNode = (emoji)=>shadowRoot.getElementById(`emo-${emoji.id}`);
    // fire a custom event that crosses the shadow boundary
    const fireEvent = (name, detail)=>{
        refs.rootElement.dispatchEvent(new CustomEvent(name, {
            detail: detail,
            bubbles: true,
            composed: true
        }));
    };
    //
    // Comparison utils
    //
    const compareEmojiArrays = (a, b)=>a.id === b.id;
    const compareCurrentEmojisWithCategories = (a, b)=>{
        const { category: aCategory, emojis: aEmojis } = a;
        const { category: bCategory, emojis: bEmojis } = b;
        if (aCategory !== bCategory) return false;
        return $9e9d3488b14d9168$var$arraysAreEqualByFunction(aEmojis, bEmojis, compareEmojiArrays);
    };
    //
    // Update utils to avoid excessive re-renders
    //
    // avoid excessive re-renders by checking the value before setting
    const updateCurrentEmojis = (newEmojis)=>{
        if (!$9e9d3488b14d9168$var$arraysAreEqualByFunction(state.currentEmojis, newEmojis, compareEmojiArrays)) state.currentEmojis = newEmojis;
    };
    // avoid excessive re-renders
    const updateSearchMode = (newSearchMode)=>{
        if (state.searchMode !== newSearchMode) state.searchMode = newSearchMode;
    };
    // avoid excessive re-renders
    const updateCurrentEmojisWithCategories = (newEmojisWithCategories)=>{
        if (!$9e9d3488b14d9168$var$arraysAreEqualByFunction(state.currentEmojisWithCategories, newEmojisWithCategories, compareCurrentEmojisWithCategories)) state.currentEmojisWithCategories = newEmojisWithCategories;
    };
    // Helpers used by PickerTemplate
    const unicodeWithSkin = (emoji, currentSkinTone)=>currentSkinTone && emoji.skins && emoji.skins[currentSkinTone] || emoji.unicode;
    const labelWithSkin = (emoji, currentSkinTone)=>$9e9d3488b14d9168$var$uniq([
            emoji.name || unicodeWithSkin(emoji, currentSkinTone),
            emoji.annotation,
            ...emoji.shortcodes || $9e9d3488b14d9168$var$EMPTY_ARRAY
        ].filter(Boolean)).join(', ');
    const titleForEmoji = (emoji)=>emoji.annotation || (emoji.shortcodes || $9e9d3488b14d9168$var$EMPTY_ARRAY).join(', ');
    const helpers = {
        labelWithSkin: labelWithSkin,
        titleForEmoji: titleForEmoji,
        unicodeWithSkin: unicodeWithSkin
    };
    const events = {
        onClickSkinToneButton: onClickSkinToneButton,
        onEmojiClick: onEmojiClick,
        onNavClick: onNavClick,
        onNavKeydown: onNavKeydown,
        onSearchKeydown: onSearchKeydown,
        onSkinToneOptionsClick: onSkinToneOptionsClick,
        onSkinToneOptionsFocusOut: onSkinToneOptionsFocusOut,
        onSkinToneOptionsKeydown: onSkinToneOptionsKeydown,
        onSkinToneOptionsKeyup: onSkinToneOptionsKeyup,
        onSearchInput: onSearchInput
    };
    const actions = {
        calculateEmojiGridStyle: calculateEmojiGridStyle,
        updateOnIntersection: updateOnIntersection
    };
    let firstRender = true;
    createEffect(()=>{
        $9e9d3488b14d9168$var$render(shadowRoot, state, helpers, events, actions, refs, abortSignal, actionContext, firstRender);
        firstRender = false;
    });
    //
    // Determine the emoji support level (in requestIdleCallback)
    //
    // mount logic
    if (!state.emojiVersion) $9e9d3488b14d9168$var$detectEmojiSupportLevel().then((level)=>{
        // Can't actually test emoji support in Jest/Vitest/JSDom, emoji never render in color in Cairo
        /* istanbul ignore next */ if (!level) state.message = state.i18n.emojiUnsupportedMessage;
    });
    //
    // Set or update the database object
    //
    createEffect(()=>{
        // show a Loading message if it takes a long time, or show an error if there's a network/IDB error
        async function handleDatabaseLoading() {
            let showingLoadingMessage = false;
            const timeoutHandle = setTimeout(()=>{
                showingLoadingMessage = true;
                state.message = state.i18n.loadingMessage;
            }, $9e9d3488b14d9168$var$TIMEOUT_BEFORE_LOADING_MESSAGE);
            try {
                await state.database.ready();
                state.databaseLoaded = true; // eslint-disable-line no-unused-vars
            } catch (err) {
                console.error(err);
                state.message = state.i18n.networkErrorMessage;
            } finally{
                clearTimeout(timeoutHandle);
                if (showingLoadingMessage) {
                    showingLoadingMessage = false;
                    state.message = ''; // eslint-disable-line no-unused-vars
                }
            }
        }
        if (state.database) /* no await */ handleDatabaseLoading();
    });
    //
    // Global styles for the entire picker
    //
    createEffect(()=>{
        state.pickerStyle = `
      --num-groups: ${state.groups.length}; 
      --indicator-opacity: ${state.searchMode ? 0 : 1}; 
      --num-skintones: ${$9e9d3488b14d9168$var$NUM_SKIN_TONES};`;
    });
    //
    // Set or update the customEmoji
    //
    createEffect(()=>{
        if (state.customEmoji && state.database) updateCustomEmoji(); // re-run whenever customEmoji change
    });
    createEffect(()=>{
        if (state.customEmoji && state.customEmoji.length) {
            if (state.groups !== $9e9d3488b14d9168$var$allGroups) state.groups = $9e9d3488b14d9168$var$allGroups;
        } else if (state.groups !== $9e9d3488b14d9168$var$groups) {
            if (state.currentGroupIndex) // If the current group is anything other than "custom" (which is first), decrement.
            // This fixes the odd case where you set customEmoji, then pick a category, then unset customEmoji
            state.currentGroupIndex--;
            state.groups = $9e9d3488b14d9168$var$groups;
        }
    });
    //
    // Set or update the preferred skin tone
    //
    createEffect(()=>{
        async function updatePreferredSkinTone() {
            if (state.databaseLoaded) state.currentSkinTone = await state.database.getPreferredSkinTone();
        }
        /* no await */ updatePreferredSkinTone();
    });
    createEffect(()=>{
        state.skinTones = Array($9e9d3488b14d9168$var$NUM_SKIN_TONES).fill().map((_, i)=>$9e9d3488b14d9168$var$applySkinTone(state.skinToneEmoji, i));
    });
    createEffect(()=>{
        state.skinToneButtonText = state.skinTones[state.currentSkinTone];
    });
    createEffect(()=>{
        state.skinToneButtonLabel = state.i18n.skinToneLabel.replace('{skinTone}', state.i18n.skinTones[state.currentSkinTone]);
    });
    //
    // Set or update the favorites emojis
    //
    createEffect(()=>{
        async function updateDefaultFavoriteEmojis() {
            const { database: database } = state;
            const favs = (await Promise.all($9e9d3488b14d9168$var$MOST_COMMONLY_USED_EMOJI.map((unicode)=>database.getEmojiByUnicodeOrName(unicode)))).filter(Boolean); // filter because in Jest/Vitest tests we don't have all the emoji in the DB
            state.defaultFavoriteEmojis = favs;
        }
        if (state.databaseLoaded) /* no await */ updateDefaultFavoriteEmojis();
    });
    function updateCustomEmoji() {
        // Certain effects have an implicit dependency on customEmoji since it affects the database
        // Getting it here on the state ensures this effect re-runs when customEmoji change.
        const { customEmoji: customEmoji, database: database } = state;
        const databaseCustomEmoji = customEmoji || $9e9d3488b14d9168$var$EMPTY_ARRAY;
        if (database.customEmoji !== databaseCustomEmoji) // Avoid setting this if the customEmoji have _not_ changed, because the setter triggers a re-computation of the
        // `customEmojiIndex`. Note we don't bother with deep object changes.
        database.customEmoji = databaseCustomEmoji;
    }
    createEffect(()=>{
        async function updateFavorites() {
            updateCustomEmoji(); // re-run whenever customEmoji change
            const { database: database, defaultFavoriteEmojis: defaultFavoriteEmojis, numColumns: numColumns } = state;
            const dbFavorites = await database.getTopFavoriteEmoji(numColumns);
            const favorites = await summarizeEmojis($9e9d3488b14d9168$var$uniqBy([
                ...dbFavorites,
                ...defaultFavoriteEmojis
            ], (_)=>_.unicode || _.name).slice(0, numColumns));
            state.currentFavorites = favorites;
        }
        if (state.databaseLoaded && state.defaultFavoriteEmojis) /* no await */ updateFavorites();
    });
    //
    // Re-run whenever the emoji grid changes size, and re-calc style/layout-related state variables:
    // 1) Re-calculate the --num-columns var because it may have changed
    // 2) Re-calculate whether we're in RTL mode or not.
    //
    // The benefit of doing this in one place is to align with rAF/ResizeObserver
    // and do all the calculations in one go. RTL vs LTR is not strictly layout-related,
    // but since we're already reading the style here, and since it's already aligned with
    // the rAF loop, this is the most appropriate place to do it perf-wise.
    //
    function calculateEmojiGridStyle(node) {
        $9e9d3488b14d9168$var$resizeObserverAction(node, abortSignal, ()=>{
            /* istanbul ignore next */ {
                // read all the style/layout calculations we need to make
                const style = getComputedStyle(refs.rootElement);
                const newNumColumns = parseInt(style.getPropertyValue('--num-columns'), 10);
                const newIsRtl = style.getPropertyValue('direction') === 'rtl';
                // write to state variables
                state.numColumns = newNumColumns;
                state.isRtl = newIsRtl;
            }
        });
    }
    // Re-run whenever the custom emoji in a category are shown/hidden. This is an optimization that simulates
    // what we'd get from `<img loading=lazy>` but without rendering an `<img>`.
    function updateOnIntersection(node) {
        $9e9d3488b14d9168$var$intersectionObserverAction(node, abortSignal, (entries)=>{
            for (const { target: target, isIntersecting: isIntersecting } of entries)target.classList.toggle('onscreen', isIntersecting);
        });
    }
    //
    // Set or update the currentEmojis. Check for invalid ZWJ renderings
    // (i.e. double emoji).
    //
    createEffect(()=>{
        async function updateEmojis() {
            const { searchText: searchText, currentGroup: currentGroup, databaseLoaded: databaseLoaded, customEmoji: customEmoji } = state;
            if (!databaseLoaded) {
                state.currentEmojis = [];
                state.searchMode = false;
            } else if (searchText.length >= $9e9d3488b14d9168$var$MIN_SEARCH_TEXT_LENGTH) {
                const newEmojis = await getEmojisBySearchQuery(searchText);
                if (state.searchText === searchText) {
                    updateCurrentEmojis(newEmojis);
                    updateSearchMode(true);
                }
            } else {
                const { id: currentGroupId } = currentGroup;
                // avoid race condition where currentGroupId is -1 and customEmoji is undefined/empty
                if (currentGroupId !== -1 || customEmoji && customEmoji.length) {
                    const newEmojis = await getEmojisByGroup(currentGroupId);
                    if (state.currentGroup.id === currentGroupId) {
                        updateCurrentEmojis(newEmojis);
                        updateSearchMode(false);
                    }
                }
            }
        }
        /* no await */ updateEmojis();
    });
    const resetScrollTopInRaf = ()=>{
        $9e9d3488b14d9168$var$rAF(()=>$9e9d3488b14d9168$var$resetScrollTopIfPossible(refs.tabpanelElement));
    };
    // Some emojis have their ligatures rendered as two or more consecutive emojis
    // We want to treat these the same as unsupported emojis, so we compare their
    // widths against the baseline widths and remove them as necessary
    createEffect(()=>{
        const { currentEmojis: currentEmojis, emojiVersion: emojiVersion } = state;
        const zwjEmojisToCheck = currentEmojis.filter((emoji)=>emoji.unicode) // filter custom emoji
        .filter((emoji)=>$9e9d3488b14d9168$var$hasZwj(emoji) && !$9e9d3488b14d9168$var$supportedZwjEmojis.has(emoji.unicode));
        if (!emojiVersion && zwjEmojisToCheck.length) {
            // render now, check their length later
            updateCurrentEmojis(currentEmojis);
            $9e9d3488b14d9168$var$rAF(()=>checkZwjSupportAndUpdate(zwjEmojisToCheck));
        } else {
            const newEmojis = emojiVersion ? currentEmojis : currentEmojis.filter(isZwjSupported);
            updateCurrentEmojis(newEmojis);
            // Reset scroll top to 0 when emojis change
            resetScrollTopInRaf();
        }
    });
    function checkZwjSupportAndUpdate(zwjEmojisToCheck) {
        const allSupported = $9e9d3488b14d9168$var$checkZwjSupport(zwjEmojisToCheck, refs.baselineEmoji, emojiToDomNode);
        if (allSupported) // Even if all emoji are supported, we still need to reset the scroll top to 0 when emojis change
        resetScrollTopInRaf();
        else // Force update. We only do this if there are any unsupported ZWJ characters since otherwise,
        // for browsers that support all emoji, it would be an unnecessary extra re-render.
        state.currentEmojis = [
            ...state.currentEmojis
        ];
    }
    function isZwjSupported(emoji) {
        return !emoji.unicode || !$9e9d3488b14d9168$var$hasZwj(emoji) || $9e9d3488b14d9168$var$supportedZwjEmojis.get(emoji.unicode);
    }
    async function filterEmojisByVersion(emojis) {
        const emojiSupportLevel = state.emojiVersion || await $9e9d3488b14d9168$var$detectEmojiSupportLevel();
        // !version corresponds to custom emoji
        return emojis.filter(({ version: version })=>!version || version <= emojiSupportLevel);
    }
    async function summarizeEmojis(emojis) {
        return $9e9d3488b14d9168$var$summarizeEmojisForUI(emojis, state.emojiVersion || await $9e9d3488b14d9168$var$detectEmojiSupportLevel());
    }
    async function getEmojisByGroup(group) {
        // -1 is custom emoji
        const emoji = group === -1 ? state.customEmoji : await state.database.getEmojiByGroup(group);
        return summarizeEmojis(await filterEmojisByVersion(emoji));
    }
    async function getEmojisBySearchQuery(query) {
        return summarizeEmojis(await filterEmojisByVersion(await state.database.getEmojiBySearchQuery(query)));
    }
    createEffect(()=>{});
    //
    // Derive currentEmojisWithCategories from currentEmojis. This is always done even if there
    // are no categories, because it's just easier to code the HTML this way.
    //
    createEffect(()=>{
        function calculateCurrentEmojisWithCategories() {
            const { searchMode: searchMode, currentEmojis: currentEmojis } = state;
            if (searchMode) return [
                {
                    category: '',
                    emojis: currentEmojis
                }
            ];
            const categoriesToEmoji = new Map();
            for (const emoji of currentEmojis){
                const category = emoji.category || '';
                let emojis = categoriesToEmoji.get(category);
                if (!emojis) {
                    emojis = [];
                    categoriesToEmoji.set(category, emojis);
                }
                emojis.push(emoji);
            }
            return [
                ...categoriesToEmoji.entries()
            ].map(([category, emojis])=>({
                    category: category,
                    emojis: emojis
                })).sort((a, b)=>state.customCategorySorting(a.category, b.category));
        }
        const newEmojisWithCategories = calculateCurrentEmojisWithCategories();
        updateCurrentEmojisWithCategories(newEmojisWithCategories);
    });
    //
    // Handle active search item (i.e. pressing up or down while searching)
    //
    createEffect(()=>{
        state.activeSearchItemId = state.activeSearchItem !== -1 && state.currentEmojis[state.activeSearchItem].id;
    });
    //
    // Handle user input on the search input
    //
    createEffect(()=>{
        const { rawSearchText: rawSearchText } = state;
        $9e9d3488b14d9168$var$rIC(()=>{
            state.searchText = (rawSearchText || '').trim(); // defer to avoid input delays, plus we can trim here
            state.activeSearchItem = -1;
        });
    });
    function onSearchKeydown(event) {
        if (!state.searchMode || !state.currentEmojis.length) return;
        const goToNextOrPrevious = (previous)=>{
            $9e9d3488b14d9168$var$halt(event);
            state.activeSearchItem = $9e9d3488b14d9168$var$incrementOrDecrement(previous, state.activeSearchItem, state.currentEmojis);
        };
        switch(event.key){
            case 'ArrowDown':
                return goToNextOrPrevious(false);
            case 'ArrowUp':
                return goToNextOrPrevious(true);
            case 'Enter':
                if (state.activeSearchItem === -1) // focus the first option in the list since the list must be non-empty at this point (it's verified above)
                state.activeSearchItem = 0;
                else {
                    $9e9d3488b14d9168$var$halt(event);
                    return clickEmoji(state.currentEmojis[state.activeSearchItem].id);
                }
        }
    }
    //
    // Handle user input on nav
    //
    function onNavClick(event) {
        const { target: target } = event;
        const closestTarget = target.closest('.nav-button');
        /* istanbul ignore if */ if (!closestTarget) return; // This should never happen, but makes me nervous not to have it
        const groupId = parseInt(closestTarget.dataset.groupId, 10);
        refs.searchElement.value = ''; // clear search box input
        state.rawSearchText = '';
        state.searchText = '';
        state.activeSearchItem = -1;
        state.currentGroupIndex = state.groups.findIndex((_)=>_.id === groupId);
    }
    function onNavKeydown(event) {
        const { target: target, key: key } = event;
        const doFocus = (el)=>{
            if (el) {
                $9e9d3488b14d9168$var$halt(event);
                el.focus();
            }
        };
        switch(key){
            case 'ArrowLeft':
                return doFocus(target.previousElementSibling);
            case 'ArrowRight':
                return doFocus(target.nextElementSibling);
            case 'Home':
                return doFocus(target.parentElement.firstElementChild);
            case 'End':
                return doFocus(target.parentElement.lastElementChild);
        }
    }
    //
    // Handle user input on an emoji
    //
    async function clickEmoji(unicodeOrName) {
        const emoji = await state.database.getEmojiByUnicodeOrName(unicodeOrName);
        const emojiSummary = [
            ...state.currentEmojis,
            ...state.currentFavorites
        ].find((_)=>_.id === unicodeOrName);
        const skinTonedUnicode = emojiSummary.unicode && unicodeWithSkin(emojiSummary, state.currentSkinTone);
        await state.database.incrementFavoriteEmojiCount(unicodeOrName);
        fireEvent('emoji-click', {
            emoji: emoji,
            skinTone: state.currentSkinTone,
            ...skinTonedUnicode && {
                unicode: skinTonedUnicode
            },
            ...emojiSummary.name && {
                name: emojiSummary.name
            }
        });
    }
    async function onEmojiClick(event) {
        const { target: target } = event;
        /* istanbul ignore if */ if (!target.classList.contains('emoji')) // This should never happen, but makes me nervous not to have it
        return;
        $9e9d3488b14d9168$var$halt(event);
        const id = target.id.substring(4); // replace 'emo-' or 'fav-' prefix
        /* no await */ clickEmoji(id);
    }
    //
    // Handle user input on the skintone picker
    //
    function changeSkinTone(skinTone) {
        state.currentSkinTone = skinTone;
        state.skinTonePickerExpanded = false;
        focus('skintone-button');
        fireEvent('skin-tone-change', {
            skinTone: skinTone
        });
        /* no await */ state.database.setPreferredSkinTone(skinTone);
    }
    function onSkinToneOptionsClick(event) {
        const { target: { id: id } } = event;
        const match = id && id.match(/^skintone-(\d)/); // skintone option format
        /* istanbul ignore if */ if (!match) return; // This should never happen, but makes me nervous not to have it
        $9e9d3488b14d9168$var$halt(event);
        const skinTone = parseInt(match[1], 10); // remove 'skintone-' prefix
        changeSkinTone(skinTone);
    }
    function onClickSkinToneButton(event) {
        state.skinTonePickerExpanded = !state.skinTonePickerExpanded;
        state.activeSkinTone = state.currentSkinTone;
        // this should always be true, since the button is obscured by the listbox, so this `if` is just to be sure
        if (state.skinTonePickerExpanded) {
            $9e9d3488b14d9168$var$halt(event);
            $9e9d3488b14d9168$var$rAF(()=>focus('skintone-list'));
        }
    }
    // To make the animation nicer, change the z-index of the skintone picker button
    // *after* the animation has played. This makes it appear that the picker box
    // is expanding "below" the button
    createEffect(()=>{
        if (state.skinTonePickerExpanded) refs.skinToneDropdown.addEventListener('transitionend', ()=>{
            state.skinTonePickerExpandedAfterAnimation = true; // eslint-disable-line no-unused-vars
        }, {
            once: true
        });
        else state.skinTonePickerExpandedAfterAnimation = false; // eslint-disable-line no-unused-vars
    });
    function onSkinToneOptionsKeydown(event) {
        // this should never happen, but makes me nervous not to have it
        /* istanbul ignore if */ if (!state.skinTonePickerExpanded) return;
        const changeActiveSkinTone = async (nextSkinTone)=>{
            $9e9d3488b14d9168$var$halt(event);
            state.activeSkinTone = nextSkinTone;
        };
        switch(event.key){
            case 'ArrowUp':
                return changeActiveSkinTone($9e9d3488b14d9168$var$incrementOrDecrement(true, state.activeSkinTone, state.skinTones));
            case 'ArrowDown':
                return changeActiveSkinTone($9e9d3488b14d9168$var$incrementOrDecrement(false, state.activeSkinTone, state.skinTones));
            case 'Home':
                return changeActiveSkinTone(0);
            case 'End':
                return changeActiveSkinTone(state.skinTones.length - 1);
            case 'Enter':
                // enter on keydown, space on keyup. this is just how browsers work for buttons
                // https://lists.w3.org/Archives/Public/w3c-wai-ig/2019JanMar/0086.html
                $9e9d3488b14d9168$var$halt(event);
                return changeSkinTone(state.activeSkinTone);
            case 'Escape':
                $9e9d3488b14d9168$var$halt(event);
                state.skinTonePickerExpanded = false;
                return focus('skintone-button');
        }
    }
    function onSkinToneOptionsKeyup(event) {
        // this should never happen, but makes me nervous not to have it
        /* istanbul ignore if */ if (!state.skinTonePickerExpanded) return;
        switch(event.key){
            case ' ':
                // enter on keydown, space on keyup. this is just how browsers work for buttons
                // https://lists.w3.org/Archives/Public/w3c-wai-ig/2019JanMar/0086.html
                $9e9d3488b14d9168$var$halt(event);
                return changeSkinTone(state.activeSkinTone);
        }
    }
    async function onSkinToneOptionsFocusOut(event) {
        // On blur outside of the skintone listbox, collapse the skintone picker.
        const { relatedTarget: relatedTarget } = event;
        // The `else` should never happen, but makes me nervous not to have it
        /* istanbul ignore else */ if (!relatedTarget || relatedTarget.id !== 'skintone-list') state.skinTonePickerExpanded = false;
    }
    function onSearchInput(event) {
        state.rawSearchText = event.target.value;
    }
    return {
        $set (newState) {
            $9e9d3488b14d9168$var$assign(state, newState);
        },
        $destroy () {
            abortController.abort();
        }
    };
}
const $9e9d3488b14d9168$var$DEFAULT_DATA_SOURCE = 'https://cdn.jsdelivr.net/npm/emoji-picker-element-data@^1/en/emojibase/data.json';
const $9e9d3488b14d9168$var$DEFAULT_LOCALE = 'en';
var $9e9d3488b14d9168$var$enI18n = {
    categoriesLabel: 'Categories',
    emojiUnsupportedMessage: 'Your browser does not support color emoji.',
    favoritesLabel: 'Favorites',
    loadingMessage: "Loading\u2026",
    networkErrorMessage: 'Could not load emoji.',
    regionLabel: 'Emoji picker',
    searchDescription: 'When search results are available, press up or down to select and enter to choose.',
    searchLabel: 'Search',
    searchResultsLabel: 'Search results',
    skinToneDescription: 'When expanded, press up or down to select and enter to choose.',
    skinToneLabel: 'Choose a skin tone (currently {skinTone})',
    skinTonesLabel: 'Skin tones',
    skinTones: [
        'Default',
        'Light',
        'Medium-Light',
        'Medium',
        'Medium-Dark',
        'Dark'
    ],
    categories: {
        custom: 'Custom',
        'smileys-emotion': 'Smileys and emoticons',
        'people-body': 'People and body',
        'animals-nature': 'Animals and nature',
        'food-drink': 'Food and drink',
        'travel-places': 'Travel and places',
        activities: 'Activities',
        objects: 'Objects',
        symbols: 'Symbols',
        flags: 'Flags'
    }
};
var $9e9d3488b14d9168$var$baseStyles = ":host{--emoji-size:1.375rem;--emoji-padding:0.5rem;--category-emoji-size:var(--emoji-size);--category-emoji-padding:var(--emoji-padding);--indicator-height:3px;--input-border-radius:0.5rem;--input-border-size:1px;--input-font-size:1rem;--input-line-height:1.5;--input-padding:0.25rem;--num-columns:8;--outline-size:2px;--border-size:1px;--border-radius:0;--skintone-border-radius:1rem;--category-font-size:1rem;display:flex;width:min-content;height:400px}:host,:host(.light){color-scheme:light;--background:#fff;--border-color:#e0e0e0;--indicator-color:#385ac1;--input-border-color:#999;--input-font-color:#111;--input-placeholder-color:#999;--outline-color:#999;--category-font-color:#111;--button-active-background:#e6e6e6;--button-hover-background:#d9d9d9}:host(.dark){color-scheme:dark;--background:#222;--border-color:#444;--indicator-color:#5373ec;--input-border-color:#ccc;--input-font-color:#efefef;--input-placeholder-color:#ccc;--outline-color:#fff;--category-font-color:#efefef;--button-active-background:#555555;--button-hover-background:#484848}@media (prefers-color-scheme:dark){:host{color-scheme:dark;--background:#222;--border-color:#444;--indicator-color:#5373ec;--input-border-color:#ccc;--input-font-color:#efefef;--input-placeholder-color:#ccc;--outline-color:#fff;--category-font-color:#efefef;--button-active-background:#555555;--button-hover-background:#484848}}:host([hidden]){display:none}button{margin:0;padding:0;border:0;background:0 0;box-shadow:none;-webkit-tap-highlight-color:transparent}button::-moz-focus-inner{border:0}input{padding:0;margin:0;line-height:1.15;font-family:inherit}input[type=search]{-webkit-appearance:none}:focus{outline:var(--outline-color) solid var(--outline-size);outline-offset:calc(-1*var(--outline-size))}:host([data-js-focus-visible]) :focus:not([data-focus-visible-added]){outline:0}:focus:not(:focus-visible){outline:0}.hide-focus{outline:0}*{box-sizing:border-box}.picker{contain:content;display:flex;flex-direction:column;background:var(--background);border:var(--border-size) solid var(--border-color);border-radius:var(--border-radius);width:100%;height:100%;overflow:hidden;--total-emoji-size:calc(var(--emoji-size) + (2 * var(--emoji-padding)));--total-category-emoji-size:calc(var(--category-emoji-size) + (2 * var(--category-emoji-padding)))}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.hidden{opacity:0;pointer-events:none}.abs-pos{position:absolute;left:0;top:0}.gone{display:none!important}.skintone-button-wrapper,.skintone-list{background:var(--background);z-index:3}.skintone-button-wrapper.expanded{z-index:1}.skintone-list{position:absolute;inset-inline-end:0;top:0;z-index:2;overflow:visible;border-bottom:var(--border-size) solid var(--border-color);border-radius:0 0 var(--skintone-border-radius) var(--skintone-border-radius);will-change:transform;transition:transform .2s ease-in-out;transform-origin:center 0}@media (prefers-reduced-motion:reduce){.skintone-list{transition-duration:.001s}}@supports not (inset-inline-end:0){.skintone-list{right:0}}.skintone-list.no-animate{transition:none}.tabpanel{overflow-y:auto;scrollbar-gutter:stable;-webkit-overflow-scrolling:touch;will-change:transform;min-height:0;flex:1;contain:content}.emoji-menu{display:grid;grid-template-columns:repeat(var(--num-columns),var(--total-emoji-size));justify-content:space-around;align-items:flex-start;width:100%}.emoji-menu.visibility-auto{content-visibility:auto;contain-intrinsic-size:calc(var(--num-columns)*var(--total-emoji-size)) calc(var(--num-rows)*var(--total-emoji-size))}.category{padding:var(--emoji-padding);font-size:var(--category-font-size);color:var(--category-font-color)}.emoji,button.emoji{font-size:var(--emoji-size);display:flex;align-items:center;justify-content:center;border-radius:100%;height:var(--total-emoji-size);width:var(--total-emoji-size);line-height:1;overflow:hidden;font-family:var(--emoji-font-family);cursor:pointer}@media (hover:hover) and (pointer:fine){.emoji:hover,button.emoji:hover{background:var(--button-hover-background)}}.emoji.active,.emoji:active,button.emoji.active,button.emoji:active{background:var(--button-active-background)}.onscreen .custom-emoji::after{content:\"\";width:var(--emoji-size);height:var(--emoji-size);background-repeat:no-repeat;background-position:center center;background-size:contain;background-image:var(--custom-emoji-background)}.nav,.nav-button{align-items:center}.nav{display:grid;justify-content:space-between;contain:content}.nav-button{display:flex;justify-content:center}.nav-emoji{font-size:var(--category-emoji-size);width:var(--total-category-emoji-size);height:var(--total-category-emoji-size)}.indicator-wrapper{display:flex;border-bottom:1px solid var(--border-color)}.indicator{width:calc(100%/var(--num-groups));height:var(--indicator-height);opacity:var(--indicator-opacity);background-color:var(--indicator-color);will-change:transform,opacity;transition:opacity .1s linear,transform .25s ease-in-out}@media (prefers-reduced-motion:reduce){.indicator{will-change:opacity;transition:opacity .1s linear}}.pad-top,input.search{background:var(--background);width:100%}.pad-top{height:var(--emoji-padding);z-index:3}.search-row{display:flex;align-items:center;position:relative;padding-inline-start:var(--emoji-padding);padding-bottom:var(--emoji-padding)}.search-wrapper{flex:1;min-width:0}input.search{padding:var(--input-padding);border-radius:var(--input-border-radius);border:var(--input-border-size) solid var(--input-border-color);color:var(--input-font-color);font-size:var(--input-font-size);line-height:var(--input-line-height)}input.search::placeholder{color:var(--input-placeholder-color)}.favorites{overflow-y:auto;scrollbar-gutter:stable;display:flex;flex-direction:row;border-top:var(--border-size) solid var(--border-color);contain:content}.message{padding:var(--emoji-padding)}";
const $9e9d3488b14d9168$var$PROPS = [
    'customEmoji',
    'customCategorySorting',
    'database',
    'dataSource',
    'i18n',
    'locale',
    'skinToneEmoji',
    'emojiVersion'
];
// Styles injected ourselves, so we can declare the FONT_FAMILY variable in one place
const $9e9d3488b14d9168$var$EXTRA_STYLES = `:host{--emoji-font-family:${$9e9d3488b14d9168$var$FONT_FAMILY}}`;
class $9e9d3488b14d9168$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(props){
        super();
        this.attachShadow({
            mode: 'open'
        });
        const style = document.createElement('style');
        style.textContent = $9e9d3488b14d9168$var$baseStyles + $9e9d3488b14d9168$var$EXTRA_STYLES;
        this.shadowRoot.appendChild(style);
        this._ctx = {
            // Set defaults
            locale: $9e9d3488b14d9168$var$DEFAULT_LOCALE,
            dataSource: $9e9d3488b14d9168$var$DEFAULT_DATA_SOURCE,
            skinToneEmoji: $9e9d3488b14d9168$var$DEFAULT_SKIN_TONE_EMOJI,
            customCategorySorting: $9e9d3488b14d9168$var$DEFAULT_CATEGORY_SORTING,
            customEmoji: null,
            i18n: $9e9d3488b14d9168$var$enI18n,
            emojiVersion: null,
            ...props
        };
        // Handle properties set before the element was upgraded
        for (const prop of $9e9d3488b14d9168$var$PROPS)if (prop !== 'database' && Object.prototype.hasOwnProperty.call(this, prop)) {
            this._ctx[prop] = this[prop];
            delete this[prop];
        }
        this._dbFlush(); // wait for a flush before creating the db, in case the user calls e.g. a setter or setAttribute
    }
    connectedCallback() {
        // The _cmp may be defined if the component was immediately disconnected and then reconnected. In that case,
        // do nothing (preserve the state)
        if (!this._cmp) this._cmp = $9e9d3488b14d9168$var$createRoot(this.shadowRoot, this._ctx);
    }
    disconnectedCallback() {
        // Check in a microtask if the element is still connected. If so, treat this as a "move" rather than a disconnect
        // Inspired by Vue: https://vuejs.org/guide/extras/web-components.html#building-custom-elements-with-vue
        $9e9d3488b14d9168$var$qM(()=>{
            // this._cmp may be defined if connect-disconnect-connect-disconnect occurs synchronously
            if (!this.isConnected && this._cmp) {
                this._cmp.$destroy();
                this._cmp = undefined;
                const { database: database } = this._ctx;
                database.close()// only happens if the database failed to load in the first place, so we don't care
                .catch((err)=>console.error(err));
            }
        });
    }
    static get observedAttributes() {
        return [
            'locale',
            'data-source',
            'skin-tone-emoji',
            'emoji-version'
        ] // complex objects aren't supported, also use kebab-case
        ;
    }
    attributeChangedCallback(attrName, oldValue, newValue) {
        this._set(// convert from kebab-case to camelcase
        // see https://github.com/sveltejs/svelte/issues/3852#issuecomment-665037015
        attrName.replace(/-([a-z])/g, (_, up)=>up.toUpperCase()), // convert string attribute to float if necessary
        attrName === 'emoji-version' ? parseFloat(newValue) : newValue);
    }
    _set(prop, newValue) {
        this._ctx[prop] = newValue;
        if (this._cmp) this._cmp.$set({
            [prop]: newValue
        });
        if ([
            'locale',
            'dataSource'
        ].includes(prop)) this._dbFlush();
    }
    _dbCreate() {
        const { locale: locale, dataSource: dataSource, database: database } = this._ctx;
        // only create a new database if we really need to
        if (!database || database.locale !== locale || database.dataSource !== dataSource) this._set('database', new (0, $736431a7b9521865$export$2e2bcd8739ae039)({
            locale: locale,
            dataSource: dataSource
        }));
    }
    // Update the Database in one microtask if the locale/dataSource change. We do one microtask
    // so we don't create two Databases if e.g. both the locale and the dataSource change
    _dbFlush() {
        $9e9d3488b14d9168$var$qM(()=>this._dbCreate());
    }
}
const $9e9d3488b14d9168$var$definitions = {};
for (const prop of $9e9d3488b14d9168$var$PROPS)$9e9d3488b14d9168$var$definitions[prop] = {
    get () {
        if (prop === 'database') // in rare cases, the microtask may not be flushed yet, so we need to instantiate the DB
        // now if the user is asking for it
        this._dbCreate();
        return this._ctx[prop];
    },
    set (val) {
        if (prop === 'database') throw new Error('database is read-only');
        this._set(prop, val);
    }
};
Object.defineProperties($9e9d3488b14d9168$export$2e2bcd8739ae039.prototype, $9e9d3488b14d9168$var$definitions);
/* istanbul ignore else */ if (!customElements.get('emoji-picker')) customElements.define('emoji-picker', $9e9d3488b14d9168$export$2e2bcd8739ae039);





var $bf4f0cf05f6fd378$var$browserSupportsTextareaTextNodes;
/**
 * @param {HTMLElement} input
 * @return {boolean}
 */ function $bf4f0cf05f6fd378$var$canManipulateViaTextNodes(input) {
    if (input.nodeName !== "TEXTAREA") return false;
    if (typeof $bf4f0cf05f6fd378$var$browserSupportsTextareaTextNodes === "undefined") {
        var textarea = document.createElement("textarea");
        textarea.value = 1;
        $bf4f0cf05f6fd378$var$browserSupportsTextareaTextNodes = !!textarea.firstChild;
    }
    return $bf4f0cf05f6fd378$var$browserSupportsTextareaTextNodes;
}
/**
 * @param {HTMLTextAreaElement|HTMLInputElement} input
 * @param {string} text
 * @returns {void}
 */ function $bf4f0cf05f6fd378$var$index(input, text) {
    // Most of the used APIs only work with the field selected
    input.focus(); // IE 8-10
    if (document.selection) {
        var ieRange = document.selection.createRange();
        ieRange.text = text; // Move cursor after the inserted text
        ieRange.collapse(false);
        ieRange.select();
        return;
    } // Webkit + Edge
    var isSuccess = document.execCommand("insertText", false, text);
    if (!isSuccess) {
        var start = input.selectionStart;
        var end = input.selectionEnd; // Firefox (non-standard method)
        if (typeof input.setRangeText === "function") input.setRangeText(text);
        else {
            // To make a change we just need a Range, not a Selection
            var range = document.createRange();
            var textNode = document.createTextNode(text);
            if ($bf4f0cf05f6fd378$var$canManipulateViaTextNodes(input)) {
                var node = input.firstChild; // If textarea is empty, just insert the text
                if (!node) input.appendChild(textNode);
                else {
                    // Otherwise we need to find a nodes for start and end
                    var offset = 0;
                    var startNode = null;
                    var endNode = null;
                    while(node && (startNode === null || endNode === null)){
                        var nodeLength = node.nodeValue.length; // if start of the selection falls into current node
                        if (start >= offset && start <= offset + nodeLength) range.setStart(startNode = node, start - offset);
                         // if end of the selection falls into current node
                        if (end >= offset && end <= offset + nodeLength) range.setEnd(endNode = node, end - offset);
                        offset += nodeLength;
                        node = node.nextSibling;
                    } // If there is some text selected, remove it as we should replace it
                    if (start !== end) range.deleteContents();
                }
            } // If the node is a textarea and the range doesn't span outside the element
            //
            // Get the commonAncestorContainer of the selected range and test its type
            // If the node is of type `#text` it means that we're still working with text nodes within our textarea element
            // otherwise, if it's of type `#document` for example it means our selection spans outside the textarea.
            if ($bf4f0cf05f6fd378$var$canManipulateViaTextNodes(input) && range.commonAncestorContainer.nodeName === "#text") // Finally insert a new node. The browser will automatically split start and end nodes into two if necessary
            range.insertNode(textNode);
            else {
                // If the node is not a textarea or the range spans outside a textarea the only way is to replace the whole value
                var value = input.value;
                input.value = value.slice(0, start) + text + value.slice(end);
            }
        } // Correct the cursor position to be at the end of the insertion
        input.setSelectionRange(start + text.length, start + text.length); // Notify any possible listeners of the change
        var e = document.createEvent("UIEvent");
        e.initEvent("input", true, false);
        input.dispatchEvent(e);
    }
}
var $bf4f0cf05f6fd378$export$2e2bcd8739ae039 = $bf4f0cf05f6fd378$var$index;


/*!
 * @georapbox/capture-photo-element
 * A custom element that implements the MediaDevices.getUserMedia() method of the MediaDevices interface to capture a photo in the browser.
 *
 * @version 5.0.0
 * @homepage https://github.com/georapbox/capture-photo-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $dced0d224c6d876e$var$c = (r, t, e)=>(Number.isNaN(t) && (t = 0), Number.isNaN(e) && (e = 0), Math.min(Math.max(r, Math.min(t, e)), Math.max(t, e)));
var $dced0d224c6d876e$var$a = "capture-photo", $dced0d224c6d876e$var$d = `
  :host { display: block; box-sizing: border-box; }
  :host *, :host *::before, :host *::after { box-sizing: inherit;}
  :host([hidden]), [hidden], ::slotted([hidden]) { display: none; }
  video { display: block; }
  #output:empty { display: none; }
`, $dced0d224c6d876e$var$u = document.createElement("template");
$dced0d224c6d876e$var$u.innerHTML = `
  <style>${$dced0d224c6d876e$var$d}</style>
  <video part="video" playsinline></video>
  <canvas hidden></canvas>
  <div part="actions-container">
    <slot name="capture-button">
      <button part="capture-button" type="button">
        <slot name="capture-button-content">Capture photo</slot>
      </button>
    </slot>
    <slot name="actions"></slot>
  </div>
  <slot></slot>
  <div part="output-container" id="output"></div>
`;
var $dced0d224c6d876e$export$cc30a98fe3890794 = class r extends HTMLElement {
    #a = {};
    #t = null;
    #n = null;
    #h = null;
    #e = null;
    #r = null;
    #i = null;
    constructor(){
        super(), this.#a = this.getSupportedConstraints(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($dced0d224c6d876e$var$u.content.cloneNode(!0));
    }
    static get observedAttributes() {
        return [
            "no-image",
            "pan",
            "tilt",
            "zoom",
            "torch"
        ];
    }
    attributeChangedCallback(t, e, s) {
        if (!this.isConnected) return;
        let i = this.getTrackCapabilities();
        if (t === "no-image" && e !== s && this.#u(), t === "pan" && e !== s && "pan" in this.#a) {
            let o = "pan" in i && i.pan?.min && i.pan?.max ? this.pan >= i.pan.min && this.pan <= i.pan.max : !1;
            typeof this.pan == "number" && o && this.#o("pan", this.pan);
        }
        if (t === "tilt" && e !== s && "tilt" in this.#a) {
            let o = "tilt" in i && i.tilt?.min && i.tilt?.max ? this.tilt >= i.tilt.min && this.tilt <= i.tilt.max : !1;
            typeof this.tilt == "number" && o && this.#o("tilt", this.tilt);
        }
        if (t === "zoom" && e !== s && "zoom" in this.#a) {
            let o = "zoom" in i && i.zoom?.min && i.zoom?.max ? this.zoom >= i.zoom.min && this.zoom <= i.zoom.max : !1;
            typeof this.zoom == "number" && o && this.#o("zoom", this.zoom);
        }
        t === "torch" && e !== s && "torch" in this.#a && this.#o("torch", this.torch);
    }
    async connectedCallback() {
        if (this.#s("autoPlay"), this.#s("noImage"), this.#s("facingMode"), this.#s("cameraResolution"), this.#s("pan"), this.#s("tilt"), this.#s("zoom"), this.#s("torch"), this.#s("calculateFileSize"), this.#n = this.shadowRoot?.querySelector("canvas") || null, this.#h = this.shadowRoot?.getElementById("output") || null, this.#e = this.shadowRoot?.querySelector("video") || null, this.#r = this.shadowRoot?.querySelector('slot[name="capture-button"]') || null, this.#i = this.#m(), this.#e?.addEventListener("loadedmetadata", this.#c), this.#r?.addEventListener("slotchange", this.#d), this.#i?.addEventListener("click", this.#l), !r.isSupported()) return this.dispatchEvent(new CustomEvent(`${$dced0d224c6d876e$var$a}:error`, {
            bubbles: !0,
            composed: !0,
            detail: {
                error: {
                    name: "NotSupportedError",
                    message: "Not supported"
                }
            }
        }));
        this.autoPlay && this.startVideoStream();
    }
    disconnectedCallback() {
        this.stopVideoStream(), this.#i?.removeEventListener("click", this.#l), this.#e?.removeEventListener("loadedmetadata", this.#c), this.#r?.removeEventListener("slotchange", this.#d);
    }
    get autoPlay() {
        return this.hasAttribute("auto-play");
    }
    set autoPlay(t) {
        this.toggleAttribute("auto-play", !!t);
    }
    get noImage() {
        return this.hasAttribute("no-image");
    }
    set noImage(t) {
        this.toggleAttribute("no-image", !!t);
    }
    get facingMode() {
        let t = this.getAttribute("facing-mode");
        return t !== "user" ? "environment" : t;
    }
    set facingMode(t) {
        this.setAttribute("facing-mode", t);
    }
    get cameraResolution() {
        return this.getAttribute("camera-resolution") || "";
    }
    set cameraResolution(t) {
        this.setAttribute("camera-resolution", t);
    }
    get pan() {
        return Number(this.getAttribute("pan")) || 0;
    }
    set pan(t) {
        this.setAttribute("pan", t != null ? t.toString() : t);
    }
    get tilt() {
        return Number(this.getAttribute("tilt")) || 0;
    }
    set tilt(t) {
        this.setAttribute("tilt", t != null ? t.toString() : t);
    }
    get zoom() {
        return Number(this.getAttribute("zoom")) || 1;
    }
    set zoom(t) {
        this.setAttribute("zoom", t != null ? t.toString() : t);
    }
    get torch() {
        return this.hasAttribute("torch");
    }
    set torch(t) {
        this.toggleAttribute("torch", !!t);
    }
    get calculateFileSize() {
        return this.hasAttribute("calculate-file-size");
    }
    set calculateFileSize(t) {
        this.toggleAttribute("calculate-file-size", !!t);
    }
    get loading() {
        return this.hasAttribute("loading");
    }
    #l = (t)=>{
        t.preventDefault(), this.capture();
    };
    #c = (t)=>{
        let e = t.target;
        e.play().then(()=>{
            this.dispatchEvent(new CustomEvent(`${$dced0d224c6d876e$var$a}:video-play`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    video: e
                }
            }));
        }).catch((s)=>{
            this.dispatchEvent(new CustomEvent(`${$dced0d224c6d876e$var$a}:error`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: s
                }
            }));
        }).finally(()=>{
            this.removeAttribute("loading");
        });
    };
    #u() {
        this.#h && this.#h.replaceChildren();
    }
    #o(t, e) {
        if (!this.#t) return;
        let [s] = this.#t.getVideoTracks(), i = this.getTrackCapabilities(), o = this.getTrackSettings(), n = t === "pan" || t === "tilt" || t === "zoom" ? $dced0d224c6d876e$var$c(Number(e), i[t]?.min || 1, i[t]?.max || 1) : e;
        t in o && s.applyConstraints({
            advanced: [
                {
                    [t]: n
                }
            ]
        }).catch(()=>{});
    }
    #d = (t)=>{
        t.target?.name === "capture-button" && (this.#i?.removeEventListener("click", this.#l), this.#i = this.#m(), this.#i && (this.#i.addEventListener("click", this.#l), this.#i.nodeName !== "BUTTON" && !this.#i.hasAttribute("role") && this.#i.setAttribute("role", "button")));
    };
    #m() {
        return this.#r && this.#r.assignedElements({
            flatten: !0
        }).find((t)=>t.nodeName === "BUTTON" || t.getAttribute("slot") === "capture-button") || null;
    }
    #s(t) {
        let e = this;
        if (Object.prototype.hasOwnProperty.call(e, t)) {
            let s = e[t];
            delete e[t], e[t] = s;
        }
    }
    async startVideoStream(t) {
        if (!r.isSupported() || this.#t) return;
        this.setAttribute("loading", "");
        let e = {
            video: {
                facingMode: {
                    ideal: this.facingMode
                },
                pan: !0,
                tilt: !0,
                zoom: !0,
                torch: this.torch
            },
            audio: !1
        };
        if (typeof t == "string" && t.trim().length > 0 && (e.video.deviceId = {
            exact: t
        }), typeof this.cameraResolution == "string" && this.cameraResolution.trim().length > 0) {
            let [s = 0, i = 0] = this.cameraResolution.split("x").map((o)=>Number(o));
            s > 0 && i > 0 && (e.video.width = s, e.video.height = i);
        }
        try {
            this.#t = await navigator.mediaDevices.getUserMedia(e), this.#e && (this.#e.srcObject = this.#t), this.#o("pan", this.pan), this.#o("tilt", this.tilt), this.#o("zoom", this.zoom);
        } catch (s) {
            this.dispatchEvent(new CustomEvent(`${$dced0d224c6d876e$var$a}:error`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: s
                }
            }));
        } finally{
            this.removeAttribute("loading");
        }
    }
    restartVideoStream(t) {
        this.#t && this.#e && this.stopVideoStream(), this.startVideoStream(t);
    }
    stopVideoStream() {
        if (!this.#e || !this.#t) return;
        let [t] = this.#t.getVideoTracks();
        t?.stop(), this.#e.srcObject = null, this.#t = null;
    }
    async capture() {
        if (!(this.loading || !this.#n || !this.#e)) try {
            let t = this.#n.getContext("2d"), e = this.#e.videoWidth, s = this.#e.videoHeight;
            this.#n.width = e, this.#n.height = s, t?.drawImage(this.#e, 0, 0, e, s);
            let i = this.#n.toDataURL("image/png");
            if (typeof i == "string" && i.includes("data:image")) {
                if (!this.noImage) {
                    let n = new Image;
                    n.src = i, n.width = e, n.height = s, n.alt = "Captured photo", n.setAttribute("part", "output-image"), this.#u(), this.#h?.appendChild(n);
                }
                let o = {
                    dataURI: i,
                    width: e,
                    height: s
                };
                if (this.calculateFileSize) try {
                    let l = (await (await fetch(i)).blob()).size;
                    l && (o.size = l);
                } catch  {}
                this.dispatchEvent(new CustomEvent(`${$dced0d224c6d876e$var$a}:success`, {
                    bubbles: !0,
                    composed: !0,
                    detail: o
                }));
            }
        } catch (t) {
            this.dispatchEvent(new CustomEvent(`${$dced0d224c6d876e$var$a}:error`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: t
                }
            }));
        }
    }
    getSupportedConstraints() {
        return r.isSupported() ? navigator.mediaDevices.getSupportedConstraints() || {} : {};
    }
    getTrackCapabilities() {
        if (!this.#t) return {};
        let [t] = this.#t.getVideoTracks();
        return t && typeof t.getCapabilities == "function" ? t.getCapabilities() || {} : {};
    }
    getTrackSettings() {
        if (!this.#t) return {};
        let [t] = this.#t.getVideoTracks();
        return t && typeof t.getSettings == "function" ? t.getSettings() || {} : {};
    }
    static async getVideoInputDevices() {
        return !navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices ? [] : (await navigator.mediaDevices.enumerateDevices() || []).filter((e)=>e.kind === "videoinput" && !!e.deviceId);
    }
    static isSupported() {
        return !!navigator.mediaDevices?.getUserMedia;
    }
    static defineCustomElement(t = $dced0d224c6d876e$var$a) {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, r);
    }
};
$dced0d224c6d876e$export$cc30a98fe3890794.defineCustomElement();


/*!
 * @georapbox/web-share-element
 * A custom element that implements the Web Share API to share user-defined data.
 *
 * @version 3.1.1
 * @homepage https://github.com/georapbox/web-share-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ function $7a2aca835bb05064$export$c37129e465f64ef0(a) {
    return a !== null && typeof a == "object" ? "share" in navigator && "canShare" in navigator && navigator.canShare(a) : "share" in navigator;
}


/*!
 * @georapbox/theme-toggle-element
 * A custom element that allows you to toggle between dark and light theme.
 *
 * @version 4.0.2
 * @homepage https://github.com/georapbox/theme-toggle-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $647a8d39392e9d40$var$n = "theme-toggle/theme-preference", $647a8d39392e9d40$var$r = "data-theme", $647a8d39392e9d40$var$a = document.createElement("template"), $647a8d39392e9d40$var$h = `
  :host {
    display: inline-block;
    box-sizing: border-box;
  }

  :host *,
  :host *:after,
  :host *:before {
    box-sizing: inherit;
  }

  .hidden {
    display: none !important;
  }

  .button {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 0.375rem;
    border: none;
    background-color: transparent;
    color: inherit;
    cursor: pointer;
    font-family: inherit;
    font-size: inherit;
  }

  .icon--hidden {
    display: none !important;
  }

  .label--hidden {
    display: inline !important;
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;
  }

  .icon__svg {
    min-width: 1.5em;
    width: 1.5em;
    height: 1.5em;
  }

  .system-path {
    transform: scale(0.4) translateY(-4px);
    transform-origin: center;
  }
`;
$647a8d39392e9d40$var$a.innerHTML = `
  <style>${$647a8d39392e9d40$var$h}</style>

  <button type="button" part="base" id="theme-toggle" class="button">
    <slot name="light">
      <slot name="icon-light" part="icon icon-light" class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" class="icon__svg" aria-hidden="true">
          <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41L5.99 4.58zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41l-1.06-1.06zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06zM7.05 18.36c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06z"></path>
        </svg>
      </slot>
      <slot name="label-light" part="label label-light" class="label">Light theme</slot>
    </slot>

    <slot name="dark">
      <slot name="icon-dark" part="icon icon-dark" class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" class="icon__svg" aria-hidden="true">
          <path d="M9.5 2c-1.82 0-3.53.5-5 1.35 2.99 1.73 5 4.95 5 8.65s-2.01 6.92-5 8.65c1.47.85 3.18 1.35 5 1.35 5.52 0 10-4.48 10-10S15.02 2 9.5 2z"></path>
        </svg>
      </slot>
      <slot name="label-dark" part="label label-dark" class="label">Dark theme</slot>
    </slot>

    <slot name="system">
      <slot name="icon-system" part="icon icon-system" class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" class="icon__svg" aria-hidden="true">
          <path d="M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v2h12v-2l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"></path>
          <path class="system-path system-path--light" d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41L5.99 4.58zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41l-1.06-1.06zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06zM7.05 18.36c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06z"></path>
          <path class="system-path system-path--dark" d="M9.5 2c-1.82 0-3.53.5-5 1.35 2.99 1.73 5 4.95 5 8.65s-2.01 6.92-5 8.65c1.47.85 3.18 1.35 5 1.35 5.52 0 10-4.48 10-10S15.02 2 9.5 2z"></path>
        </svg>
      </slot>
      <slot name="label-system" part="label label-system" class="label">System theme</slot>
    </slot>
  </button>
`;
var $647a8d39392e9d40$export$173e0a822059eddc = class l extends HTMLElement {
    #i = [
        "light",
        "dark",
        "system"
    ];
    #t = "system";
    #s = 0;
    #e = null;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open",
            delegatesFocus: !0
        }).appendChild($647a8d39392e9d40$var$a.content.cloneNode(!0)), this.#e = this.shadowRoot?.getElementById("theme-toggle") || null;
    }
    static get observedAttributes() {
        return [
            "storage-key",
            "no-icon",
            "no-label"
        ];
    }
    attributeChangedCallback(t, e, s) {
        t === "storage-key" && e !== s && (this.#t = this.#a(), this.#s = this.#i.indexOf(this.#t) || 0, this.#o()), t === "no-icon" && e !== s && this.#e && this.#e.querySelectorAll('slot[name^="icon"]').forEach((o)=>{
            o.classList.toggle("icon--hidden", this.noIcon);
        }), t === "no-label" && e !== s && this.#e && this.#e.querySelectorAll('slot[name^="label"]').forEach((o)=>{
            o.classList.toggle("label--hidden", this.noLabel);
        });
    }
    get noStorage() {
        return this.hasAttribute("no-storage");
    }
    set noStorage(t) {
        t ? this.setAttribute("no-storage", "") : this.removeAttribute("no-storage");
    }
    get storageKey() {
        return this.getAttribute("storage-key");
    }
    set storageKey(t) {
        t != null && this.setAttribute("storage-key", t);
    }
    get noIcon() {
        return this.hasAttribute("no-icon");
    }
    set noIcon(t) {
        t ? this.setAttribute("no-icon", "") : this.removeAttribute("no-icon");
    }
    get noLabel() {
        return this.hasAttribute("no-label");
    }
    set noLabel(t) {
        t ? this.setAttribute("no-label", "") : this.removeAttribute("no-label");
    }
    connectedCallback() {
        this.#n("noStorage"), this.#n("storageKey"), this.#n("noIcon"), this.#n("noLabel"), this.#t = this.#a(), this.#s = this.#i.indexOf(this.#t) || 0, this.#o(), this.#e?.addEventListener("click", this.#l), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", this.#r);
    }
    disconnectedCallback() {
        this.#e?.removeEventListener("click", this.#l), window.matchMedia("(prefers-color-scheme: dark)").removeEventListener("change", this.#r);
    }
    #a() {
        if (this.noStorage) return "system";
        let t = "";
        try {
            t = window.localStorage.getItem(this.storageKey || $647a8d39392e9d40$var$n) || "";
        } catch  {}
        return t === "light" || t === "dark" || t === "system" ? t : "system";
    }
    #h() {
        if (!this.noStorage) try {
            window.localStorage.setItem(this.storageKey || $647a8d39392e9d40$var$n, this.#t);
        } catch  {}
    }
    #o() {
        if (this.#e?.querySelectorAll('slot[name="light"], slot[name="dark"], slot[name="system"]').forEach((t)=>{
            t.classList.toggle("hidden", !t.getAttribute("name")?.startsWith(this.#t));
        }), document.documentElement.setAttribute($647a8d39392e9d40$var$r, this.#t), this.#t === "system") {
            let t = window.matchMedia("(prefers-color-scheme: dark)").matches;
            this.#e?.querySelectorAll(".system-path").forEach((e)=>{
                e.classList.toggle("hidden", t ? e.classList.contains("system-path--light") : e.classList.contains("system-path--dark"));
            });
        }
    }
    #c() {
        return this.#s = (this.#s + 1) % this.#i.length, this.#i[this.#s];
    }
    #l = ()=>{
        this.#t = this.#c(), this.#h(), this.#o(), this.dispatchEvent(new CustomEvent("tt-theme-change", {
            bubbles: !0,
            composed: !0,
            detail: {
                theme: this.#t
            }
        }));
    };
    #r = ()=>{
        this.#o();
    };
    #n(t) {
        let e = this;
        if (Object.prototype.hasOwnProperty.call(e, t)) {
            let s = e[t];
            delete e[t], e[t] = s;
        }
    }
    static defineCustomElement(t = "theme-toggle") {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, l);
    }
};
$647a8d39392e9d40$export$173e0a822059eddc.defineCustomElement();


/*!
 * @georapbox/web-share-element
 * A custom element that implements the Web Share API to share user-defined data.
 *
 * @version 3.1.1
 * @homepage https://github.com/georapbox/web-share-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $cd62c5572235e737$var$h = `
  :host {
    display: inline-block;
  }
`, $cd62c5572235e737$var$r = document.createElement("template");
$cd62c5572235e737$var$r.innerHTML = `
  <style>${$cd62c5572235e737$var$h}</style>
  <slot name="button"><button type="button" part="button"><slot name="button-content">Share</slot></button></slot>
`;
var $cd62c5572235e737$export$30b344bef3e55b67 = class a extends HTMLElement {
    #e;
    #t;
    #r = [];
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open",
            delegatesFocus: !0
        }).appendChild($cd62c5572235e737$var$r.content.cloneNode(!0)), this.#e = this.shadowRoot?.querySelector('slot[name="button"]') || null, this.#t = this.#h();
    }
    static get observedAttributes() {
        return [
            "disabled"
        ];
    }
    attributeChangedCallback(t, e, i) {
        t === "disabled" && e !== i && this.#t && (this.#t.toggleAttribute("disabled", this.disabled), this.#t.setAttribute("aria-disabled", this.disabled.toString()), this.#t.part && this.#t.part.contains("button") && this.#t.part.toggle("button--disabled", this.disabled));
    }
    connectedCallback() {
        this.#s("shareUrl"), this.#s("shareTitle"), this.#s("shareText"), this.#s("shareFiles"), this.#s("disabled"), this.#e?.addEventListener("slotchange", this.#a), this.#t?.addEventListener("click", this.#i);
    }
    disconnectedCallback() {
        this.#e?.removeEventListener("slotchange", this.#a), this.#t?.removeEventListener("click", this.#i);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(t) {
        this.toggleAttribute("disabled", !!t);
    }
    get shareUrl() {
        return this.getAttribute("share-url") || "";
    }
    set shareUrl(t) {
        this.setAttribute("share-url", t);
    }
    get shareTitle() {
        return this.getAttribute("share-title") || "";
    }
    set shareTitle(t) {
        this.setAttribute("share-title", t);
    }
    get shareText() {
        return this.getAttribute("share-text") || "";
    }
    set shareText(t) {
        this.setAttribute("share-text", t);
    }
    get shareFiles() {
        return this.#r;
    }
    set shareFiles(t) {
        Array.isArray(t) && t.length > 0 && (this.#r = t);
    }
    async share() {
        if (!this.disabled) try {
            let t = {};
            this.shareUrl && (t.url = this.shareUrl), this.shareTitle && (t.title = this.shareTitle), this.shareText && (t.text = this.shareText), Array.isArray(this.shareFiles) && this.shareFiles.length > 0 && navigator.canShare && navigator.canShare({
                files: this.shareFiles
            }) && (t.files = this.shareFiles), await navigator.share(t), this.dispatchEvent(new CustomEvent("web-share:success", {
                bubbles: !0,
                composed: !0,
                detail: {
                    shareData: t
                }
            }));
        } catch (t) {
            if (t instanceof Error && t.name === "AbortError") {
                this.dispatchEvent(new CustomEvent("web-share:abort", {
                    bubbles: !0,
                    composed: !0,
                    detail: {
                        error: t
                    }
                }));
                return;
            }
            this.dispatchEvent(new CustomEvent("web-share:error", {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: t
                }
            }));
        }
    }
    #i = (t)=>{
        t.preventDefault(), !this.disabled && this.share();
    };
    #a = (t)=>{
        t.target && t.target.name === "button" && (this.#t?.removeEventListener("click", this.#i), this.#t = this.#h(), this.#t && (this.#t.addEventListener("click", this.#i), this.#t.nodeName !== "BUTTON" && !this.#t.hasAttribute("role") && this.#t.setAttribute("role", "button")));
    };
    #h() {
        return this.#e && this.#e.assignedElements({
            flatten: !0
        }).find((t)=>t.nodeName === "BUTTON" || t.getAttribute("slot") === "button") || null;
    }
    #s(t) {
        let e = this;
        if (Object.prototype.hasOwnProperty.call(e, t)) {
            let i = e[t];
            delete e[t], e[t] = i;
        }
    }
    static defineCustomElement(t = "web-share") {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, a);
    }
};
$cd62c5572235e737$export$30b344bef3e55b67.defineCustomElement();


/*!
 * @georapbox/modal-element
 * A custom element to create a modal, using the native dialog element under the hood.
 *
 * @version 1.9.1
 * @homepage https://github.com/georapbox/modal-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $d9c5053bade2d3f8$var$a = document.createElement("template"), $d9c5053bade2d3f8$var$r = `
  :host {
    --me-width: 32rem;
    --me-height: fit-content;
    --me-border-color: initial;
    --me-border-style: solid;
    --me-border-width: initial;
    --me-border-radius: 0;
    --me-box-shadow: none;
    --me-background-color: canvas;
    --me-color: canvastext;

    --me-header-spacing: 1rem;
    --me-footer-spacing: 1rem;
    --me-header-background-color: transparent;
    --me-header-color: initial;

    --me-body-spacing: 1rem;
    --me-body-background-color: transparent;
    --me-body-color: initial;
    --me-footer-background-color: transparent;
    --me-footer-color: initial;

    --me-close-padding: 0.4375rem;
    --me-close-border: none;
    --me-close-border-radius: 0;
    --me-close-background-color: transparent;
    --me-close-color: inherit;
    --me-close-font-size: 1rem;

    --me-backdrop-background: rgba(0, 0, 0, 0.5);
    --me-backdrop-filter: none;

    display: contents;
    box-sizing: border-box;
  }

  :host *,
  :host *:after,
  :host *:before {
    box-sizing: inherit;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  /* Dialog */
  .dialog {
    --dialog-placement-margin: calc((2em + 6px) / 2);

    width: var(--me-width);
    height: var(--me-height);
    padding: 0;
    border-color: var(--me-border-color);
    border-style: var(--me-border-style);
    border-width: var(--me-border-width);
    border-radius: var(--me-border-radius);
    box-shadow: var(--me-box-shadow);
    background-color: var(--me-background-color);
    color: var(--me-color);
  }

  .dialog[open] {
    display: flex;
  }

  :host([fullscreen]) .dialog {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
  }

  .dialog::backdrop {
    background: var(--me-backdrop-background, rgba(0, 0, 0, 0.5));
    backdrop-filter: var(--me-backdrop-filter, none);
    opacity: 0;
  }

  .dialog[open]::backdrop {
    opacity: 1;
  }

  /* Dialog placement */
  :host(:not([fullscreen])[placement="top-start"]) .dialog {
    margin-block-start: var(--dialog-placement-margin);
    margin-inline-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="top-center"]) .dialog {
    margin-block-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="top-end"]) .dialog {
    margin-block-start: var(--dialog-placement-margin);
    margin-inline-end: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="center-start"]) .dialog {
    margin-inline-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="center"]) .dialog {
    margin: auto;
  }

  :host(:not([fullscreen])[placement="center-end"]) .dialog {
    margin-inline-end: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="bottom-start"]) .dialog {
    margin-block-end: var(--dialog-placement-margin);
    margin-inline-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="bottom-center"]) .dialog {
    margin-block-end: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="bottom-end"]) .dialog {
    margin-block-end: var(--dialog-placement-margin);
    margin-inline-end: var(--dialog-placement-margin);
  }

  /* Dialog animations */
  @media (prefers-reduced-motion: no-preference) {
    .dialog:not(.dialog--no-animations),
    .dialog:not(.dialog--no-animations)::backdrop {
      transition: transform 0.3s, opacity 0.3s, display 0.3s allow-discrete, overlay 0.3s allow-discrete;
    }

    /* 1. IS-OPEN STATE */
    .dialog[open]:not(.dialog--no-animations) {
      transform: scale(1);
      opacity: 1;
    }

    /* 2. EXIT STATE */
    .dialog:not(.dialog--no-animations) {
      transform: scale(0.95);
      opacity: 0;
    }

    /* 0. BEFORE-OPEN STATE */
    @starting-style {
      .dialog[open]:not(.dialog--no-animations) {
        transform: scale(0.95);
        opacity: 0;
      }

      .dialog[open]:not(.dialog--no-animations)::backdrop {
        opacity: 0;
      }
    }

    .dialog--pulse:not(.dialog--no-animations) {
      animation-name: pulse;
      animation-duration: 300ms;
      animation-timing-function: cubic-bezier(0.2, 0, 0.38, 0.9);
    }

    @keyframes pulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.02); }
      100% { transform: scale(1); }
    }
  }

  /* Dialog panel, header, body, footer */
  .dialog__panel {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    width: 100%;
  }

  .dialog__header {
    display: flex;
    align-items: center;
    padding: var(--me-header-spacing);
    column-gap: 0.5rem;
    background-color: var(--me-header-background-color);
    color: var(--me-header-color);
  }

  :host([no-close-button]) .dialog__header {
    column-gap: 0;
  }

  .dialog__title {
    display: block;
    flex: 1 1 auto;
    padding: 0;
    margin: 0;
  }

  .dialog__body {
    display: block;
    flex: 1 1 auto;
    padding: var(--me-body-spacing);
    overflow: auto;
    background-color: var(--me-body-background-color);
    color: var(--me-body-color);
    overscroll-behavior: contain;
  }

  .dialog__footer {
    flex: 0 0 auto;
    text-align: end;
    padding: var(--me-footer-spacing);
    background-color: var(--me-footer-background-color);
    color: var(--me-footer-color);
  }

  .dialog__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: var(--me-close-padding);
    border: var(--me-close-border);
    border-radius: var(--me-close-border-radius);
    background-color: var(--me-close-background-color);
    color: var(--me-close-color);
    font-size: var(--me-close-font-size);
  }

  .dialog__close:not(:disabled) {
    cursor: pointer;
  }

  .dialog__close:disabled {
    cursor: not-allowed;
  }
`;
$d9c5053bade2d3f8$var$a.innerHTML = `
  <style>${$d9c5053bade2d3f8$var$r}</style>

  <dialog part="base" class="dialog">
    <div part="panel" class="dialog__panel" aria-labelledby="title">
      <header part="header" class="dialog__header">
        <slot name="header" part="title" class="dialog__title" id="title"></slot>

        <form method="dialog">
          <button type="submit" part="close" class="dialog__close" aria-label="Close">
            <slot name="close">
              <svg part="close-icon" xmlns="http://www.w3.org/2000/svg" width="1.125em" height="1.125em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </slot>
          </button>
        </form>
      </header>

      <slot part="body" class="dialog__body"></slot>

      <footer part="footer" class="dialog__footer" hidden>
        <slot name="footer"></slot>
      </footer>
    </div>
  </dialog>
`;
var $d9c5053bade2d3f8$export$32589115725b904b = class s extends HTMLElement {
    #e = null;
    #a = null;
    #s = null;
    #o = void 0;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($d9c5053bade2d3f8$var$a.content.cloneNode(!0)), this.shadowRoot && (this.#e = this.shadowRoot.querySelector("dialog"), this.#a = this.shadowRoot.querySelector('slot[name="footer"]'), this.#s = this.shadowRoot.querySelector('slot[name="close"]'));
    }
    static get observedAttributes() {
        return [
            "open",
            "no-header",
            "no-animations",
            "no-close-button",
            "close-label"
        ];
    }
    attributeChangedCallback(e, t, i) {
        if (this.#e !== null) {
            if (e === "open" && t !== i && (this.open ? (this.#e.showModal(), this.dispatchEvent(new CustomEvent("me-open", {
                bubbles: !0,
                composed: !0,
                detail: {
                    element: this
                }
            })), document.body && !this.preserveOverflow && (document.body.style.overflow = "hidden")) : this.#e.close()), e === "no-header" && t !== i) {
                let o = this.#e.querySelector(".dialog__header");
                o !== null && (o.hidden = this.noHeader);
            }
            if (e === "no-animations" && t !== i && this.#e.classList.toggle("dialog--no-animations", this.noAnimations), e === "no-close-button" && t !== i) {
                let o = this.#e.querySelector(".dialog__close");
                o !== null && (o.hidden = this.noCloseButton);
            }
            e === "close-label" && t !== i && this.#r();
        }
    }
    connectedCallback() {
        this.#t("open"), this.#t("staticBackdrop"), this.#t("noHeader"), this.#t("noAnimations"), this.#t("noCloseButton"), this.#t("fullscreen"), this.#t("preserveOverflow"), this.#t("placement"), this.#t("closeLabel"), this.#e?.addEventListener("click", this.#h), this.#e?.addEventListener("close", this.#l), this.#e?.addEventListener("cancel", this.#d), this.#e?.querySelector('form[method="dialog"]')?.addEventListener("submit", this.#c), this.#a?.addEventListener("slotchange", this.#g), this.#s?.addEventListener("slotchange", this.#u), this.addEventListener("command", this.#m);
    }
    disconnectedCallback() {
        this.#o && clearTimeout(this.#o), this.#e?.removeEventListener("click", this.#h), this.#e?.removeEventListener("close", this.#l), this.#e?.removeEventListener("cancel", this.#d), this.#e?.querySelector('form[method="dialog"]')?.removeEventListener("submit", this.#c), this.#a?.removeEventListener("slotchange", this.#g), this.#s?.removeEventListener("slotchange", this.#u), this.removeEventListener("command", this.#m);
    }
    get open() {
        return this.hasAttribute("open");
    }
    set open(e) {
        this.toggleAttribute("open", !!e);
    }
    get staticBackdrop() {
        return this.hasAttribute("static-backdrop");
    }
    set staticBackdrop(e) {
        this.toggleAttribute("static-backdrop", !!e);
    }
    get noHeader() {
        return this.hasAttribute("no-header");
    }
    set noHeader(e) {
        this.toggleAttribute("no-header", !!e);
    }
    get noAnimations() {
        return this.hasAttribute("no-animations");
    }
    set noAnimations(e) {
        this.toggleAttribute("no-animations", !!e);
    }
    get noCloseButton() {
        return this.hasAttribute("no-close-button");
    }
    set noCloseButton(e) {
        this.toggleAttribute("no-close-button", !!e);
    }
    get fullscreen() {
        return this.hasAttribute("fullscreen");
    }
    set fullscreen(e) {
        this.toggleAttribute("fullscreen", !!e);
    }
    get preserveOverflow() {
        return this.hasAttribute("preserve-overflow");
    }
    set preserveOverflow(e) {
        this.toggleAttribute("preserve-overflow", !!e);
    }
    get placement() {
        return this.getAttribute("placement") || "center";
    }
    set placement(e) {
        this.setAttribute("placement", e != null ? e.toString() : e);
    }
    get closeLabel() {
        return this.getAttribute("close-label") || "Close";
    }
    set closeLabel(e) {
        this.setAttribute("close-label", e != null ? e.toString() : e);
    }
    #r() {
        if (this.#e === null) return;
        let e = this.#e.querySelector(".dialog__close");
        if (e === null) return;
        (this.#s?.assignedElements() || [])?.some((o)=>o.textContent?.replace(/\s/g, "") !== "") ? e.removeAttribute("aria-label") : e.setAttribute("aria-label", this.closeLabel);
    }
    #i() {
        this.#o || (this.#e?.classList.add("dialog--pulse"), this.#o = setTimeout(()=>{
            this.#e?.classList.remove("dialog--pulse"), clearTimeout(this.#o), this.#o = void 0;
        }, 300));
    }
    #l = ()=>{
        this.open = !1, this.dispatchEvent(new CustomEvent("me-close", {
            bubbles: !0,
            composed: !0,
            detail: {
                element: this
            }
        })), document.body && !this.preserveOverflow && (document.body.style.overflow = "");
    };
    #d = (e)=>{
        let t = this.#n("escape-key");
        this.dispatchEvent(t), t.defaultPrevented && (e.preventDefault(), !this.noAnimations && this.#i());
    };
    #c = (e)=>{
        let t = this.#n("close-button");
        this.dispatchEvent(t), t.defaultPrevented && (e.preventDefault(), !this.noAnimations && this.#i());
    };
    #h = (e)=>{
        let t = e.target, i = e.currentTarget;
        if (t === i) {
            let o = this.#n("backdrop-click");
            this.dispatchEvent(o), o.defaultPrevented || this.staticBackdrop ? !this.noAnimations && this.#i() : this.hide();
        }
        if (t instanceof HTMLElement && t.closest("[data-me-close]") !== null) {
            let o = this.#n("external-invoker");
            this.dispatchEvent(o), o.defaultPrevented ? !this.noAnimations && this.#i() : this.hide();
        }
    };
    #m = (e)=>{
        if (e.command === "--me-open" && !this.open && this.show(), e.command === "--me-close" && this.open) {
            let t = this.#n("external-invoker");
            this.dispatchEvent(t), t.defaultPrevented ? !this.noAnimations && this.#i() : this.hide();
        }
    };
    #g = ()=>{
        if (this.#e === null) return;
        let e = this.#e.querySelector(".dialog__footer");
        if (e === null) return;
        let t = this.#a?.assignedNodes(), i = t ? t.length > 0 : !1;
        e.hidden = !i;
    };
    #u = ()=>{
        this.#r();
    };
    #n(e) {
        return new CustomEvent("me-request-close", {
            bubbles: !0,
            composed: !0,
            cancelable: !0,
            detail: {
                reason: e,
                element: this
            }
        });
    }
    #t(e) {
        let t = this;
        if (Object.prototype.hasOwnProperty.call(t, e)) {
            let i = t[e];
            delete t[e], t[e] = i;
        }
    }
    show() {
        this.open || (this.open = !0);
    }
    hide() {
        this.open && (this.open = !1);
    }
    static defineCustomElement(e = "modal-element") {
        typeof window < "u" && !window.customElements.get(e) && window.customElements.define(e, s);
    }
};
$d9c5053bade2d3f8$export$32589115725b904b.defineCustomElement();


/*!
 * @georapbox/files-dropzone-element
 * A custom element that creates a drag and drop zone for files
 *
 * @version 2.1.1
 * @homepage https://github.com/georapbox/files-dropzone-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ function $9351176e8d763a78$var$h(o, e = "") {
    if (!e) return !0;
    let t = [
        ...new Set(e.split(",").map((r)=>r.trim()).filter(Boolean))
    ], i = o.type, s = i.replace(/\/.*$/, "");
    for (let r of t)if (r.charAt(0) === ".") {
        if (o.name.toLowerCase().indexOf(r.toLowerCase(), o.name.length - r.length) !== -1) return !0;
    } else if (/\/\*$/.test(r)) {
        if (s === r.replace(/\/.*$/, "")) return !0;
    } else if (i === r) return !0;
    return !1;
}
var $9351176e8d763a78$var$E = new Map([
    [
        "aac",
        "audio/aac"
    ],
    [
        "abw",
        "application/x-abiword"
    ],
    [
        "arc",
        "application/x-freearc"
    ],
    [
        "avif",
        "image/avif"
    ],
    [
        "avi",
        "video/x-msvideo"
    ],
    [
        "azw",
        "application/vnd.amazon.ebook"
    ],
    [
        "bin",
        "application/octet-stream"
    ],
    [
        "bmp",
        "image/bmp"
    ],
    [
        "bz",
        "application/x-bzip"
    ],
    [
        "bz2",
        "application/x-bzip2"
    ],
    [
        "cda",
        "application/x-cdf"
    ],
    [
        "csh",
        "application/x-csh"
    ],
    [
        "css",
        "text/css"
    ],
    [
        "csv",
        "text/csv"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    [
        "eot",
        "application/vnd.ms-fontobject"
    ],
    [
        "epub",
        "application/epub+zip"
    ],
    [
        "gz",
        "application/gzip"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "heic",
        "image/heic"
    ],
    [
        "heif",
        "image/heif"
    ],
    [
        "htm",
        "text/html"
    ],
    [
        "html",
        "text/html"
    ],
    [
        "ico",
        "image/vnd.microsoft.icon"
    ],
    [
        "ics",
        "text/calendar"
    ],
    [
        "jar",
        "application/java-archive"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "jxl",
        "image/jxl"
    ],
    [
        "js",
        "text/javascript"
    ],
    [
        "json",
        "application/json"
    ],
    [
        "jsonld",
        "application/ld+json"
    ],
    [
        "markdown",
        "text/markdown"
    ],
    [
        "md",
        "text/markdown"
    ],
    [
        "mid",
        "audio/midi"
    ],
    [
        "midi",
        "audio/midi"
    ],
    [
        "mjs",
        "text/javascript"
    ],
    [
        "mp3",
        "audio/mpeg"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "mpeg",
        "video/mpeg"
    ],
    [
        "mpkg",
        "application/vnd.apple.installer+xml"
    ],
    [
        "odp",
        "application/vnd.oasis.opendocument.presentation"
    ],
    [
        "ods",
        "application/vnd.oasis.opendocument.spreadsheet"
    ],
    [
        "odt",
        "application/vnd.oasis.opendocument.text"
    ],
    [
        "oga",
        "audio/ogg"
    ],
    [
        "ogv",
        "video/ogg"
    ],
    [
        "ogx",
        "application/ogg"
    ],
    [
        "opus",
        "audio/opus"
    ],
    [
        "otf",
        "font/otf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "php",
        "application/x-httpd-php"
    ],
    [
        "ppt",
        "application/vnd.ms-powerpoint"
    ],
    [
        "pptx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    [
        "rar",
        "application/vnd.rar"
    ],
    [
        "rtf",
        "application/rtf"
    ],
    [
        "sh",
        "application/x-sh"
    ],
    [
        "svg",
        "image/svg+xml"
    ],
    [
        "swf",
        "application/x-shockwave-flash"
    ],
    [
        "tar",
        "application/x-tar"
    ],
    [
        "tif",
        "image/tiff"
    ],
    [
        "tiff",
        "image/tiff"
    ],
    [
        "ts",
        "video/mp2t"
    ],
    [
        "ttf",
        "font/ttf"
    ],
    [
        "txt",
        "text/plain"
    ],
    [
        "vsd",
        "application/vnd.visio"
    ],
    [
        "wav",
        "audio/wav"
    ],
    [
        "weba",
        "audio/webm"
    ],
    [
        "webm",
        "video/webm"
    ],
    [
        "webp",
        "image/webp"
    ],
    [
        "woff",
        "font/woff"
    ],
    [
        "woff2",
        "font/woff2"
    ],
    [
        "xhtml",
        "application/xhtml+xml"
    ],
    [
        "xls",
        "application/vnd.ms-excel"
    ],
    [
        "xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    [
        "xml",
        "application/xml"
    ],
    [
        "xul",
        "application/vnd.mozilla.xul+xml"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "7z",
        "application/x-7z-compressed"
    ],
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "msg",
        "application/vnd.ms-outlook"
    ]
]), $9351176e8d763a78$var$f = [
    ".DS_Store",
    "Thumbs.db"
], $9351176e8d763a78$var$z = (o)=>{
    let { name: e } = o;
    if (e && e.lastIndexOf(".") !== -1 && !o.type) {
        let i = (e.split(".").pop() || "").toLowerCase(), s = $9351176e8d763a78$var$E.get(i);
        s && Object.defineProperty(o, "type", {
            value: s,
            writable: !1,
            configurable: !1,
            enumerable: !0
        });
    }
    return o;
}, $9351176e8d763a78$var$g = (o, e)=>{
    let t = $9351176e8d763a78$var$z(o);
    if (typeof t.path != "string") {
        let { webkitRelativePath: i } = o;
        Object.defineProperty(t, "path", {
            value: typeof e == "string" ? e : i || o.name,
            writable: !1,
            configurable: !1,
            enumerable: !0
        });
    }
    return t;
}, $9351176e8d763a78$var$u = async (o)=>await new Promise((e, t)=>{
        o.readEntries(e, t);
    }), $9351176e8d763a78$var$x = async (o)=>{
    let e = [], t = await $9351176e8d763a78$var$u(o);
    for(; t.length > 0;)e.push(...t), t = await $9351176e8d763a78$var$u(o);
    return e;
}, $9351176e8d763a78$var$y = (o)=>new Promise((e, t)=>{
        o.file((i)=>e($9351176e8d763a78$var$g(i, o.fullPath)), t);
    }), $9351176e8d763a78$var$w = async (o)=>{
    let e = [], t = [];
    for (let i of o){
        if (i.kind !== "file") continue;
        let s = i.getAsEntry ? i.getAsEntry() : i.webkitGetAsEntry();
        t.push(s);
    }
    for(; t.length > 0;){
        let i = t.shift();
        if (i) {
            if (i.isFile) {
                let s = await $9351176e8d763a78$var$y(i);
                $9351176e8d763a78$var$f.indexOf(s.name) === -1 && e.push(s);
            } else i.isDirectory && t.push(...await $9351176e8d763a78$var$x(i.createReader()));
        } else continue;
    }
    return e;
}, $9351176e8d763a78$var$m = async (o)=>{
    let e = [];
    for (let t of o)$9351176e8d763a78$var$f.indexOf(t.name) === -1 && e.push($9351176e8d763a78$var$g(t));
    return e;
}, $9351176e8d763a78$var$d = async (o)=>o.dataTransfer ? o.dataTransfer.items ? await $9351176e8d763a78$var$w(o.dataTransfer.items) : await $9351176e8d763a78$var$m(o.dataTransfer.files) : await $9351176e8d763a78$var$m(o.target.files);
var $9351176e8d763a78$var$O = String.raw, $9351176e8d763a78$var$L = String.raw, $9351176e8d763a78$var$b = "files-dropzone", $9351176e8d763a78$var$v = document.createElement("template"), $9351176e8d763a78$var$F = $9351176e8d763a78$var$O`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  :host {
    --dropzone-border-width: 2px;
    --dropzone-border-style: dashed;
    --dropzone-border-radius: 0.25rem;
    --dropzone-border-color: #6c757d;
    --dropzone-border-color-dragover: #0d6efd;
    --dropzone-border-color-hover: var(--dropzone-border-color-dragover);
    --dropzone-background-color: #ffffff;
    --dropzone-background-color-dragover: #f4f4f5;
    --dropzone-background-color-hover: var(--dropzone-background-color-dragover);
    --dropzone-body-color: #3f3f46;
    --dropzone-body-color-dragover: var(--dropzone-body-color);
    --dropzone-body-color-hover: var(--dropzone-body-color-dragover);
    --dropzone-focus-shadow-rgb: 49, 132, 253;
    --dropzone-focus-box-shadow: 0 0 0 0.25rem rgba(var(--dropzone-focus-shadow-rgb), 0.5);
    --transition-duration: 0.2s; /* for backwards compatibility */
    --dropzone-transition-duration: var(--transition-duration);

    display: block;
  }

  :host(:not([no-style])) .dropzone {
    border: var(--dropzone-border-width) var(--dropzone-border-style) var(--dropzone-border-color);
    border-radius: var(--dropzone-border-radius);
    padding: 3rem 1rem;
    overflow: hidden;
    background-color: var(--dropzone-background-color);
    color: var(--dropzone-body-color);
    text-align: center;
    cursor: pointer;
    transition:
      border var(--dropzone-transition-duration) ease-in-out,
      background-color var(--dropzone-transition-duration) ease-in-out,
      color var(--dropzone-transition-duration) ease-in-out,
      box-shadow var(--dropzone-transition-duration) ease-in-out;
  }

  :host(:not([no-style])[disabled]) .dropzone {
    opacity: 0.8;
    cursor: not-allowed;
    user-select: none;
  }

  :host(:not([no-style]):not([disabled])) .dropzone--dragover {
    border-color: var(--dropzone-border-color-dragover);
    background-color: var(--dropzone-background-color-dragover);
    color: var(--dropzone-body-color-dragover);
  }

  :host(:not([no-style]):not([disabled])) .dropzone:focus-visible {
    outline: none;
    box-shadow: var(--dropzone-focus-box-shadow);
  }

  @media (hover: hover) {
    :host(:not([no-style]):not([disabled])) .dropzone:not(.dropzone--dragover):hover {
      border-color: var(--dropzone-border-color-hover);
      background-color: var(--dropzone-background-color-hover);
      color: var(--dropzone-body-color-hover);
    }
  }
`;
$9351176e8d763a78$var$v.innerHTML = $9351176e8d763a78$var$L`
  <style>
    ${$9351176e8d763a78$var$F}
  </style>

  <input type="file" id="file-input" hidden />

  <div part="dropzone" class="dropzone" id="dropzone" tabindex="0" role="button" aria-disabled="false">
    <slot><span>Drag 'n' drop files here, or click to select files</span></slot>
  </div>
`;
var $9351176e8d763a78$export$6ccd1735166caad9 = class o extends HTMLElement {
    static ERROR_CODES = {
        FILE_DIALOG_OPEN_FAILED: "FILE_DIALOG_OPEN_FAILED",
        FILE_INPUT_CHANGE_FAILED: "FILE_INPUT_CHANGE_FAILED",
        DROP_EVENT_PROCESSING_FAILED: "DROP_EVENT_PROCESSING_FAILED",
        UNKNOWN_ERROR: "UNKNOWN_ERROR"
    };
    static REJECTION_CODES = {
        TOO_MANY_FILES: "TOO_MANY_FILES",
        FILE_TOO_LARGE: "FILE_TOO_LARGE",
        FILE_TOO_SMALL: "FILE_TOO_SMALL",
        INVALID_MIME_TYPE: "INVALID_MIME_TYPE"
    };
    #t = null;
    #e = null;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open",
            delegatesFocus: !0
        }).appendChild($9351176e8d763a78$var$v.content.cloneNode(!0)), this.shadowRoot && (this.#t = this.shadowRoot.getElementById("file-input"), this.#e = this.shadowRoot.getElementById("dropzone"));
    }
    static get observedAttributes() {
        return [
            "accept",
            "disabled",
            "multiple"
        ];
    }
    attributeChangedCallback(e, t, i) {
        e === "accept" && t !== i && this.#t && (this.#t.accept = this.accept), e === "disabled" && t !== i && this.#t && (this.#t.disabled = this.disabled, this.disabled ? (this.#e?.removeAttribute("tabindex"), this.#e?.setAttribute("aria-disabled", "true")) : (this.#e?.setAttribute("tabindex", "0"), this.#e?.setAttribute("aria-disabled", "false"))), e === "multiple" && t !== i && this.#t && (this.#t.multiple = this.multiple);
    }
    connectedCallback() {
        this.#o("accept"), this.#o("disabled"), this.#o("maxFiles"), this.#o("maxSize"), this.#o("minSize"), this.#o("multiple"), this.#o("autoFocus"), this.#o("noStyle"), this.#t?.addEventListener("change", this.#s), this.#e?.addEventListener("dragenter", this.#n), this.#e?.addEventListener("dragover", this.#a), this.#e?.addEventListener("dragleave", this.#d), this.#e?.addEventListener("drop", this.#l), this.#e?.addEventListener("click", this.#c), this.#e?.addEventListener("keyup", this.#p), this.autoFocus && this.#e?.focus();
    }
    disconnectedCallback() {
        this.#t?.removeEventListener("change", this.#s), this.#e?.removeEventListener("dragenter", this.#n), this.#e?.removeEventListener("dragover", this.#a), this.#e?.removeEventListener("dragleave", this.#d), this.#e?.removeEventListener("drop", this.#l), this.#e?.removeEventListener("click", this.#c), this.#e?.removeEventListener("keyup", this.#p);
    }
    get accept() {
        return this.getAttribute("accept") || "";
    }
    set accept(e) {
        this.setAttribute("accept", e != null ? e.toString() : e);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(e) {
        this.toggleAttribute("disabled", !!e);
    }
    get maxFiles() {
        let e = Number(this.getAttribute("max-files")) || 0;
        return e <= 0 ? 1 / 0 : Math.floor(Math.abs(e));
    }
    set maxFiles(e) {
        this.setAttribute("max-files", e != null ? e.toString() : e);
    }
    get maxSize() {
        let e = this.getAttribute("max-size");
        if (e === null) return 1 / 0;
        let t = Number(e);
        return Number.isNaN(t) ? 1 / 0 : t;
    }
    set maxSize(e) {
        this.setAttribute("max-size", e != null ? e.toString() : e);
    }
    get minSize() {
        let e = this.getAttribute("min-size");
        if (e === null) return 0;
        let t = Number(e);
        return Number.isNaN(t) ? 0 : t;
    }
    set minSize(e) {
        this.setAttribute("min-size", e != null ? e.toString() : e);
    }
    get multiple() {
        return this.hasAttribute("multiple");
    }
    set multiple(e) {
        this.toggleAttribute("multiple", !!e);
    }
    get autoFocus() {
        return this.hasAttribute("auto-focus");
    }
    set autoFocus(e) {
        this.toggleAttribute("auto-focus", !!e);
    }
    get noStyle() {
        return this.hasAttribute("no-style");
    }
    set noStyle(e) {
        this.toggleAttribute("no-style", !!e);
    }
    #i(e, t, i) {
        let s = {
            bubbles: !0,
            composed: !0,
            cancelable: !1,
            ...i,
            detail: t
        }, r = new CustomEvent(`${$9351176e8d763a78$var$b}-${e}`, s);
        return this.dispatchEvent(r);
    }
    #r(e, t) {
        let i = {
            code: e,
            error: t
        };
        this.#i("error", i);
    }
    #s = async (e)=>{
        try {
            this.#h(await $9351176e8d763a78$var$d(e));
        } catch (t) {
            this.#r(o.ERROR_CODES.FILE_INPUT_CHANGE_FAILED, t);
        }
    };
    #n = ()=>{
        this.disabled || this.#i("dragenter");
    };
    #a = (e)=>{
        if (e.preventDefault(), this.disabled) {
            e.dataTransfer.dropEffect = "none";
            return;
        }
        e.dataTransfer.dropEffect = "copy", this.#e && (this.#e.classList.add("dropzone--dragover"), this.#e.part.add("dropzone--dragover")), this.#i("dragover");
    };
    #d = ()=>{
        this.disabled || (this.#e && (this.#e.classList.remove("dropzone--dragover"), this.#e.part.remove("dropzone--dragover")), this.#i("dragleave"));
    };
    #l = async (e)=>{
        if (!this.disabled) {
            e.preventDefault(), this.#e && (this.#e.classList.remove("dropzone--dragover"), this.#e.part.remove("dropzone--dragover"));
            try {
                this.#h(await $9351176e8d763a78$var$d(e));
            } catch (t) {
                this.#r(o.ERROR_CODES.DROP_EVENT_PROCESSING_FAILED, t);
            }
        }
    };
    #c = ()=>{
        this.disabled || this.openFileDialog();
    };
    #p = (e)=>{
        this.disabled || (e.key === " " || e.key === "Enter") && this.openFileDialog();
    };
    #h(e) {
        if (!Array.isArray(e) || !e.length) return;
        let t = [], i = [], s = e.length;
        if (!this.multiple && s > 1) for (let r of e)i.push({
            file: r,
            errors: [
                {
                    code: o.REJECTION_CODES.TOO_MANY_FILES,
                    message: "Too many files selected. Only 1 file is allowed."
                }
            ]
        });
        else if (this.multiple && s > this.maxFiles) for (let r of e)i.push({
            file: r,
            errors: [
                {
                    code: o.REJECTION_CODES.TOO_MANY_FILES,
                    message: `Too many files selected. Only ${this.maxFiles} ${this.maxFiles > 1 ? "files are" : "file is"} allowed.`
                }
            ]
        });
        else for (let r of e){
            let l = $9351176e8d763a78$var$h(r, this.accept), c = r.size > this.maxSize, p = r.size < this.minSize;
            if (l && !c && !p) t.push(r);
            else {
                let n = [];
                l || n.push({
                    code: o.REJECTION_CODES.INVALID_MIME_TYPE,
                    message: `File type "${r.type}" is not accepted.`
                }), c && n.push({
                    code: o.REJECTION_CODES.FILE_TOO_LARGE,
                    message: `File size ${r.size} exceeds the maximum size of ${this.maxSize}.`
                }), p && n.push({
                    code: o.REJECTION_CODES.FILE_TOO_SMALL,
                    message: `File size ${r.size} is smaller than the minimum size of ${this.minSize}.`
                }), i.push({
                    file: r,
                    errors: n
                });
            }
        }
        this.#i("drop", {
            acceptedFiles: t,
            rejectedFiles: i
        }), t.length > 0 && this.#i("drop-accepted", {
            acceptedFiles: t
        }), i.length > 0 && this.#i("drop-rejected", {
            rejectedFiles: i
        }), this.#t && (this.#t.value = this.#t.defaultValue);
    }
    openFileDialog() {
        if (!(this.disabled || !this.#t)) {
            if ("showPicker" in HTMLInputElement.prototype && typeof this.#t.showPicker == "function") {
                try {
                    this.#t.showPicker();
                } catch (e) {
                    this.#r(o.ERROR_CODES.FILE_DIALOG_OPEN_FAILED, e);
                }
                return;
            }
            this.#t.click();
        }
    }
    #o(e) {
        let t = this;
        if (Object.prototype.hasOwnProperty.call(t, e)) {
            let i = t[e];
            delete t[e], t[e] = i;
        }
    }
    static defineCustomElement(e = $9351176e8d763a78$var$b) {
        typeof window < "u" && !window.customElements.get(e) && window.customElements.define(e, o);
    }
};
$9351176e8d763a78$export$6ccd1735166caad9.defineCustomElement();




const $65136e012e05e2d7$export$63e7bed68b07a85c = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'image/apng',
    'image/gif',
    'image/webp',
    'image/avif'
];
const $65136e012e05e2d7$export$62045be72fe457b4 = 20;
const $65136e012e05e2d7$export$8f089f0a062560ff = 20;
const $65136e012e05e2d7$export$d3f4819a57998cf7 = 360;


/**
 * Generates a unique id of the form `${prefix}-${randomString}-${suffix}`.
 *
 * @param {string} [prefix=''] - The prefix to use for the id.
 * @param {string} [suffix=''] - The suffix to use for the id.
 * @returns {string} - The unique id.
 */ const $17004b28c97c1306$export$e2a22331486dcca0 = (prefix = '', suffix = '')=>{
    const prefixString = typeof prefix === 'string' && prefix !== '' ? prefix + '-' : '';
    const suffixString = typeof suffix === 'string' && suffix !== '' ? '-' + suffix : '';
    const randomString = Math.random().toString(36).substring(2, 8); // Pseudo-random string of six alphanumeric characters.
    return `${prefixString}${randomString}${suffixString}`;
};



const $2669cb7c28251d2a$export$6539e087749cf9d3 = async (options = {})=>{
    const res = await fetch(options.url);
    const blob = await res.blob();
    const mimeType = options.mimeType || blob.type || '';
    if (!(0, $65136e012e05e2d7$export$63e7bed68b07a85c).includes(mimeType)) throw new Error(`This is not an accepted image format. Accepted MIME types are: ${(0, $65136e012e05e2d7$export$63e7bed68b07a85c).join(', ')}`);
    return new File([
        blob
    ], options.filename || '', blob);
};


/**
 * A class representing a storage utility for managing data in `localStorage` or `sessionStorage`.
 */ class $9e093dbdf49c6d51$export$bf2a15d34f3c441c {
    /**
   * The prefix to be added to all keys.
   *
   * @type {string}
   * @private
   */ #keyPrefix = null;
    /**
   * The storage provider (`localStorage` or `sessionStorage`).
   *
   * @type {Storage}
   * @private
   */ #provider = null;
    /**
   * Creates an instance of Storage.
   *
   * @param {string} prefix - The prefix to be added to all keys when storing/retrieving data.
   * @param {Storage} [provider=localStorage] - The storage provider (`localStorage` or `sessionStorage`).
   * @throws {Error} If prefix is not provided or if the provider is not supported.
   */ constructor(prefix, provider = localStorage){
        if (!prefix) throw new Error('Storage prefix is required');
        if (provider !== localStorage && provider !== sessionStorage) throw new Error('Storage provider is not supported');
        this.#keyPrefix = prefix;
        this.#provider = provider;
    }
    /**
   * Sets a key-value pair in the storage.
   *
   * @param {string} key - The key for the data.
   * @param {*} value - The value to be stored (will be converted to JSON string).
   */ set(key, value) {
        try {
            this.#provider.setItem(`${this.#keyPrefix}${key}`, JSON.stringify(value));
        } catch (err) {
            console.error('Error saving to storage', err);
        }
    }
    /**
   * Retrieves the value associated with the given key from the storage.
   *
   * @param {string} key - The key to retrieve the value for.
   * @returns {*} The value associated with the key, or `null` if key is not found or an error occurs.
   */ get(key) {
        try {
            const value = this.#provider.getItem(`${this.#keyPrefix}${key}`);
            return value ? JSON.parse(value) : null;
        } catch (err) {
            console.error('Error getting from storage', err);
            return null;
        }
    }
}
const $9e093dbdf49c6d51$var$DEFAULT_STORAGE_PREFIX = 'meme-generator/';
const $9e093dbdf49c6d51$var$DEFAULT_STORAGE_PROVIDER = localStorage;
const $9e093dbdf49c6d51$export$ddcffe0146c8f882 = new $9e093dbdf49c6d51$export$bf2a15d34f3c441c($9e093dbdf49c6d51$var$DEFAULT_STORAGE_PREFIX, $9e093dbdf49c6d51$var$DEFAULT_STORAGE_PROVIDER);


const $c38b15b964e67d8b$export$de75f46579dcf24 = (selectedImage)=>{
    return typeof selectedImage === 'string';
};


var $4ce134d17b44ae18$exports = {};
$4ce134d17b44ae18$exports = $parcel$resolve("lRBOd");


var $4aac2f31d7cdbf2a$exports = {};
$4aac2f31d7cdbf2a$exports = $parcel$resolve("hOimC");


var $7047d5eb69770188$exports = {};
$7047d5eb69770188$exports = $parcel$resolve("c5nso");


var $50860fc9edc85a1e$exports = {};
$50860fc9edc85a1e$exports = $parcel$resolve("917SN");


var $ab9b02fed1d18789$exports = {};
$ab9b02fed1d18789$exports = $parcel$resolve("kCRYk");


var $9453a539ecff3153$exports = {};
$9453a539ecff3153$exports = $parcel$resolve("7mTjM");


var $2740691160ef63b7$exports = {};
$2740691160ef63b7$exports = $parcel$resolve("bNJU7");


var $d2dea0daed093658$exports = {};
$d2dea0daed093658$exports = $parcel$resolve("2zTNP");


var $abfbe5e1894df7bd$exports = {};
$abfbe5e1894df7bd$exports = $parcel$resolve("6U5us");


var $42aed72aaf921606$exports = {};
$42aed72aaf921606$exports = $parcel$resolve("jadM2");


var $1b830496d4af00a3$exports = {};
$1b830496d4af00a3$exports = $parcel$resolve("4rZHV");


const $56b863c8b6be7003$export$6874249d87f2602a = [
    {
        name: 'Pressuru',
        label: 'Pressuru',
        path: (0, (/*@__PURE__*/$parcel$interopDefault($4ce134d17b44ae18$exports))),
        style: 'normal',
        weight: '400'
    },
    {
        name: 'Oswald-Regular',
        label: 'Oswald',
        path: (0, (/*@__PURE__*/$parcel$interopDefault($4aac2f31d7cdbf2a$exports))),
        style: 'normal',
        weight: '400'
    },
    {
        name: 'Oswald-Bold',
        label: 'Oswald Bold',
        path: (0, (/*@__PURE__*/$parcel$interopDefault($7047d5eb69770188$exports))),
        style: 'normal',
        weight: '700'
    },
    {
        name: 'Roboto-Regular',
        label: 'Roboto',
        path: (0, (/*@__PURE__*/$parcel$interopDefault($50860fc9edc85a1e$exports))),
        style: 'normal',
        weight: '400'
    },
    {
        name: 'Roboto-Bold',
        label: 'Roboto Bold',
        path: (0, (/*@__PURE__*/$parcel$interopDefault($ab9b02fed1d18789$exports))),
        style: 'normal',
        weight: '700'
    },
    {
        name: 'RobotoCondensed-Regular',
        label: 'Roboto Condensed',
        path: (0, (/*@__PURE__*/$parcel$interopDefault($9453a539ecff3153$exports))),
        style: 'normal',
        weight: '400'
    },
    {
        name: 'RobotoCondensed-Bold',
        label: 'Roboto Condensed Bold',
        path: (0, (/*@__PURE__*/$parcel$interopDefault($2740691160ef63b7$exports))),
        style: 'normal',
        weight: '700'
    },
    {
        name: 'CourierPrime-Regular',
        label: 'Courier Prime',
        path: (0, (/*@__PURE__*/$parcel$interopDefault($d2dea0daed093658$exports))),
        style: 'normal',
        weight: '400'
    },
    {
        name: 'CourierPrime-Bold',
        label: 'Courier Prime Bold',
        path: (0, (/*@__PURE__*/$parcel$interopDefault($abfbe5e1894df7bd$exports))),
        style: 'normal',
        weight: '700'
    },
    {
        name: 'OpenSans-Regular',
        label: 'Open Sans',
        path: (0, (/*@__PURE__*/$parcel$interopDefault($42aed72aaf921606$exports))),
        style: 'normal',
        weight: '400'
    },
    {
        name: 'OpenSans-Bold',
        label: 'Open Sans Bold',
        path: (0, (/*@__PURE__*/$parcel$interopDefault($1b830496d4af00a3$exports))),
        style: 'normal',
        weight: '400'
    }
];
const $56b863c8b6be7003$export$59eceaef0c7797b2 = async (name, path, options = {})=>{
    try {
        const font = new FontFace(name, `url(${path})`, {
            ...options
        });
        await font.load();
        document.fonts.add(font);
    } catch (err) {
        console.error(err);
    }
};


const $3969451ff60cb8d5$var$errorsContainer = document.getElementById('errorsContainer');
const $3969451ff60cb8d5$var$hideError = (evt)=>{
    const target = evt.currentTarget;
    target.removeEventListener('click', $3969451ff60cb8d5$var$hideError);
    $3969451ff60cb8d5$var$errorsContainer.removeChild(target.parentNode);
};
const $3969451ff60cb8d5$export$af04143326425dbd = (message = '', type = 'info')=>{
    const types = [
        'info',
        'warning',
        'danger'
    ];
    if (!types.includes(type)) type = 'info';
    const template = /* html */ `
    ${message}
    <button type="button" class="btn-close" data-dismiss="alert" aria-label="Close"></button>
  `;
    const div = document.createElement('div');
    div.className = `alert alert-${type} alert-dismissible text-break mb-2 fade`;
    div.innerHTML = template;
    div.querySelector('button').addEventListener('click', $3969451ff60cb8d5$var$hideError);
    $3969451ff60cb8d5$var$errorsContainer.appendChild(div);
    setTimeout(()=>div.classList.add('show'), 100);
};





const $a5e4a78f80aa8693$var$defaultTextboxData = {
    id: '',
    text: '',
    fillColor: '#ffffff',
    strokeColor: '#000000',
    font: 'Pressuru',
    fontSize: 40,
    fontWeight: 'normal',
    textAlign: 'center',
    shadowBlur: 0,
    strokeWidth: 1.5,
    offsetY: 0,
    offsetX: 0,
    rotate: 0,
    allCaps: true,
    textBackgroundEnabled: false,
    textBackgroundColor: '#000000'
};
const $a5e4a78f80aa8693$var$textboxes = new Map();
class $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b {
    constructor(data){
        const id = (0, $17004b28c97c1306$export$e2a22331486dcca0)('textbox', Date.now().toString(36));
        this.data = data ? {
            ...data,
            id: id
        } : {
            ...$a5e4a78f80aa8693$var$defaultTextboxData,
            id: id
        };
        $a5e4a78f80aa8693$var$textboxes.set(id, this);
        document.dispatchEvent(new CustomEvent(`textbox-create`, {
            bubbles: true,
            composed: true,
            detail: {
                textbox: this
            }
        }));
    }
    getData() {
        return this.data;
    }
    static create(data) {
        return new $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b(data);
    }
    static getAll() {
        return $a5e4a78f80aa8693$var$textboxes;
    }
    static getById(id) {
        return $a5e4a78f80aa8693$var$textboxes.get(id);
    }
    static remove(id) {
        $a5e4a78f80aa8693$var$textboxes.delete(id);
        document.dispatchEvent(new CustomEvent(`textbox-remove`, {
            bubbles: true,
            composed: true,
            detail: {
                id: id
            }
        }));
    }
    static createElement(textbox, autoFocus = true) {
        if (!(textbox instanceof $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b)) return;
        const data = textbox.getData();
        const { id: id, text: text, fillColor: fillColor, strokeColor: strokeColor, fontSize: fontSize, shadowBlur: shadowBlur, strokeWidth: strokeWidth, offsetX: offsetX, offsetY: offsetY, rotate: rotate, textBackgroundColor: textBackgroundColor } = data;
        const template = /* html */ `
    <div class="d-flex align-items-center" data-section="basic-settings">
      <button type="button" class="btn btn-link" data-button="duplicate-text-box" title="Duplicate text box"></button>
      <button type="button" class="btn btn-link" data-button="delete-text-box" title="Remove text box"></button>

      <textarea class="form-control meme-text" type="text" data-input="text" autocomplete="off" rows="1" placeholder="${`Text #${$a5e4a78f80aa8693$var$textboxes.size}`}">${text}</textarea>

      <div class="d-flex align-items-center pe-2">
        <label for="fillColorInput" class="visually-hidden">Fill color</label>
        <input class="form-control" type="color" value="${fillColor}" id="fillColorInput_${id}" data-input="fillColor" title="Fill color">

        <label for="strokeColorInput" class="visually-hidden">Outline color</label>
        <input class="form-control" type="color" value="${strokeColor}" id="strokeColorInput_${id}" data-input="strokeColor" title="Outline color">

        <button type="button" class="btn btn-secondary settings-button" data-button="settings" title="Settings"></button>
      </div>
    </div>

    <div class="p-2" data-section="advanced-settings" hidden>
      <div class="row g-2">
        <div class="col-12">
          <details class="emoji-picker-details">
            <summary>Emoji picker</summary>
            <emoji-picker class="light"></emoji-picker>
          </details>
        </div>
      </div>

      <div class="row g-2">
        <div class="col-4 mb-3">
          <label for="fontInput_${id}" class="mb-1 d-block text-truncate">Font: </label>

          <select class="form-select" data-input="font" id="fontInput_${id}">
            <optgroup label="Web fonts">
              <option value="Impact">Impact</option>
              <option value="Arial">Arial</option>
              <option value="Arial Black">Arial Black</option>
              <option value="Helvetica">Helvetica</option>
              <option value="Comic Sans MS">Comic Sans MS</option>
              <option value="Times">Times</option>
              <option value="Times New Roman">Times New Roman</option>
              <option value="Courier New">Courier New</option>
              <option value="Verdana">Verdana</option>
              <option value="Georgia">Georgia</option>
              <option value="Palatino">Palatino</option>
              <option value="Garamond">Garamond</option>
              <option value="Bookman">Bookman</option>
              <option value="Trebuchet MS">Trebuchet MS</option>
            </optgroup>
            <optgroup label="Google fonts">
              ${(0, $56b863c8b6be7003$export$6874249d87f2602a).map(({ name: name, label: label })=>`<option value="${name}">${label}</option>`)}
            </optgroup>
          </select>
        </div>

        <div class="col-4 mb-3">
          <label for="fontSizeInput_${id}" class="mb-1 d-block text-truncate">Size:</label>
          <input class="form-control" type="number" min="1" value="${fontSize}" data-input="fontSize" id="fontSizeInput_${id}">
        </div>

        <div class="col-4 mb-3">
          <label for="fontWeightInput_${id}" class="mb-1 d-block text-truncate">Weight:</label>
          <select class="form-select" data-input="fontWeight" id="fontWeightInput_${id}">
            <option value="normal">Normal</option>
            <option value="bold">Bold</option>
          </select>
        </div>
      </div>

      <div class="row g-2">
        <div class="col-4 mb-3">
          <label for="shadowWidthInput_${id}" class="mb-1 d-block text-truncate">Shadow size:</label>
          <input class="form-control" type="number" min="0" max="${(0, $65136e012e05e2d7$export$62045be72fe457b4)}" value="${shadowBlur}" data-input="shadowBlur" id="shadowWidthInput_${id}">
        </div>

        <div class="col-4 mb-3">
          <label class="mb-1 d-block text-truncate" for="strokeWidthInput_${id}">Outline size:</label>
          <input class="form-control" type="number" min="0" max="${(0, $65136e012e05e2d7$export$8f089f0a062560ff)}" step="0.5" value="${strokeWidth}" data-input="strokeWidth" id="strokeWidthInput_${id}">
        </div>

        <div class="col-4 mb-3">
          <label for="textAlignInput_${id}" class="mb-1 d-block text-truncate">Text align:</label>
          <select class="form-select" data-input="textAlign" id="textAlignInput_${id}">
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
          </select>
        </div>
      </div>

      <div class="row g-2">
        <div class="col-4 mb-3">
          <label class="mb-1 d-block text-truncate" for="offsetYInput_${id}">Vertical offset:</label>
          <input class="form-control" type="number" value="${offsetY}" data-input="offsetY" id="offsetYInput_${id}">
        </div>

        <div class="col-4 mb-3">
          <label class="mb-1 d-block text-truncate" for="offsetXInput_${id}">Horizontal offset:</label>
          <input class="form-control" type="number" value="${offsetX}" data-input="offsetX" id="offsetXInput_${id}">
        </div>

        <div class="col-4 mb-3">
          <label class="mb-1 d-block text-truncate" for="textRotateInput_${id}">Rotate:</label>
          <input class="form-control" type="number" value="${rotate}" data-input="rotate" id="textRotateInput_${id}" min="-360" max="${(0, $65136e012e05e2d7$export$d3f4819a57998cf7)}">
        </div>

        <div class="col-12">
          <div class="move-text-actions mb-3">
            <button type="button" class="btn btn-secondary" data-action="move-text" aria-label="Up"></button>
            <button type="button" class="btn btn-secondary" data-action="move-text" aria-label="Right"></button>
            <button type="button" class="btn btn-secondary" data-action="move-text" aria-label="Down"></button>
            <button type="button" class="btn btn-secondary" data-action="move-text" aria-label="Left"></button>
          </div>
        </div>
      </div>

      <div class="row g-2">
        <div class="col-12">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="allCapsCheckbox_${id}" data-input="allCaps">
            <label class="form-check-label" for="allCapsCheckbox_${id}">ALL CAPS</label>
          </div>
        </div>
      </div>

      <div class="row g-2">
        <div class="col-12">
          <div class="d-flex align-items-center gap-3">
            <div class="form-check">
              <label class="form-check-label" for="textBackgroundEnabledInput_${id}">Enable text background</label>
              <input class="form-check-input" type="checkbox" role="switch" data-input="textBackgroundEnabled" id="textBackgroundEnabledInput_${id}">
            </div>

            <div>
              <label class="visually-hidden" for="textBackgroundColorInput_${id}">Background color:</label>
              <input class="border rounded p-0" type="color" value="${textBackgroundColor}" data-input="textBackgroundColor" id="textBackgroundColorInput_${id}">
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
        const fragment = document.createDocumentFragment();
        const div = document.createElement('div');
        div.setAttribute('id', id);
        div.setAttribute('data-section', 'textbox');
        div.className = 'bg-body-tertiary border shadow-sm mb-3 rounded';
        div.innerHTML = template;
        div.querySelectorAll('select').forEach((el)=>el.value = data[el.dataset.input]);
        div.querySelectorAll('input[type="checkbox"]').forEach((el)=>el.checked = data[el.dataset.input]);
        const textboxEl = fragment.appendChild(div);
        if (autoFocus) setTimeout(()=>textboxEl.querySelector('[data-input="text"]').focus(), 0);
        return textboxEl;
    }
}




class $9b58d7721ff4a93e$export$8d01c972ee8b14a9 {
    #canvas = null;
    #ctx = null;
    constructor(canvasEl){
        this.#canvas = canvasEl;
        this.#ctx = this.#canvas.getContext('2d');
    }
    get width() {
        return this.#canvas.width;
    }
    set width(value) {
        this.#canvas.width = value;
    }
    get height() {
        return this.#canvas.height;
    }
    set height(value) {
        this.#canvas.height = value;
    }
    getDimensions() {
        return {
            width: this.width,
            height: this.height
        };
    }
    setDimensions({ width: width, height: height }) {
        this.width = width;
        this.height = height;
        return this;
    }
    toDataURL() {
        return this.#canvas.toDataURL();
    }
    draw(image, textboxes = new Map()) {
        if (image == null) return;
        const canvas = this.#canvas;
        const ctx = this.#ctx;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if ((0, $c38b15b964e67d8b$export$de75f46579dcf24)(image)) {
            ctx.fillStyle = image;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        } else ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
        let multiplier = 0;
        textboxes.forEach((textbox)=>{
            const { data: data } = textbox;
            multiplier += 1;
            ctx.save();
            ctx.font = `${data.fontWeight} ${data.fontSize * canvas.width / 1000}px ${data.font}`;
            ctx.textAlign = data.textAlign;
            ctx.strokeStyle = data.strokeColor;
            const xPos = canvas.width / 2;
            const shadowBlur = data.shadowBlur;
            const text = data.allCaps === true ? data.text.toUpperCase() : data.text;
            const textLines = text.split('\n').filter((line)=>line.trim() !== '');
            const textMetrics = ctx.measureText(textLines[0]);
            const textHeight = textMetrics.actualBoundingBoxAscent + textMetrics.actualBoundingBoxDescent;
            const bgOffset = data.textBackgroundEnabled ? textHeight / 4 : 0;
            const lineHeight = textHeight + data.fontSize / 4 + bgOffset;
            ctx.translate(xPos + data.offsetX, lineHeight * multiplier + data.offsetY);
            ctx.rotate(Math.min(data.rotate, (0, $65136e012e05e2d7$export$d3f4819a57998cf7)) * Math.PI / 180);
            if (data.textBackgroundEnabled) {
                ctx.fillStyle = data.textBackgroundColor;
                textLines.forEach((line, index)=>{
                    if (line) {
                        const textMetrics = ctx.measureText(line);
                        const textWidth = textMetrics.width;
                        const textHeight = textMetrics.actualBoundingBoxAscent + textMetrics.actualBoundingBoxDescent;
                        const xOffset = data.textAlign === 'left' ? 0 : data.textAlign === 'right' ? -textWidth : -textWidth / 2;
                        ctx.fillRect(xOffset - bgOffset, index * lineHeight - textHeight - bgOffset, textWidth + bgOffset * 2, textHeight + bgOffset * 2);
                    }
                });
            }
            ctx.save();
            if (shadowBlur !== 0) {
                ctx.shadowOffsetX = 0;
                ctx.shadowOffsetY = 0;
                ctx.shadowBlur = Math.min(shadowBlur, (0, $65136e012e05e2d7$export$62045be72fe457b4));
                ctx.shadowColor = data.strokeColor;
            }
            ctx.fillStyle = data.fillColor;
            textLines.forEach((text, index)=>ctx.fillText(text, 0, index * lineHeight));
            ctx.restore();
            if (data.strokeWidth > 0) {
                ctx.lineWidth = Math.min(data.strokeWidth, (0, $65136e012e05e2d7$export$8f089f0a062560ff));
                textLines.forEach((text, index)=>ctx.strokeText(text, 0, index * lineHeight));
            }
            ctx.restore();
        });
        return this;
    }
    clear() {
        this.#ctx.clearRect(0, 0, this.#canvas.width, this.#canvas.height);
        return this;
    }
    show() {
        this.#canvas.hidden = false;
        return this;
    }
    hide() {
        this.#canvas.hidden = true;
        return this;
    }
    static createInstance(canvasEl) {
        return new $9b58d7721ff4a93e$export$8d01c972ee8b14a9(canvasEl);
    }
}


const $85a5f86b715fe7db$var$canvas = (0, $9b58d7721ff4a93e$export$8d01c972ee8b14a9).createInstance(document.getElementById('canvas'));
const $85a5f86b715fe7db$var$videoModal = document.getElementById('videoModal');
const $85a5f86b715fe7db$var$downloadModal = document.getElementById('downloadModal');
const $85a5f86b715fe7db$var$capturePhotoEl = document.querySelector('capture-photo');
const $85a5f86b715fe7db$var$cameraSelect = document.getElementById('cameraSelect');
const $85a5f86b715fe7db$var$capturePhotoButton = document.getElementById('capturePhotoButton');
const $85a5f86b715fe7db$var$torchButton = document.getElementById('torchButton');
const $85a5f86b715fe7db$var$dropzoneEl = document.querySelector('files-dropzone');
const $85a5f86b715fe7db$var$instructionsEl = document.getElementById('instructions');
const $85a5f86b715fe7db$var$imageUploadMethodSelect = document.getElementById('imageUploadMethodSelect');
const $85a5f86b715fe7db$var$fileSelectBtn = document.getElementById('fileSelectBtn');
const $85a5f86b715fe7db$var$imageUrlForm = document.getElementById('imageUrlForm');
const $85a5f86b715fe7db$var$addTextboxBtn = document.getElementById('addTextboxBtn');
const $85a5f86b715fe7db$var$textboxesContainer = document.getElementById('textboxesContainer');
const $85a5f86b715fe7db$var$generateMemeBtn = document.getElementById('generateMemeBtn');
const $85a5f86b715fe7db$var$openVideoModalBtn = document.getElementById('openVideoModalBtn');
const $85a5f86b715fe7db$var$downloadMemeBtn = document.getElementById('downloadMemeBtn');
const $85a5f86b715fe7db$var$downloadMemePreview = document.getElementById('downloadMemePreview');
const $85a5f86b715fe7db$var$webShareComponent = document.querySelector('web-share');
const $85a5f86b715fe7db$var$galleryEl = document.getElementById('gallery');
const $85a5f86b715fe7db$var$gallerySearchEl = document.getElementById('gallerySearch');
const $85a5f86b715fe7db$var$galleryNoResultsEl = $85a5f86b715fe7db$var$galleryEl.querySelector('.gallery__no-results');
const $85a5f86b715fe7db$var$solidColorForm = document.getElementById('solidColorForm');
const $85a5f86b715fe7db$var$uploadMethodEls = document.querySelectorAll('.upload-method');
const $85a5f86b715fe7db$var$removeConfirmationModal = document.getElementById('removeConfirmationModal');
const $85a5f86b715fe7db$var$removeTextForm = document.getElementById('removeTextForm');
const $85a5f86b715fe7db$var$maxImageDimensionsForm = document.getElementById('maxImageDimensionsForm');
const $85a5f86b715fe7db$var$maxImageDimensionsSelect = $85a5f86b715fe7db$var$maxImageDimensionsForm['maxImageDimensions'];
const $85a5f86b715fe7db$var$clearCanvasBtn = document.getElementById('clearCanvasBtn');
const $85a5f86b715fe7db$var$maxImageDimensionsFromStorage = (0, $9e093dbdf49c6d51$export$ddcffe0146c8f882).get('maxImageDimensions');
let $85a5f86b715fe7db$var$shouldFocusOnTextboxCreate = false;
let $85a5f86b715fe7db$var$selectedImage = null;
let $85a5f86b715fe7db$var$reqAnimFrame = null;
const $85a5f86b715fe7db$var$renderAcceptedImageFormats = (acceptedMimeTypes, rootEl)=>{
    if (!rootEl) return;
    const extensions = acceptedMimeTypes.map((mimeType)=>mimeType.split('/')[1]);
    const str = `Supported image formats: ${extensions.join(', ')}`;
    const div = document.createElement('div');
    const small = document.createElement('small');
    small.textContent = str;
    div.appendChild(small);
    rootEl.appendChild(small);
};
const $85a5f86b715fe7db$var$generateMeme = async ()=>{
    const originalCanvasEl = document.getElementById('canvas');
    const width = originalCanvasEl.width;
    const height = originalCanvasEl.height;
    if (width === 0 || height === 0) {
        (0, $3969451ff60cb8d5$export$af04143326425dbd)('Please select an image or solid color first.', 'warning');
        return;
    }
    const tempCanvas = document.createElement('canvas');
    const ctx = tempCanvas.getContext('2d');
    tempCanvas.width = width;
    tempCanvas.height = height;
    ctx.drawImage(originalCanvasEl, 0, 0);
    const watermarkText = "\xa9 https://fuko.meme";
    const x = 10;
    const y = height - 4;
    ctx.font = '12px Arial';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'bottom';
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.5)';
    ctx.lineWidth = 2;
    ctx.strokeText(watermarkText, x, y);
    ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
    ctx.lineWidth = 2;
    ctx.fillText(watermarkText, x, y);
    const dataUrl = tempCanvas.toDataURL('image/png');
    const filename = `${(0, $17004b28c97c1306$export$e2a22331486dcca0)('meme')}.png`;
    $85a5f86b715fe7db$var$downloadMemeBtn.download = filename;
    $85a5f86b715fe7db$var$downloadMemeBtn.href = dataUrl;
    $85a5f86b715fe7db$var$downloadMemePreview.src = dataUrl;
    $85a5f86b715fe7db$var$downloadMemePreview.width = width;
    $85a5f86b715fe7db$var$downloadMemePreview.height = height;
    if ((0, $7a2aca835bb05064$export$c37129e465f64ef0)()) try {
        const file = await (0, $2669cb7c28251d2a$export$6539e087749cf9d3)({
            url: dataUrl,
            filename: filename,
            mimeType: 'image/png'
        });
        if (file && (0, $7a2aca835bb05064$export$c37129e465f64ef0)({
            files: [
                file
            ]
        })) {
            $85a5f86b715fe7db$var$webShareComponent.shareFiles = [
                file
            ];
            $85a5f86b715fe7db$var$webShareComponent.hidden = false;
        }
    } catch (err) {
        (0, $3969451ff60cb8d5$export$af04143326425dbd)(err.message, 'danger');
    }
    window.requestAnimationFrame(()=>{
        $85a5f86b715fe7db$var$downloadModal.open = true;
    });
};
const $85a5f86b715fe7db$var$setImageMaxDimensions = (image)=>{
    const maxImageDimensionsSelect = $85a5f86b715fe7db$var$maxImageDimensionsForm['maxImageDimensions'];
    const [maxWidthValue, maxHeightValue] = maxImageDimensionsSelect.value.split('x');
    const MAX_WIDTH = Number(maxWidthValue) || 800;
    const MAX_HEIGHT = Number(maxHeightValue) || 600;
    let width = image.width;
    let height = image.height;
    if (width > height) {
        if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
        }
    } else if (height > MAX_HEIGHT) {
        width *= MAX_HEIGHT / height;
        height = MAX_HEIGHT;
    }
    $85a5f86b715fe7db$var$canvas.setDimensions({
        width: width,
        height: height
    });
};
const $85a5f86b715fe7db$var$afterImageSelect = ()=>{
    $85a5f86b715fe7db$var$canvas.draw($85a5f86b715fe7db$var$selectedImage, (0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).getAll()).show();
    $85a5f86b715fe7db$var$dropzoneEl.classList.add('dropzone--accepted');
    $85a5f86b715fe7db$var$dropzoneEl.disabled = true;
    $85a5f86b715fe7db$var$generateMemeBtn.disabled = false;
    $85a5f86b715fe7db$var$instructionsEl.hidden = true;
    $85a5f86b715fe7db$var$clearCanvasBtn.hidden = false;
};
const $85a5f86b715fe7db$var$handleImageLoad = (evt)=>{
    $85a5f86b715fe7db$var$selectedImage = evt.target;
    $85a5f86b715fe7db$var$setImageMaxDimensions($85a5f86b715fe7db$var$selectedImage);
    $85a5f86b715fe7db$var$afterImageSelect();
};
const $85a5f86b715fe7db$var$handleSolidColorFormInput = (evt)=>{
    const DEFAULT_WIDTH = 800;
    const DEFAULT_HEIGHT = 600;
    if (evt.target === $85a5f86b715fe7db$var$solidColorForm['canvasColor']) $85a5f86b715fe7db$var$selectedImage = evt.target.value;
    if ((0, $c38b15b964e67d8b$export$de75f46579dcf24)($85a5f86b715fe7db$var$selectedImage)) {
        $85a5f86b715fe7db$var$canvas.setDimensions({
            width: Number($85a5f86b715fe7db$var$solidColorForm['canvasWidth'].value) || DEFAULT_WIDTH,
            height: Number($85a5f86b715fe7db$var$solidColorForm['canvasHeight'].value) || DEFAULT_HEIGHT
        });
        $85a5f86b715fe7db$var$afterImageSelect();
    }
};
const $85a5f86b715fe7db$var$handleFileSelect = (file)=>{
    if (!file) return;
    const image = new Image();
    const reader = new FileReader();
    reader.addEventListener('load', function(evt) {
        const data = evt.target.result;
        image.addEventListener('load', $85a5f86b715fe7db$var$handleImageLoad);
        image.src = data;
    });
    reader.readAsDataURL(file);
};
const $85a5f86b715fe7db$var$handleOpenVideoModalButtonClick = ()=>{
    $85a5f86b715fe7db$var$videoModal.open = true;
};
const $85a5f86b715fe7db$var$handleTextPropChange = (element, textboxId, prop)=>{
    const textboxData = (0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).getById(textboxId).getData();
    switch(element.type){
        case 'checkbox':
            textboxData[prop] = element.checked;
            break;
        case 'number':
            textboxData[prop] = Number(element.value);
            break;
        default:
            textboxData[prop] = element.value;
    }
    $85a5f86b715fe7db$var$canvas.draw($85a5f86b715fe7db$var$selectedImage, (0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).getAll());
};
const $85a5f86b715fe7db$var$handleAddTextboxBtnClick = ()=>(0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).create();
const $85a5f86b715fe7db$var$handleImageUploadFromURL = async (evt)=>{
    evt.preventDefault();
    const form = evt.target;
    const submitButton = form.querySelector('button[type="submit"]');
    const imageUrl = form['imageUrl'].value;
    if (!imageUrl.trim()) return;
    submitButton.disabled = true;
    submitButton.querySelector('.spinner').hidden = false;
    submitButton.querySelector('.label').hidden = true;
    try {
        const file = await (0, $2669cb7c28251d2a$export$6539e087749cf9d3)({
            url: imageUrl
        }).catch((err)=>(0, $3969451ff60cb8d5$export$af04143326425dbd)(err.message, 'danger'));
        if (file) $85a5f86b715fe7db$var$handleFileSelect(file);
    } catch  {
        (0, $3969451ff60cb8d5$export$af04143326425dbd)(`Failed to load image from "${imageUrl}".`, 'danger');
    } finally{
        submitButton.disabled = false;
        submitButton.querySelector('.spinner').hidden = true;
        submitButton.querySelector('.label').hidden = false;
    }
};
const $85a5f86b715fe7db$var$moveTextUsingArrowbuttons = (textboxId, direction)=>()=>{
        const textboxEl = document.getElementById(textboxId);
        const offsetYInput = textboxEl.querySelector('[data-input="offsetY"]');
        const offsetXInput = textboxEl.querySelector('[data-input="offsetX"]');
        const textbox = (0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).getById(textboxId);
        if (!textbox) return;
        const textboxData = textbox.getData();
        direction = direction.toLowerCase();
        switch(direction){
            case 'up':
                textboxData.offsetY -= 1;
                offsetYInput.value = textboxData.offsetY;
                break;
            case 'down':
                textboxData.offsetY += 1;
                offsetYInput.value = textboxData.offsetY;
                break;
            case 'left':
                textboxData.offsetX -= 1;
                offsetXInput.value = textboxData.offsetX;
                break;
            case 'right':
                textboxData.offsetX += 1;
                offsetXInput.value = textboxData.offsetX;
                break;
        }
        $85a5f86b715fe7db$var$canvas.draw($85a5f86b715fe7db$var$selectedImage, (0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).getAll());
        $85a5f86b715fe7db$var$reqAnimFrame = requestAnimationFrame($85a5f86b715fe7db$var$moveTextUsingArrowbuttons(textboxId, direction));
    };
const $85a5f86b715fe7db$var$handleUploadMethodChange = (evt)=>{
    $85a5f86b715fe7db$var$uploadMethodEls.forEach((el)=>el.hidden = el.id !== evt.target.value);
    $85a5f86b715fe7db$var$maxImageDimensionsForm.hidden = evt.target.value === 'solidColorForm';
};
const $85a5f86b715fe7db$var$handleFileSelectClick = ()=>{
    if (typeof $85a5f86b715fe7db$var$dropzoneEl.openFileDialog === 'function') {
        $85a5f86b715fe7db$var$dropzoneEl.disabled = false;
        $85a5f86b715fe7db$var$dropzoneEl.openFileDialog();
    }
};
const $85a5f86b715fe7db$var$handleDropFilesAccepted = (evt)=>{
    const [file] = evt.detail.acceptedFiles;
    if (file) $85a5f86b715fe7db$var$handleFileSelect(file);
};
const $85a5f86b715fe7db$var$handleTextboxesContainerInput = (evt)=>{
    const inputMap = {
        text: 'text',
        fillColor: 'fillColor',
        strokeColor: 'strokeColor',
        font: 'font',
        fontSize: 'fontSize',
        fontWeight: 'fontWeight',
        textAlign: 'textAlign',
        shadowBlur: 'shadowBlur',
        offsetY: 'offsetY',
        offsetX: 'offsetX',
        rotate: 'rotate',
        strokeWidth: 'strokeWidth',
        textBackgroundEnabled: 'textBackgroundEnabled',
        textBackgroundColor: 'textBackgroundColor'
    };
    const element = evt.target;
    const prop = inputMap[element.dataset.input];
    if (!prop) return;
    const textboxId = element.closest('[data-section="textbox"]').id;
    $85a5f86b715fe7db$var$handleTextPropChange(element, textboxId, prop);
};
const $85a5f86b715fe7db$var$handleTextboxesContainerChange = (evt)=>{
    const element = evt.target;
    const textboxId = element.closest('[data-section="textbox"]').id;
    let prop;
    if (element.matches('[data-input="allCaps"]')) prop = 'allCaps';
    if (prop) $85a5f86b715fe7db$var$handleTextPropChange(element, textboxId, prop);
};
const $85a5f86b715fe7db$var$handleTextboxesContainerClick = (evt)=>{
    const element = evt.target;
    if (element.matches('[data-button="settings"]')) {
        const textboxEl = element.closest('[data-section="textbox"]');
        const textboxSettingsEl = textboxEl?.querySelector('[data-section="advanced-settings"]');
        if (textboxSettingsEl) textboxSettingsEl.hidden = !textboxSettingsEl.hidden;
    }
    if (element.matches('[data-button="duplicate-text-box"')) {
        const currentTextboxEl = element.closest('[data-section="textbox"]');
        const currentTextboxData = (0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).getById(currentTextboxEl.id);
        (0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).create({
            ...currentTextboxData.data
        });
    }
    if (element.matches('[data-button="delete-text-box"]')) {
        const textboxId = element.closest('[data-section="textbox"]').id;
        const textboxToDelete = (0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).getById(textboxId);
        if (textboxToDelete && textboxToDelete.data.text.trim()) {
            const textboxIdInput = $85a5f86b715fe7db$var$removeTextForm['textbox-id'];
            if (textboxIdInput) {
                textboxIdInput.value = textboxId;
                $85a5f86b715fe7db$var$removeConfirmationModal.open = true;
            }
        } else (0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).remove(textboxId);
    }
};
const $85a5f86b715fe7db$var$handleTextRemoveFormSubmit = (evt)=>{
    evt.preventDefault();
    const textboxId = evt.target['textbox-id'].value;
    if (textboxId) {
        (0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).remove(textboxId);
        $85a5f86b715fe7db$var$removeConfirmationModal.open = false;
    }
};
const $85a5f86b715fe7db$var$handleTextboxesContainerPointerdown = (evt)=>{
    const element = evt.target;
    const textboxEl = element.closest('[data-section="textbox"]');
    if (!textboxEl) return;
    if (element.matches('[data-action="move-text"]')) $85a5f86b715fe7db$var$reqAnimFrame = requestAnimationFrame($85a5f86b715fe7db$var$moveTextUsingArrowbuttons(textboxEl.id, element.getAttribute('aria-label')));
};
const $85a5f86b715fe7db$var$handleTextboxesContainerPointerup = (evt)=>{
    const element = evt.target;
    if (element.matches('[data-action="move-text"]')) {
        cancelAnimationFrame && cancelAnimationFrame($85a5f86b715fe7db$var$reqAnimFrame);
        $85a5f86b715fe7db$var$reqAnimFrame = null;
    }
};
const $85a5f86b715fe7db$var$handleTextboxesContainerPointerout = (evt)=>{
    const element = evt.target;
    if (element.matches('[data-action="move-text"]')) {
        cancelAnimationFrame && cancelAnimationFrame($85a5f86b715fe7db$var$reqAnimFrame);
        $85a5f86b715fe7db$var$reqAnimFrame = null;
    }
};
const $85a5f86b715fe7db$var$handleTextboxesContainerKeyDown = (evt)=>{
    const element = evt.target;
    const textboxEl = element.closest('[data-section="textbox"]');
    if (element.matches('[data-action="move-text"]')) {
        if (evt.key === ' ' || evt.key === 'Enter') {
            $85a5f86b715fe7db$var$reqAnimFrame && cancelAnimationFrame($85a5f86b715fe7db$var$reqAnimFrame);
            $85a5f86b715fe7db$var$reqAnimFrame = requestAnimationFrame($85a5f86b715fe7db$var$moveTextUsingArrowbuttons(textboxEl.id, element.getAttribute('aria-label')));
        }
    }
};
const $85a5f86b715fe7db$var$handleTextboxesContainerKeyUp = (evt)=>{
    const element = evt.target;
    if (element.matches('[data-action="move-text"]')) {
        if (evt.key === ' ' || evt.key === 'Enter') {
            $85a5f86b715fe7db$var$reqAnimFrame && cancelAnimationFrame($85a5f86b715fe7db$var$reqAnimFrame);
            $85a5f86b715fe7db$var$reqAnimFrame = null;
        }
    }
};
const $85a5f86b715fe7db$var$handleGalleryClick = async (evt)=>{
    const button = evt.target.closest('button');
    if (!button) return;
    const img = button.querySelector('img');
    try {
        const file = await (0, $2669cb7c28251d2a$export$6539e087749cf9d3)({
            url: img.src
        }).catch((err)=>(0, $3969451ff60cb8d5$export$af04143326425dbd)(err.message, 'danger'));
        if (file) $85a5f86b715fe7db$var$handleFileSelect(file);
    } catch  {
        (0, $3969451ff60cb8d5$export$af04143326425dbd)(`Failed to load image: "${img.alt}".`, 'danger');
    }
};
const $85a5f86b715fe7db$var$handleGallerySearchInput = (evt)=>{
    const query = evt.target.value.toLowerCase().trim();
    const galleryItems = $85a5f86b715fe7db$var$galleryEl.querySelectorAll('button');
    galleryItems.forEach((item)=>{
        const alt = (item.querySelector('img').getAttribute('alt') || '').toLowerCase();
        item.hidden = !alt.includes(query);
    });
    $85a5f86b715fe7db$var$galleryNoResultsEl.hidden = !!$85a5f86b715fe7db$var$galleryEl.querySelector('button:not([hidden])');
};
const $85a5f86b715fe7db$var$handleWebShareError = ()=>{
    $85a5f86b715fe7db$var$downloadModal.open = false;
    (0, $3969451ff60cb8d5$export$af04143326425dbd)('There was an error while trying to share your meme.', 'danger');
};
const $85a5f86b715fe7db$var$handleCapturePhotoError = (evt)=>{
    const error = evt.detail.error;
    let errorMessage = 'An error occurred while trying to capture photo.';
    if (error instanceof Error && (error.name === 'NotAllowedError' || error.name === 'NotFoundError')) errorMessage += ' Make sure you have a camera connected and you have granted the appropriate permissions.';
    (0, $3969451ff60cb8d5$export$af04143326425dbd)(errorMessage, 'danger');
    $85a5f86b715fe7db$var$videoModal.open = false;
    console.error(error);
};
const $85a5f86b715fe7db$var$handleCapturePhotoSuccess = (evt)=>{
    $85a5f86b715fe7db$var$videoModal.open = false;
    const image = new Image();
    image.addEventListener('load', $85a5f86b715fe7db$var$handleImageLoad);
    image.src = evt.detail.dataURI;
};
const $85a5f86b715fe7db$var$handleModalOpen = (evt)=>{
    if (evt.target.id === 'videoModal') {
        if ($85a5f86b715fe7db$var$capturePhotoEl && typeof $85a5f86b715fe7db$var$capturePhotoEl.startVideoStream === 'function') $85a5f86b715fe7db$var$capturePhotoEl.startVideoStream();
    }
};
const $85a5f86b715fe7db$var$handleModalClose = (evt)=>{
    if (evt.target.id === 'videoModal') {
        if ($85a5f86b715fe7db$var$capturePhotoEl && typeof $85a5f86b715fe7db$var$capturePhotoEl.stopVideoStream === 'function') $85a5f86b715fe7db$var$capturePhotoEl.stopVideoStream();
    }
    if (evt.target.id === 'removeConfirmationModal') $85a5f86b715fe7db$var$removeTextForm.reset();
};
const $85a5f86b715fe7db$var$handleEmojiPickerSelection = (evt)=>{
    const textboxEl = evt.target.closest('[data-section="textbox"]');
    if (textboxEl) {
        const input = textboxEl.querySelector('[data-input="text"]');
        const emoji = evt.detail.unicode;
        if (input) (0, $bf4f0cf05f6fd378$export$2e2bcd8739ae039)(input, emoji);
    }
};
const $85a5f86b715fe7db$var$handleMaxImageDimensionsFormChange = (evt)=>{
    if (evt.target.matches('[name="maxImageDimensions"]')) (0, $9e093dbdf49c6d51$export$ddcffe0146c8f882).set('maxImageDimensions', evt.target.value);
    if (!$85a5f86b715fe7db$var$selectedImage || (0, $c38b15b964e67d8b$export$de75f46579dcf24)($85a5f86b715fe7db$var$selectedImage)) return;
    $85a5f86b715fe7db$var$setImageMaxDimensions($85a5f86b715fe7db$var$selectedImage);
    $85a5f86b715fe7db$var$canvas.draw($85a5f86b715fe7db$var$selectedImage, (0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).getAll());
};
const $85a5f86b715fe7db$var$handleTextboxCreate = (evt)=>{
    const textbox = evt.detail.textbox;
    const textboxEl = (0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).createElement(textbox, $85a5f86b715fe7db$var$shouldFocusOnTextboxCreate);
    $85a5f86b715fe7db$var$shouldFocusOnTextboxCreate = true;
    $85a5f86b715fe7db$var$textboxesContainer.appendChild(textboxEl);
    if (textbox.getData().text) $85a5f86b715fe7db$var$canvas.draw($85a5f86b715fe7db$var$selectedImage, (0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).getAll());
};
const $85a5f86b715fe7db$var$handleTextboxDelete = (evt)=>{
    const textboxEl = document.getElementById(evt.detail.id);
    textboxEl && textboxEl.remove();
    $85a5f86b715fe7db$var$textboxesContainer.querySelectorAll('[data-section="textbox"]').forEach((el, idx)=>{
        el.querySelector('[data-input="text"]').setAttribute('placeholder', `Text #${idx + 1}`);
    });
    $85a5f86b715fe7db$var$canvas.draw($85a5f86b715fe7db$var$selectedImage, (0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).getAll());
};
const $85a5f86b715fe7db$var$handleClearCanvas = (evt)=>{
    if (!$85a5f86b715fe7db$var$selectedImage) return;
    evt.stopPropagation();
    $85a5f86b715fe7db$var$selectedImage = null;
    $85a5f86b715fe7db$var$dropzoneEl.classList.remove('dropzone--accepted');
    $85a5f86b715fe7db$var$generateMemeBtn.disabled = true;
    $85a5f86b715fe7db$var$instructionsEl.hidden = false;
    $85a5f86b715fe7db$var$clearCanvasBtn.hidden = true;
    $85a5f86b715fe7db$var$dropzoneEl.disabled = false;
    $85a5f86b715fe7db$var$canvas.clear().hide();
};
const $85a5f86b715fe7db$var$toggleTorchButtonStatus = (options = {})=>{
    const defaults = {
        el: document.getElementById('torchButton'),
        isTorchOn: false
    };
    const { el: el, isTorchOn: isTorchOn } = {
        ...defaults,
        ...options
    };
    const iconPaths = el.querySelectorAll('svg path');
    if (iconPaths.length !== 2) return;
    iconPaths[0].style.display = isTorchOn ? 'none' : 'block';
    iconPaths[1].style.display = isTorchOn ? 'block' : 'none';
    el.setAttribute('aria-label', `Turn ${isTorchOn ? 'off' : 'on'} flash`);
};
const $85a5f86b715fe7db$var$handleTorchButtonClick = (evt)=>{
    if ($85a5f86b715fe7db$var$capturePhotoEl === null) return;
    $85a5f86b715fe7db$var$capturePhotoEl.torch = !$85a5f86b715fe7db$var$capturePhotoEl.torch;
    $85a5f86b715fe7db$var$toggleTorchButtonStatus({
        el: evt.currentTarget,
        isTorchOn: $85a5f86b715fe7db$var$capturePhotoEl.hasAttribute('torch')
    });
};
const $85a5f86b715fe7db$var$handleCapturePhotoVideoPlay = async (evt)=>{
    const trackCapabilities = evt.target.getTrackCapabilities();
    if (trackCapabilities?.torch) {
        $85a5f86b715fe7db$var$torchButton?.removeAttribute('hidden');
        if ($85a5f86b715fe7db$var$capturePhotoEl?.hasAttribute('torch')) $85a5f86b715fe7db$var$toggleTorchButtonStatus({
            el: $85a5f86b715fe7db$var$torchButton,
            isTorchOn: true
        });
    }
    const videoInputDevices = await (0, $dced0d224c6d876e$export$cc30a98fe3890794).getVideoInputDevices();
    videoInputDevices.forEach((device, index)=>{
        const option = document.createElement('option');
        option.value = device.deviceId;
        option.textContent = device.label || `Camera ${index + 1}`;
        $85a5f86b715fe7db$var$cameraSelect.appendChild(option);
    });
    if (videoInputDevices.length > 1) $85a5f86b715fe7db$var$cameraSelect?.removeAttribute('hidden');
};
const $85a5f86b715fe7db$var$handleCameraSelectChange = (evt)=>{
    if ($85a5f86b715fe7db$var$capturePhotoEl === null || typeof $85a5f86b715fe7db$var$capturePhotoEl.restartVideoStream !== 'function' || $85a5f86b715fe7db$var$capturePhotoEl.hasAttribute('loading')) return;
    const videoDeviceId = evt.target.value || undefined;
    $85a5f86b715fe7db$var$capturePhotoEl.restartVideoStream(videoDeviceId);
};
const $85a5f86b715fe7db$var$handleCapturePhotoButtonClick = ()=>{
    if ($85a5f86b715fe7db$var$capturePhotoEl === null || typeof $85a5f86b715fe7db$var$capturePhotoEl.capture !== 'function' || $85a5f86b715fe7db$var$capturePhotoEl.hasAttribute('loading')) return;
    $85a5f86b715fe7db$var$capturePhotoEl.capture();
};
const $85a5f86b715fe7db$var$handlethemeChange = (evt)=>{
    const theme = evt.detail.theme;
    const deviceTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    document.documentElement.setAttribute('data-bs-theme', theme === 'system' ? deviceTheme : theme);
};
document.addEventListener('tt-theme-change', $85a5f86b715fe7db$var$handlethemeChange);
document.addEventListener('web-share:error', $85a5f86b715fe7db$var$handleWebShareError);
document.addEventListener('capture-photo:video-play', $85a5f86b715fe7db$var$handleCapturePhotoVideoPlay, {
    once: true
});
document.addEventListener('capture-photo:error', $85a5f86b715fe7db$var$handleCapturePhotoError);
document.addEventListener('capture-photo:success', $85a5f86b715fe7db$var$handleCapturePhotoSuccess);
document.addEventListener('me-open', $85a5f86b715fe7db$var$handleModalOpen);
document.addEventListener('me-close', $85a5f86b715fe7db$var$handleModalClose);
document.addEventListener('emoji-click', $85a5f86b715fe7db$var$handleEmojiPickerSelection);
document.addEventListener('textbox-create', $85a5f86b715fe7db$var$handleTextboxCreate);
document.addEventListener('textbox-remove', $85a5f86b715fe7db$var$handleTextboxDelete);
$85a5f86b715fe7db$var$fileSelectBtn.addEventListener('click', $85a5f86b715fe7db$var$handleFileSelectClick);
$85a5f86b715fe7db$var$openVideoModalBtn.addEventListener('click', $85a5f86b715fe7db$var$handleOpenVideoModalButtonClick);
$85a5f86b715fe7db$var$addTextboxBtn.addEventListener('click', $85a5f86b715fe7db$var$handleAddTextboxBtnClick);
$85a5f86b715fe7db$var$generateMemeBtn.addEventListener('click', $85a5f86b715fe7db$var$generateMeme);
$85a5f86b715fe7db$var$downloadMemeBtn.addEventListener('click', ()=>$85a5f86b715fe7db$var$downloadModal.open = false);
$85a5f86b715fe7db$var$imageUrlForm.addEventListener('submit', $85a5f86b715fe7db$var$handleImageUploadFromURL);
$85a5f86b715fe7db$var$dropzoneEl.addEventListener('files-dropzone-drop-accepted', $85a5f86b715fe7db$var$handleDropFilesAccepted);
$85a5f86b715fe7db$var$textboxesContainer.addEventListener('input', $85a5f86b715fe7db$var$handleTextboxesContainerInput);
$85a5f86b715fe7db$var$textboxesContainer.addEventListener('change', $85a5f86b715fe7db$var$handleTextboxesContainerChange);
$85a5f86b715fe7db$var$textboxesContainer.addEventListener('click', $85a5f86b715fe7db$var$handleTextboxesContainerClick);
$85a5f86b715fe7db$var$textboxesContainer.addEventListener('pointerdown', $85a5f86b715fe7db$var$handleTextboxesContainerPointerdown);
$85a5f86b715fe7db$var$textboxesContainer.addEventListener('pointerup', $85a5f86b715fe7db$var$handleTextboxesContainerPointerup);
$85a5f86b715fe7db$var$textboxesContainer.addEventListener('pointerout', $85a5f86b715fe7db$var$handleTextboxesContainerPointerout);
$85a5f86b715fe7db$var$textboxesContainer.addEventListener('keydown', $85a5f86b715fe7db$var$handleTextboxesContainerKeyDown);
$85a5f86b715fe7db$var$textboxesContainer.addEventListener('keyup', $85a5f86b715fe7db$var$handleTextboxesContainerKeyUp);
$85a5f86b715fe7db$var$imageUploadMethodSelect.addEventListener('change', $85a5f86b715fe7db$var$handleUploadMethodChange);
$85a5f86b715fe7db$var$galleryEl.addEventListener('click', $85a5f86b715fe7db$var$handleGalleryClick);
$85a5f86b715fe7db$var$gallerySearchEl.addEventListener('input', $85a5f86b715fe7db$var$handleGallerySearchInput);
$85a5f86b715fe7db$var$solidColorForm.addEventListener('input', $85a5f86b715fe7db$var$handleSolidColorFormInput);
$85a5f86b715fe7db$var$removeTextForm.addEventListener('submit', $85a5f86b715fe7db$var$handleTextRemoveFormSubmit);
$85a5f86b715fe7db$var$maxImageDimensionsForm.addEventListener('change', $85a5f86b715fe7db$var$handleMaxImageDimensionsFormChange);
$85a5f86b715fe7db$var$clearCanvasBtn.addEventListener('click', $85a5f86b715fe7db$var$handleClearCanvas);
$85a5f86b715fe7db$var$cameraSelect.addEventListener('change', $85a5f86b715fe7db$var$handleCameraSelectChange);
$85a5f86b715fe7db$var$capturePhotoButton.addEventListener('click', $85a5f86b715fe7db$var$handleCapturePhotoButtonClick);
$85a5f86b715fe7db$var$torchButton.addEventListener('click', $85a5f86b715fe7db$var$handleTorchButtonClick);
$85a5f86b715fe7db$var$galleryEl.querySelectorAll('button > img')?.forEach((image)=>{
    image.setAttribute('title', image.getAttribute('alt'));
});
(0, $a5e4a78f80aa8693$export$8e3dca5fa4d5f04b).create();
$85a5f86b715fe7db$var$dropzoneEl.accept = (0, $65136e012e05e2d7$export$63e7bed68b07a85c);
$85a5f86b715fe7db$var$renderAcceptedImageFormats((0, $65136e012e05e2d7$export$63e7bed68b07a85c), $85a5f86b715fe7db$var$instructionsEl);
(0, $56b863c8b6be7003$export$6874249d87f2602a).forEach(({ name: name, path: path, style: style, weight: weight })=>{
    (0, $56b863c8b6be7003$export$59eceaef0c7797b2)(name, path, {
        style: style,
        weight: weight
    });
});
if ($85a5f86b715fe7db$var$maxImageDimensionsFromStorage) $85a5f86b715fe7db$var$maxImageDimensionsSelect.value = $85a5f86b715fe7db$var$maxImageDimensionsFromStorage;
$85a5f86b715fe7db$var$maxImageDimensionsSelect.disabled = false;


//# sourceMappingURL=fuko.fb145fcf.js.map
